import React from "react";
// ============= Dashboard Icons ================== //
export function RoundedDollar() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
    >
      <g clip-path="url(#clip0_1643_20025)">
        <rect x="0.424805" width="48" height="48" rx="24" fill="#FFF5E9" />
        <path
          d="M25.4002 29.42H22.8902C21.2502 29.42 19.9202 28.04 19.9202 26.34C19.9202 25.93 20.2602 25.59 20.6702 25.59C21.0802 25.59 21.4202 25.93 21.4202 26.34C21.4202 27.21 22.0802 27.92 22.8902 27.92H25.4002C26.0502 27.92 26.5902 27.34 26.5902 26.64C26.5902 25.77 26.2802 25.6 25.7702 25.42L21.7402 24C20.9602 23.73 19.9102 23.15 19.9102 21.36C19.9102 19.82 21.1202 18.58 22.6002 18.58H25.1102C26.7502 18.58 28.0802 19.96 28.0802 21.66C28.0802 22.07 27.7402 22.41 27.3302 22.41C26.9202 22.41 26.5802 22.07 26.5802 21.66C26.5802 20.79 25.9202 20.08 25.1102 20.08H22.6002C21.9502 20.08 21.4102 20.66 21.4102 21.36C21.4102 22.23 21.7202 22.4 22.2302 22.58L26.2602 24C27.0402 24.27 28.0902 24.85 28.0902 26.64C28.0802 28.17 26.8802 29.42 25.4002 29.42Z"
          fill="#FC960E"
        />
        <path
          d="M24 30.75C23.59 30.75 23.25 30.41 23.25 30V18C23.25 17.59 23.59 17.25 24 17.25C24.41 17.25 24.75 17.59 24.75 18V30C24.75 30.41 24.41 30.75 24 30.75Z"
          fill="#FC960E"
        />
        <path
          d="M24 34.75C18.07 34.75 13.25 29.93 13.25 24C13.25 18.07 18.07 13.25 24 13.25C29.93 13.25 34.75 18.07 34.75 24C34.75 29.93 29.93 34.75 24 34.75ZM24 14.75C18.9 14.75 14.75 18.9 14.75 24C14.75 29.1 18.9 33.25 24 33.25C29.1 33.25 33.25 29.1 33.25 24C33.25 18.9 29.1 14.75 24 14.75Z"
          fill="#FC960E"
        />
      </g>
      <defs>
        <clipPath id="clip0_1643_20025">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(0.424805)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
export function ThankyouImage() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="375" height="319" viewBox="0 0 375 319" fill="none">
      <g clip-path="url(#clip0_2836_149082)">
        <path d="M142.988 0C107.47 0 67.8965 23.4593 58.4191 107.151C45.0351 225.255 5.0925 253.209 42.0753 297.267C55.1403 312.834 77.8323 318.235 103.893 318.235C142.46 318.235 188.392 306.406 221.488 298.204C284.282 282.638 358.746 300.297 373.435 216.954C388.125 133.61 294.995 129.475 258.182 105.397C215.907 77.7525 224.787 30.3655 182.393 9.35781C171.53 3.97632 157.598 0 142.988 0Z" fill="#EAF1F4" />
        <path d="M65.1061 251.864C71.6635 250.648 77.0948 247.04 81.5495 241.609C79.4567 234.722 72.8594 227.717 72.8594 227.717C77.055 228.693 84.5591 226.222 90.3791 223.85C91.5052 218.429 91.1564 213.077 89.1932 207.955C86.353 210.127 83.2038 212.609 79.935 212.678C76.0982 212.768 81.9481 206.739 86.4726 202.543C82.7254 196.624 76.6065 191.112 67.9064 186.309C65.7538 192.448 62.0665 202.354 61.04 201.487C59.9637 200.58 60.183 189.169 60.3923 182.951C51.6922 179.951 41.7962 179.213 32.578 179.911C33.3154 184.306 35.1491 191.571 34.3917 195.547C33.425 200.68 27.1765 188.212 25.1236 180.798C12.4671 182.881 2.34197 187.525 0.518247 192.159C-1.23572 196.614 1.73406 205.941 7.85301 215.897C15.3074 213.386 29.3291 211.602 25.8212 214.901C22.981 217.571 16.2441 220.462 12.1682 222.295C17.1112 229.012 23.3098 235.609 30.2958 240.802C35.1591 237.304 45.2842 230.208 46.6894 230.607C48.0348 230.995 41.2382 240.303 37.3814 245.406C37.6605 245.565 37.9395 245.715 38.2186 245.864C46.1712 250.12 53.1671 252.133 59.306 252.292C59.4854 248.684 59.605 244.589 61.6978 242.007C63.8902 239.307 64.7672 245.994 65.1061 251.864ZM66.6308 210.536C65.9731 209.828 66.3717 208.373 67.5377 207.287C68.6937 206.211 70.1786 205.912 70.8363 206.619C71.4941 207.327 71.0955 208.782 69.9295 209.868C68.7734 210.944 67.2985 211.243 66.6308 210.536ZM43.2014 199.225C42.9224 197.052 43.4805 195.198 44.4471 195.079C45.4138 194.959 46.4203 196.614 46.6894 198.786C46.9685 200.959 46.4104 202.812 45.4437 202.932C44.487 203.051 43.4805 201.397 43.2014 199.225ZM18.1077 207.925C18.0778 206.958 19.2339 206.131 20.6889 206.081C22.1439 206.031 23.3497 206.779 23.3796 207.755C23.4095 208.722 22.2535 209.549 20.7985 209.599C19.3435 209.649 18.1376 208.901 18.1077 207.925ZM54.6022 231.384C55.0108 230.138 56.0771 229.371 56.994 229.66C57.9108 229.959 58.3194 231.205 57.9208 232.45C57.5122 233.696 56.4459 234.463 55.529 234.174C54.6122 233.875 54.1936 232.63 54.6022 231.384ZM30.6645 222.016C30.0168 220.88 30.7642 219.226 32.3288 218.339C33.8934 217.442 35.6972 217.641 36.345 218.777C36.9928 219.913 36.2453 221.568 34.6807 222.455C33.1161 223.352 31.3123 223.162 30.6645 222.016Z" fill="#82B379" />
        <path d="M104.59 239.725C104.59 239.725 40.0024 209.28 23.1304 201.078C23.1304 201.078 77.334 233.357 101.022 243.532L104.59 239.725Z" fill="#629957" />
        <path d="M237.583 179.074C243.383 181.027 247.419 187.495 251.096 193.116C260.873 186.379 270.28 175.745 279.12 160.508C279.429 159.97 279.738 159.422 280.047 158.883C269.035 154.728 249.312 146.915 251.126 144.872C253.02 142.739 276.03 143.496 287.172 143.995C293.58 128.249 297.397 111.088 299.071 95.053C290.76 96.3984 277.176 98.85 270.071 97.5445C261.311 95.94 285.627 84.011 300.028 80.1942C300.556 57.7015 303.616 42.0055 300.855 37.1423C296.331 29.1796 261.58 31.8804 239.167 41.876C242.805 55.9874 244.429 82.6557 238.041 75.4106C233.088 69.7999 229.231 56.1568 226.282 48.3039C210.745 56.8943 195.458 68.5243 184.216 82.5461C190.375 92.3424 201.447 110.5 200.57 113.091C199.733 115.572 184.475 103.504 175.227 95.8902C165.68 112.812 160.976 128.139 160.488 141.633C171.729 143.616 186.837 147.144 180.559 151.06C175.207 154.399 167.793 153.721 161.166 153.223C162.81 163.547 167.275 172.546 174.191 180.081C185.801 177.768 194.9 171.301 200.769 165.311C200.769 165.311 202.035 186.08 205.124 199.374C217.412 203.42 229.57 203.52 241.3 198.547C236.357 188.721 231.474 177.021 237.583 179.074ZM189.508 132.444C186.469 131.837 184.306 129.843 184.675 127.98C185.043 126.116 187.804 125.1 190.843 125.698C193.883 126.306 196.046 128.299 195.677 130.162C195.308 132.026 192.538 133.042 189.508 132.444ZM185.412 157.737C184.117 158.654 182.333 158.365 181.446 157.1C180.549 155.834 180.878 154.06 182.173 153.143C183.469 152.226 185.253 152.515 186.14 153.781C187.037 155.057 186.708 156.821 185.412 157.737ZM223.083 95.7506C221.359 96.5379 218.518 94.0266 216.744 90.1399C214.97 86.2533 214.941 82.4663 216.665 81.679C218.389 80.8918 221.229 83.4031 223.003 87.2897C224.777 91.1764 224.817 94.9633 223.083 95.7506ZM253.907 63.2026C252.611 62.8737 252.113 60.4521 252.79 57.8012C253.468 55.1503 255.063 53.2668 256.358 53.5956C257.654 53.9245 258.152 56.3462 257.474 58.9971C256.807 61.648 255.202 63.5315 253.907 63.2026ZM267.47 75.5402C269.941 74.125 272.712 74.3044 273.659 75.9587C274.605 77.6031 273.37 80.0945 270.898 81.5096C268.427 82.9248 265.656 82.7454 264.709 81.0911C263.763 79.4467 264.998 76.9653 267.47 75.5402ZM246.522 126.804C249.661 126.624 252.272 127.691 252.362 129.186C252.452 130.69 249.98 132.056 246.841 132.235C243.702 132.415 241.091 131.348 241.001 129.853C240.911 128.349 243.383 126.983 246.522 126.804ZM214.921 176.583C213.376 176.403 212.419 173.702 212.778 170.553C213.137 167.394 214.681 164.982 216.216 165.152C217.761 165.331 218.718 168.032 218.359 171.181C218 174.34 216.455 176.762 214.921 176.583ZM238.43 158.036C237.214 159.471 234.643 159.292 232.69 157.628C230.736 155.973 230.138 153.462 231.354 152.027C232.57 150.592 235.141 150.771 237.094 152.436C239.048 154.1 239.646 156.601 238.43 158.036ZM261.042 117.147C257.514 117.277 254.584 115.303 254.485 112.742C254.395 110.181 257.175 108.008 260.713 107.879C264.241 107.749 267.171 109.723 267.271 112.284C267.36 114.845 264.57 117.027 261.042 117.147Z" fill="#A8D29F" />
        <path d="M179.851 200.211C179.851 200.211 199.045 156.312 227.019 113.071C241.878 90.0901 266.284 61.4287 275.532 52.2603C275.532 52.2603 241.778 93.4585 224.558 124.88C206.46 157.907 198.208 178.117 189.697 202.872L179.851 200.211Z" fill="#82B379" />
        <path d="M92.4321 192.408C101.71 197.052 111.606 197.61 121.801 194.959C125 184.316 127.113 167.494 127.113 167.494C131.567 172.666 138.633 178.396 147.951 180.878C153.96 175.108 158.056 168.022 159.93 159.721C154.518 159.78 148.459 159.95 144.274 156.96C139.371 153.452 151.838 151.369 161.076 150.343C161.385 139.341 158.345 126.644 151.469 112.393C143.556 118.104 130.531 127.123 129.973 125.06C129.395 122.907 139.341 108.726 144.852 101.072C136.441 89.0935 124.621 78.8488 112.433 71.0556C109.633 77.2941 105.786 88.1767 101.471 92.4819C95.9001 98.0428 98.6008 76.4371 102.298 65.1559C84.609 55.8678 56.4857 51.8616 52.3998 58.1002C49.8984 61.9071 51.5726 74.8226 50.8351 93.1396C62.3455 96.9964 81.4997 107.949 74.2845 108.806C68.4446 109.493 57.5321 106.803 50.8451 105.278C51.3733 118.403 53.5857 132.554 57.9806 145.689C67.0693 145.858 85.8148 146.436 87.2399 148.27C88.6052 150.024 72.1618 155.356 63.0033 158.166C63.2225 158.624 63.4418 159.083 63.671 159.541C70.069 172.387 77.1646 181.526 84.7584 187.505C88.0471 183.13 91.6547 178.077 96.4781 176.792C101.531 175.427 96.9665 184.685 92.4321 192.408ZM133.072 139.191C132.873 137.656 134.727 136.142 137.238 135.813C139.739 135.484 141.932 136.451 142.141 137.985C142.34 139.52 140.487 141.035 137.975 141.364C135.464 141.703 133.272 140.726 133.072 139.191ZM139.59 158.893C140.387 157.907 141.842 157.767 142.849 158.585C143.855 159.392 144.035 160.857 143.237 161.833C142.44 162.82 140.985 162.959 139.978 162.142C138.972 161.335 138.803 159.88 139.59 158.893ZM113.081 102.916C114.725 99.8465 117.157 97.9531 118.522 98.6806C119.888 99.4081 119.658 102.487 118.014 105.557C116.37 108.626 113.938 110.52 112.573 109.792C111.207 109.065 111.437 105.985 113.081 102.916ZM86.5224 78.1313C86.1138 75.9388 86.642 73.9955 87.7083 73.7962C88.7746 73.5969 89.9805 75.2113 90.3891 77.4038C90.7977 79.5962 90.2695 81.5395 89.2032 81.7388C88.1368 81.9382 86.931 80.3237 86.5224 78.1313ZM79.4966 95.7207C78.6395 97.0063 76.3773 97.0163 74.4439 95.7407C72.5106 94.4551 71.6336 92.3723 72.4907 91.0867C73.3477 89.8011 75.6099 89.7911 77.5433 91.0668C79.4766 92.3523 80.3536 94.4352 79.4966 95.7207ZM96.239 136.59C96.0895 137.806 93.907 138.533 91.3657 138.225C88.8245 137.916 86.8811 136.68 87.0306 135.464C87.1801 134.248 89.3626 133.521 91.9039 133.83C94.4451 134.139 96.3884 135.374 96.239 136.59ZM112.503 171.371C112.373 168.789 113.29 166.637 114.556 166.577C115.822 166.517 116.948 168.56 117.077 171.141C117.207 173.722 116.29 175.875 115.024 175.935C113.759 175.995 112.633 173.952 112.503 171.371ZM98.2421 155.156C99.9163 153.911 102.009 153.901 102.926 155.126C103.843 156.352 103.225 158.365 101.551 159.611C99.8764 160.857 97.7836 160.867 96.8668 159.641C95.95 158.405 96.5678 156.402 98.2421 155.156ZM75.7993 120.954C76.0085 118.881 78.49 117.426 81.3601 117.715C84.2203 118.004 86.3729 119.918 86.1636 121.99C85.9543 124.063 83.4729 125.518 80.6027 125.229C77.7426 124.94 75.59 123.027 75.7993 120.954Z" fill="#A8D29F" />
        <path d="M142.3 196.962C142.3 196.962 128.976 160.279 108.477 123.675C97.5843 104.231 79.2274 79.656 72.1917 71.7233C72.1917 71.7233 97.4946 106.972 109.862 133.401C122.867 161.195 128.528 178.048 134.158 198.617L142.3 196.962Z" fill="#82B379" />
        <path d="M310.422 213.197C313.641 215.319 315.066 219.914 316.412 223.93C323.447 221.388 330.892 216.416 338.725 208.553C339.004 208.274 339.273 207.995 339.552 207.706C333.503 203.41 322.74 195.478 324.175 194.521C325.67 193.524 339.572 197.68 346.289 199.773C352.717 191.202 357.799 181.356 361.397 171.849C356.115 171.331 347.445 170.653 343.319 168.72C338.236 166.328 354.969 162.969 364.367 162.949C368.293 149.316 372.678 140.248 371.771 136.839C370.296 131.259 348.671 127.332 333.413 129.833C333.373 139.022 330.085 155.535 327.344 150.094C325.231 145.878 325.062 136.949 324.524 131.687C313.671 134.438 302.489 139.062 293.391 145.808C295.573 152.765 299.41 165.61 298.463 167.055C297.556 168.431 290.192 158.624 285.777 152.505C277.246 161.285 271.915 169.876 269.453 178.028C275.981 181.037 284.631 185.621 280.176 186.997C276.379 188.173 271.964 186.568 268.008 185.203C267.36 191.76 268.626 197.959 271.636 203.669C279.09 204.118 285.667 201.636 290.202 198.926C290.202 198.926 287.641 211.791 287.391 220.382C294.228 224.817 301.632 226.83 309.575 225.684C308.12 218.877 307.034 210.964 310.422 213.197ZM288.597 177.051C286.843 176.194 285.847 174.629 286.365 173.553C286.893 172.477 288.737 172.297 290.491 173.154C292.245 174.011 293.241 175.576 292.723 176.652C292.205 177.729 290.351 177.908 288.597 177.051ZM282.05 191.82C281.113 192.169 280.077 191.711 279.728 190.794C279.389 189.877 279.867 188.85 280.804 188.502C281.741 188.153 282.777 188.611 283.126 189.528C283.465 190.445 282.987 191.471 282.05 191.82ZM314.957 160.079C313.781 160.279 312.455 158.296 311.997 155.645C311.538 152.994 312.126 150.672 313.302 150.472C314.478 150.273 315.804 152.256 316.262 154.907C316.721 157.558 316.133 159.87 314.957 160.079ZM338.964 145.181C338.227 144.772 338.306 143.217 339.153 141.713C339.99 140.208 341.266 139.311 342.004 139.719C342.741 140.128 342.661 141.683 341.814 143.187C340.977 144.702 339.701 145.589 338.964 145.181ZM345.252 154.877C346.986 154.409 348.641 154.967 348.96 156.123C349.269 157.279 348.122 158.594 346.388 159.063C344.654 159.531 343 158.973 342.681 157.817C342.362 156.671 343.518 155.346 345.252 154.877ZM324.255 182.761C326.198 183.15 327.623 184.226 327.434 185.153C327.244 186.08 325.52 186.518 323.577 186.13C321.634 185.741 320.209 184.665 320.398 183.738C320.587 182.811 322.321 182.373 324.255 182.761ZM297.008 208.044C296.101 207.686 295.942 205.892 296.669 204.018C297.397 202.155 298.722 200.929 299.629 201.278C300.536 201.626 300.696 203.43 299.968 205.304C299.241 207.167 297.915 208.393 297.008 208.044ZM314.319 200.51C313.342 201.188 311.807 200.67 310.891 199.344C309.964 198.019 310.004 196.394 310.98 195.717C311.947 195.039 313.492 195.557 314.408 196.883C315.325 198.208 315.285 199.833 314.319 200.51ZM334.659 179.214C332.486 178.725 331.011 177.051 331.37 175.476C331.729 173.902 333.772 173.025 335.944 173.513C338.117 174.001 339.592 175.676 339.233 177.25C338.874 178.825 336.831 179.702 334.659 179.214Z" fill="#82B379" />
        <path d="M271.835 216.814C271.835 216.814 290.58 193.136 314.568 171.261C327.314 159.641 346.787 146.087 353.893 141.982C353.893 141.982 326.706 161.684 311.17 178.067C294.836 195.298 286.564 206.29 277.406 220.013L271.835 216.814Z" fill="#70A266" />
        <path d="M305.958 265.955V134.627C305.958 127.372 300.068 121.482 292.813 121.482H85.1072C77.8422 121.482 71.9625 127.372 71.9625 134.627V265.955H305.958Z" fill="#1A2E36" />
        <path d="M298.732 129.514H80.523V255.043H298.732V129.514Z" fill="white" />
        <path d="M53.6355 263.563V266.782C53.6355 270.41 60.2228 273.36 68.3449 273.36H309.784C317.906 273.36 324.494 270.42 324.494 266.782V263.563H53.6355Z" fill="#C9C9C9" />
        <path d="M72.5604 147.642V225.694H73.557V147.642" fill="#1A2E36" />
        <path d="M305.958 265.955V134.627C305.958 127.372 300.068 121.482 292.813 121.482H85.1072C77.8422 121.482 71.9625 127.372 71.9625 134.627V265.955H305.958Z" fill="#1A2E36" />
        <path d="M298.732 129.514H80.523V255.043H298.732V129.514Z" fill="#F4F4F6" />
        <path d="M53.6355 263.563V266.782C53.6355 270.41 60.2228 273.36 68.3449 273.36H309.784C317.906 273.36 324.494 270.42 324.494 266.782V263.563H53.6355Z" fill="#C9C9C9" />
        <path d="M72.5604 147.642V225.694H73.557V147.642" fill="#1A2E36" />
        <path d="M116.768 138.593H261.351C261.73 138.593 262.039 138.932 262.039 139.351V252.77C262.039 253.189 261.73 253.528 261.351 253.528H116.768C116.39 253.528 116.081 253.189 116.081 252.77V139.351C116.071 138.932 116.38 138.593 116.768 138.593Z" fill="white" />
        <path d="M126.894 165.022H247.429C247.768 165.022 248.037 165.291 248.037 165.63V176.901C248.037 177.24 247.768 177.509 247.429 177.509H126.894C126.555 177.509 126.286 177.24 126.286 176.901V165.63C126.286 165.291 126.555 165.022 126.894 165.022Z" fill="white" />
        <path d="M126.893 165.022V165.072H247.429C247.578 165.072 247.718 165.132 247.817 165.232C247.917 165.331 247.977 165.471 247.977 165.62V176.892C247.977 177.041 247.917 177.181 247.817 177.28C247.718 177.38 247.578 177.44 247.429 177.44H126.893C126.744 177.44 126.604 177.38 126.505 177.28C126.405 177.181 126.345 177.041 126.345 176.892V165.63C126.345 165.481 126.405 165.341 126.505 165.242C126.604 165.142 126.744 165.082 126.893 165.082V165.022V164.973C126.535 164.973 126.236 165.262 126.236 165.63V176.901C126.236 177.26 126.525 177.559 126.893 177.559H247.429C247.788 177.559 248.087 177.27 248.087 176.901V165.63C248.087 165.272 247.798 164.973 247.429 164.973H126.893V165.022Z" fill="#DCDCDC" />
        <path d="M126.894 181.904H247.429C247.768 181.904 248.037 182.173 248.037 182.512V193.783C248.037 194.122 247.768 194.391 247.429 194.391H126.894C126.555 194.391 126.286 194.122 126.286 193.783V182.512C126.286 182.173 126.555 181.904 126.894 181.904Z" fill="white" />
        <path d="M126.893 181.904V181.954H247.429C247.578 181.954 247.718 182.014 247.817 182.113C247.917 182.213 247.977 182.353 247.977 182.502V193.773C247.977 193.923 247.917 194.062 247.817 194.162C247.718 194.262 247.578 194.321 247.429 194.321H126.893C126.744 194.321 126.604 194.262 126.505 194.162C126.405 194.062 126.345 193.923 126.345 193.773V182.502C126.345 182.353 126.405 182.213 126.505 182.113C126.604 182.014 126.744 181.954 126.893 181.954V181.904V181.854C126.535 181.854 126.236 182.143 126.236 182.512V193.783C126.236 194.142 126.525 194.441 126.893 194.441H247.429C247.788 194.441 248.087 194.152 248.087 193.783V182.512C248.087 182.153 247.798 181.854 247.429 181.854H126.893V181.904Z" fill="#DCDCDC" />
        <path d="M126.894 197.929H247.429C247.768 197.929 248.037 198.198 248.037 198.537V209.808C248.037 210.147 247.768 210.416 247.429 210.416H126.894C126.555 210.416 126.286 210.147 126.286 209.808V198.537C126.286 198.198 126.555 197.929 126.894 197.929Z" fill="white" />
        <path d="M126.893 197.929V197.979H247.429C247.578 197.979 247.718 198.039 247.817 198.138C247.917 198.238 247.977 198.378 247.977 198.527V209.798C247.977 209.948 247.917 210.087 247.817 210.187C247.718 210.287 247.578 210.346 247.429 210.346H126.893C126.744 210.346 126.604 210.287 126.505 210.187C126.405 210.087 126.345 209.948 126.345 209.798V198.527C126.345 198.378 126.405 198.238 126.505 198.138C126.604 198.039 126.744 197.979 126.893 197.979V197.929V197.879C126.535 197.879 126.236 198.168 126.236 198.537V209.808C126.236 210.167 126.525 210.466 126.893 210.466H247.429C247.788 210.466 248.087 210.177 248.087 209.808V198.537C248.087 198.178 247.798 197.879 247.429 197.879H126.893V197.929Z" fill="#DCDCDC" />
        <path d="M126.894 217.342H247.429C247.768 217.342 248.037 217.611 248.037 217.95V239.775C248.037 240.114 247.768 240.383 247.429 240.383H126.894C126.555 240.383 126.286 240.114 126.286 239.775V217.95C126.286 217.611 126.555 217.342 126.894 217.342Z" fill="white" />
        <path d="M126.893 217.342V217.392H247.429C247.578 217.392 247.718 217.452 247.817 217.552C247.917 217.651 247.977 217.791 247.977 217.94V239.765C247.977 239.915 247.917 240.054 247.817 240.154C247.718 240.254 247.578 240.313 247.429 240.313H126.893C126.744 240.313 126.604 240.254 126.505 240.154C126.405 240.054 126.345 239.915 126.345 239.765V217.94C126.345 217.791 126.405 217.651 126.505 217.552C126.604 217.452 126.744 217.392 126.893 217.392V217.342V217.292C126.535 217.292 126.236 217.581 126.236 217.95V239.775C126.236 240.134 126.525 240.433 126.893 240.433H247.429C247.788 240.433 248.087 240.144 248.087 239.775V217.95C248.087 217.591 247.798 217.292 247.429 217.292H126.893V217.342Z" fill="#DCDCDC" />
        <path d="M215.06 243.831H247.429C247.808 243.831 248.116 244.14 248.116 244.519V252.84C248.116 253.219 247.808 253.528 247.429 253.528H215.06C214.681 253.528 214.373 253.219 214.373 252.84V244.519C214.373 244.14 214.681 243.831 215.06 243.831Z" fill="#5FBF24" />
        <path d="M187.365 168.311H131.258V174.639H187.365V168.311Z" fill="#E9E8E8" />
        <path d="M187.365 186.459H131.258V192.787H187.365V186.459Z" fill="#E9E8E8" />
        <path d="M187.365 202.483H131.258V208.812H187.365V202.483Z" fill="#E9E8E8" />
        <path d="M214.363 221.468H131.258V235.809H214.363V221.468Z" fill="#E9E8E8" />
        <path d="M194.67 152.745H126.286V158.844H194.67V152.745Z" fill="#3B7AFE" />
        <path d="M298.304 255.72C325.939 255.72 348.342 233.17 348.342 205.354C348.342 177.537 325.939 154.987 298.304 154.987C270.669 154.987 248.266 177.537 248.266 205.354C248.266 233.17 270.669 255.72 298.304 255.72Z" fill="#3B7AFE" />
        <path d="M293.381 229.012C292.354 229.012 291.368 228.623 290.63 227.906L273.698 211.742C272.104 210.217 272.044 207.695 273.569 206.101C275.094 204.506 277.615 204.447 279.21 205.971L293.132 219.266L321.145 187.196C322.59 185.542 325.112 185.372 326.766 186.817C328.42 188.262 328.59 190.784 327.145 192.438L296.38 227.647C295.663 228.464 294.646 228.952 293.56 229.002C293.5 229.012 293.441 229.012 293.381 229.012Z" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_2836_149082">
          <rect width="375" height="318.235" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export function WhiteMainLogo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="150"
      height="60"
      viewBox="0 0 150 60"
      fill="none"
    >
      <g clip-path="url(#clip0_2836_148925)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.7981 29.1291L40.1816 48.5126L57.5661 31.1281L28.7909 2.35297L22.704 8.43991L45.3921 31.1281L39.873 36.6473L26.5765 23.3506L20.7981 29.1291Z"
          fill="white"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.015625 31.1281L17.2419 13.9019L23.3289 19.9888L12.1896 31.1281L34.8778 53.8163L28.7908 59.9032L0.015625 31.1281Z"
          fill="white"
        />
        <path
          d="M73.55 27.4599C75.8883 25.0932 78.7253 23.9099 82.0614 23.9099C85.4261 23.9099 88.2777 25.0932 90.6158 27.4599C92.9539 29.8267 94.123 32.6781 94.123 36.0142C94.123 36.7271 94.066 37.5968 93.9519 38.6233H77.4422C77.7843 39.5641 78.4188 40.3269 79.3454 40.9115C80.2723 41.496 81.377 41.7883 82.6602 41.7883C84.7134 41.7883 86.3101 41.218 87.4507 40.0774L92.9682 43.5847C91.8561 44.9819 90.352 46.101 88.4557 46.9422C86.5596 47.7835 84.6278 48.204 82.6602 48.204C78.9819 48.204 75.9522 47.0277 73.5713 44.6754C71.1905 42.323 70 39.4359 70 36.0142C70 32.6781 71.1833 29.8266 73.55 27.4599ZM142.663 47.5365V24.3433H149.592V47.5365H142.663ZM118.906 15.3541H138.494V22.4541H126.263V28.6314H138.118V35.7315H126.263V47.5365H118.906V15.3541ZM96.1516 30.5159V24.5359H113.877V29.5961L104.906 41.2216H114.462V47.5365H95.912V42.811L105.031 30.5159H96.1516ZM77.4849 33.4625H86.9374C86.7093 32.513 86.1603 31.7076 85.2907 31.0462C84.4211 30.3851 83.3588 30.0544 82.1043 30.0544C80.8781 30.0544 79.8587 30.3851 79.0461 31.0462C78.2335 31.7076 77.7131 32.513 77.4849 33.4625Z"
          fill="white"
        />
        <path
          d="M143.226 15.3511C142.419 16.1735 142.016 17.1481 142.016 18.2749C142.016 19.402 142.419 20.3691 143.226 21.1762C144.034 21.9833 145.001 22.3869 146.127 22.3869C147.254 22.3869 148.229 21.9758 149.052 21.1533C149.843 20.3615 150.239 19.402 150.239 18.2749C150.239 17.1481 149.836 16.1735 149.029 15.3511C148.221 14.5288 147.254 14.1177 146.128 14.1177C145.001 14.1177 144.034 14.5288 143.226 15.3511Z"
          fill="#5FBF24"
        />
      </g>
      <defs>
        <clipPath id="clip0_2836_148925">
          <rect width="150" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function RedDocs() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
    >
      <g clip-path="url(#clip0_1643_20031)">
        <rect x="0.287598" width="48" height="48" rx="24" fill="#FFECEC" />
        <path
          d="M27 34.75H21C15.57 34.75 13.25 32.43 13.25 27V21C13.25 15.57 15.57 13.25 21 13.25H26C26.41 13.25 26.75 13.59 26.75 14C26.75 14.41 26.41 14.75 26 14.75H21C16.39 14.75 14.75 16.39 14.75 21V27C14.75 31.61 16.39 33.25 21 33.25H27C31.61 33.25 33.25 31.61 33.25 27V22C33.25 21.59 33.59 21.25 34 21.25C34.41 21.25 34.75 21.59 34.75 22V27C34.75 32.43 32.43 34.75 27 34.75Z"
          fill="#E73F3B"
        />
        <path
          d="M34 22.75H30C26.58 22.75 25.25 21.42 25.25 18V14C25.25 13.7 25.43 13.42 25.71 13.31C25.99 13.19 26.31 13.26 26.53 13.47L34.53 21.47C34.74 21.68 34.81 22.01 34.69 22.29C34.57 22.57 34.3 22.75 34 22.75ZM26.75 15.81V18C26.75 20.58 27.42 21.25 30 21.25H32.19L26.75 15.81Z"
          fill="#E73F3B"
        />
        <path
          d="M25 25.75H19C18.59 25.75 18.25 25.41 18.25 25C18.25 24.59 18.59 24.25 19 24.25H25C25.41 24.25 25.75 24.59 25.75 25C25.75 25.41 25.41 25.75 25 25.75Z"
          fill="#E73F3B"
        />
        <path
          d="M23 29.75H19C18.59 29.75 18.25 29.41 18.25 29C18.25 28.59 18.59 28.25 19 28.25H23C23.41 28.25 23.75 28.59 23.75 29C23.75 29.41 23.41 29.75 23 29.75Z"
          fill="#E73F3B"
        />
      </g>
      <defs>
        <clipPath id="clip0_1643_20031">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(0.287598)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function RoundedDocs() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
    >
      <g clip-path="url(#clip0_1643_20013)">
        <rect x="0.30127" width="48" height="48" rx="24" fill="#EDFFE1" />
        <path
          d="M27 34.75H21C15.57 34.75 13.25 32.43 13.25 27V21C13.25 15.57 15.57 13.25 21 13.25H26C26.41 13.25 26.75 13.59 26.75 14C26.75 14.41 26.41 14.75 26 14.75H21C16.39 14.75 14.75 16.39 14.75 21V27C14.75 31.61 16.39 33.25 21 33.25H27C31.61 33.25 33.25 31.61 33.25 27V22C33.25 21.59 33.59 21.25 34 21.25C34.41 21.25 34.75 21.59 34.75 22V27C34.75 32.43 32.43 34.75 27 34.75Z"
          fill="#4DA851"
        />
        <path
          d="M34 22.75H30C26.58 22.75 25.25 21.42 25.25 18V14C25.25 13.7 25.43 13.42 25.71 13.31C25.99 13.19 26.31 13.26 26.53 13.47L34.53 21.47C34.74 21.68 34.81 22.01 34.69 22.29C34.57 22.57 34.3 22.75 34 22.75ZM26.75 15.81V18C26.75 20.58 27.42 21.25 30 21.25H32.19L26.75 15.81Z"
          fill="#4DA851"
        />
        <path
          d="M25 25.75H19C18.59 25.75 18.25 25.41 18.25 25C18.25 24.59 18.59 24.25 19 24.25H25C25.41 24.25 25.75 24.59 25.75 25C25.75 25.41 25.41 25.75 25 25.75Z"
          fill="#4DA851"
        />
        <path
          d="M23 29.75H19C18.59 29.75 18.25 29.41 18.25 29C18.25 28.59 18.59 28.25 19 28.25H23C23.41 28.25 23.75 28.59 23.75 29C23.75 29.41 23.41 29.75 23 29.75Z"
          fill="#4DA851"
        />
      </g>
      <defs>
        <clipPath id="clip0_1643_20013">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(0.30127)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function PinkFileIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
    >
      <g clip-path="url(#clip0_2129_54191)">
        <rect x="0.424805" width="48" height="48" rx="24" fill="#FFEBF0" />
        <path
          d="M26 18.75H22C21.04 18.75 19.25 18.75 19.25 16C19.25 13.25 21.04 13.25 22 13.25H26C26.96 13.25 28.75 13.25 28.75 16C28.75 16.96 28.75 18.75 26 18.75ZM22 14.75C21.01 14.75 20.75 14.75 20.75 16C20.75 17.25 21.01 17.25 22 17.25H26C27.25 17.25 27.25 16.99 27.25 16C27.25 14.75 26.99 14.75 26 14.75H22Z"
          fill="#FF6E91"
        />
        <path
          d="M27 34.7501H21C15.38 34.7501 14.25 32.1701 14.25 28.0001V22.0001C14.25 17.4401 15.9 15.4901 19.96 15.2801C20.37 15.2601 20.73 15.5701 20.75 15.9901C20.77 16.4101 20.45 16.7501 20.04 16.7701C17.2 16.9301 15.75 17.7801 15.75 22.0001V28.0001C15.75 31.7001 16.48 33.2501 21 33.2501H27C31.52 33.2501 32.25 31.7001 32.25 28.0001V22.0001C32.25 17.7801 30.8 16.9301 27.96 16.7701C27.55 16.7501 27.23 16.3901 27.25 15.9801C27.27 15.5701 27.63 15.2501 28.04 15.2701C32.1 15.4901 33.75 17.4401 33.75 21.9901V27.9901C33.75 32.1701 32.62 34.7501 27 34.7501Z"
          fill="#FF6E91"
        />
      </g>
      <defs>
        <clipPath id="clip0_2129_54191">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(0.424805)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function PurpleDollar() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
    >
      <g clip-path="url(#clip0_2129_54179)">
        <rect x="0.30127" width="48" height="48" rx="24" fill="#F4ECFF" />
        <path
          d="M25.3999 29.42H22.8899C21.2499 29.42 19.9199 28.04 19.9199 26.34C19.9199 25.93 20.2599 25.59 20.6699 25.59C21.0799 25.59 21.4199 25.93 21.4199 26.34C21.4199 27.21 22.0799 27.92 22.8899 27.92H25.3999C26.0499 27.92 26.5899 27.34 26.5899 26.64C26.5899 25.77 26.2799 25.6 25.7699 25.42L21.7399 24C20.9599 23.73 19.9099 23.15 19.9099 21.36C19.9099 19.82 21.1199 18.58 22.5999 18.58H25.1099C26.7499 18.58 28.0799 19.96 28.0799 21.66C28.0799 22.07 27.7399 22.41 27.3299 22.41C26.9199 22.41 26.5799 22.07 26.5799 21.66C26.5799 20.79 25.9199 20.08 25.1099 20.08H22.5999C21.9499 20.08 21.4099 20.66 21.4099 21.36C21.4099 22.23 21.7199 22.4 22.2299 22.58L26.2599 24C27.0399 24.27 28.0899 24.85 28.0899 26.64C28.0799 28.17 26.8799 29.42 25.3999 29.42Z"
          fill="#B47DFF"
        />
        <path
          d="M24 30.75C23.59 30.75 23.25 30.41 23.25 30V18C23.25 17.59 23.59 17.25 24 17.25C24.41 17.25 24.75 17.59 24.75 18V30C24.75 30.41 24.41 30.75 24 30.75Z"
          fill="#B47DFF"
        />
        <path
          d="M24 34.75C18.07 34.75 13.25 29.93 13.25 24C13.25 18.07 18.07 13.25 24 13.25C29.93 13.25 34.75 18.07 34.75 24C34.75 29.93 29.93 34.75 24 34.75ZM24 14.75C18.9 14.75 14.75 18.9 14.75 24C14.75 29.1 18.9 33.25 24 33.25C29.1 33.25 33.25 29.1 33.25 24C33.25 18.9 29.1 14.75 24 14.75Z"
          fill="#B47DFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_2129_54179">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(0.30127)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function GreenDollar() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
    >
      <g clip-path="url(#clip0_2129_54197)">
        <rect x="0.287598" width="48" height="48" rx="24" fill="#EBFFF6" />
        <path
          d="M25.3999 29.42H22.8899C21.2499 29.42 19.9199 28.04 19.9199 26.34C19.9199 25.93 20.2599 25.59 20.6699 25.59C21.0799 25.59 21.4199 25.93 21.4199 26.34C21.4199 27.21 22.0799 27.92 22.8899 27.92H25.3999C26.0499 27.92 26.5899 27.34 26.5899 26.64C26.5899 25.77 26.2799 25.6 25.7699 25.42L21.7399 24C20.9599 23.73 19.9099 23.15 19.9099 21.36C19.9099 19.82 21.1199 18.58 22.5999 18.58H25.1099C26.7499 18.58 28.0799 19.96 28.0799 21.66C28.0799 22.07 27.7399 22.41 27.3299 22.41C26.9199 22.41 26.5799 22.07 26.5799 21.66C26.5799 20.79 25.9199 20.08 25.1099 20.08H22.5999C21.9499 20.08 21.4099 20.66 21.4099 21.36C21.4099 22.23 21.7199 22.4 22.2299 22.58L26.2599 24C27.0399 24.27 28.0899 24.85 28.0899 26.64C28.0799 28.17 26.8799 29.42 25.3999 29.42Z"
          fill="#58C693"
        />
        <path
          d="M24 30.75C23.59 30.75 23.25 30.41 23.25 30V18C23.25 17.59 23.59 17.25 24 17.25C24.41 17.25 24.75 17.59 24.75 18V30C24.75 30.41 24.41 30.75 24 30.75Z"
          fill="#58C693"
        />
        <path
          d="M24 34.75C18.07 34.75 13.25 29.93 13.25 24C13.25 18.07 18.07 13.25 24 13.25C29.93 13.25 34.75 18.07 34.75 24C34.75 29.93 29.93 34.75 24 34.75ZM24 14.75C18.9 14.75 14.75 18.9 14.75 24C14.75 29.1 18.9 33.25 24 33.25C29.1 33.25 33.25 29.1 33.25 24C33.25 18.9 29.1 14.75 24 14.75Z"
          fill="#58C693"
        />
      </g>
      <defs>
        <clipPath id="clip0_2129_54197">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(0.287598)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function GreenGroup() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
    >
      <g clip-path="url(#clip0_1643_20019)">
        <rect x="0.30127" width="48" height="48" rx="24" fill="#EAFDFF" />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24 16C21.9289 16 20.25 17.6789 20.25 19.75C20.25 21.8211 21.9289 23.5 24 23.5C26.0711 23.5 27.75 21.8211 27.75 19.75C27.75 17.6789 26.0711 16 24 16ZM21.75 19.75C21.75 18.5074 22.7574 17.5 24 17.5C25.2426 17.5 26.25 18.5074 26.25 19.75C26.25 20.9926 25.2426 22 24 22C22.7574 22 21.75 20.9926 21.75 19.75Z"
          fill="#0BB3C8"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21 25C18.9289 25 17.25 26.6789 17.25 28.75C17.25 30.8211 18.9289 32.5 21 32.5H27C29.0711 32.5 30.75 30.8211 30.75 28.75C30.75 26.6789 29.0711 25 27 25H21ZM18.75 28.75C18.75 27.5074 19.7574 26.5 21 26.5H27C28.2426 26.5 29.25 27.5074 29.25 28.75C29.25 29.9926 28.2426 31 27 31H21C19.7574 31 18.75 29.9926 18.75 28.75Z"
          fill="#0BB3C8"
        />
        <path
          d="M19.7521 22.3887C19.5944 22.1353 19.2985 22 19 22C17.7574 22 16.75 20.9926 16.75 19.75C16.75 18.5074 17.7574 17.5 19 17.5C19.2985 17.5 19.5944 17.3647 19.7521 17.1113C19.7591 17.1001 19.7661 17.089 19.7732 17.0778C20.0358 16.6633 19.9027 16.0764 19.415 16.0227C19.2787 16.0077 19.1403 16 19 16C16.9289 16 15.25 17.6789 15.25 19.75C15.25 21.8211 16.9289 23.5 19 23.5C19.1403 23.5 19.2787 23.4923 19.415 23.4773C19.9027 23.4236 20.0358 22.8367 19.7732 22.4222C19.7661 22.411 19.7591 22.3999 19.7521 22.3887Z"
          fill="#0BB3C8"
        />
        <path
          d="M16.7083 30.3169C16.5948 30.1275 16.3944 30 16.1736 30H16C14.7574 30 13.75 28.9926 13.75 27.75C13.75 26.5074 14.7574 25.5 16 25.5H16.1736C16.3944 25.5 16.5948 25.3725 16.7083 25.1831C16.9854 24.7208 16.6847 24 16.1457 24H16C13.9289 24 12.25 25.6789 12.25 27.75C12.25 29.8211 13.9289 31.5 16 31.5H16.1457C16.6847 31.5 16.9854 30.7792 16.7083 30.3169Z"
          fill="#0BB3C8"
        />
        <path
          d="M28.2268 22.4222C27.9642 22.8367 28.0973 23.4236 28.585 23.4773C28.7213 23.4923 28.8597 23.5 29 23.5C31.0711 23.5 32.75 21.8211 32.75 19.75C32.75 17.6789 31.0711 16 29 16C28.8597 16 28.7213 16.0077 28.585 16.0227C28.0973 16.0764 27.9642 16.6633 28.2268 17.0778C28.2339 17.089 28.2409 17.1001 28.2479 17.1113C28.4056 17.3647 28.7015 17.5 29 17.5C30.2426 17.5 31.25 18.5074 31.25 19.75C31.25 20.9926 30.2426 22 29 22C28.7015 22 28.4056 22.1353 28.2479 22.3887C28.2409 22.3999 28.2339 22.411 28.2268 22.4222Z"
          fill="#0BB3C8"
        />
        <path
          d="M31.2917 30.3169C31.0146 30.7792 31.3153 31.5 31.8543 31.5H32C34.0711 31.5 35.75 29.8211 35.75 27.75C35.75 25.6789 34.0711 24 32 24H31.8543C31.3153 24 31.0146 24.7208 31.2917 25.1831C31.4052 25.3725 31.6056 25.5 31.8264 25.5H32C33.2426 25.5 34.25 26.5074 34.25 27.75C34.25 28.9926 33.2426 30 32 30H31.8264C31.6056 30 31.4052 30.1275 31.2917 30.3169Z"
          fill="#0BB3C8"
        />
      </g>
      <defs>
        <clipPath id="clip0_1643_20019">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(0.30127)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function YellowDollar() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
    >
      <g clip-path="url(#clip0_2129_54185)">
        <rect x="0.30127" width="48" height="48" rx="24" fill="#FFFAE3" />
        <path
          d="M25.3999 29.42H22.8899C21.2499 29.42 19.9199 28.04 19.9199 26.34C19.9199 25.93 20.2599 25.59 20.6699 25.59C21.0799 25.59 21.4199 25.93 21.4199 26.34C21.4199 27.21 22.0799 27.92 22.8899 27.92H25.3999C26.0499 27.92 26.5899 27.34 26.5899 26.64C26.5899 25.77 26.2799 25.6 25.7699 25.42L21.7399 24C20.9599 23.73 19.9099 23.15 19.9099 21.36C19.9099 19.82 21.1199 18.58 22.5999 18.58H25.1099C26.7499 18.58 28.0799 19.96 28.0799 21.66C28.0799 22.07 27.7399 22.41 27.3299 22.41C26.9199 22.41 26.5799 22.07 26.5799 21.66C26.5799 20.79 25.9199 20.08 25.1099 20.08H22.5999C21.9499 20.08 21.4099 20.66 21.4099 21.36C21.4099 22.23 21.7199 22.4 22.2299 22.58L26.2599 24C27.0399 24.27 28.0899 24.85 28.0899 26.64C28.0799 28.17 26.8799 29.42 25.3999 29.42Z"
          fill="#E2C544"
        />
        <path
          d="M24 30.75C23.59 30.75 23.25 30.41 23.25 30V18C23.25 17.59 23.59 17.25 24 17.25C24.41 17.25 24.75 17.59 24.75 18V30C24.75 30.41 24.41 30.75 24 30.75Z"
          fill="#E2C544"
        />
        <path
          d="M24 34.75C18.07 34.75 13.25 29.93 13.25 24C13.25 18.07 18.07 13.25 24 13.25C29.93 13.25 34.75 18.07 34.75 24C34.75 29.93 29.93 34.75 24 34.75ZM24 14.75C18.9 14.75 14.75 18.9 14.75 24C14.75 29.1 18.9 33.25 24 33.25C29.1 33.25 33.25 29.1 33.25 24C33.25 18.9 29.1 14.75 24 14.75Z"
          fill="#E2C544"
        />
      </g>
      <defs>
        <clipPath id="clip0_2129_54185">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(0.30127)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CameraIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <path
        d="M3.1875 10.47C3.1875 9.38199 4.06949 8.5 5.15748 8.5V8.5C5.90366 8.5 6.58579 8.07842 6.91949 7.41102L7.94721 5.35557C8.21617 4.81766 8.35065 4.5487 8.5923 4.39935C8.83395 4.25 9.13466 4.25 9.73607 4.25H15.7639C16.3653 4.25 16.666 4.25 16.9077 4.39935C17.1493 4.5487 17.2838 4.81766 17.5528 5.35557L18.5805 7.41102C18.9142 8.07842 19.5963 8.5 20.3425 8.5V8.5C21.4305 8.5 22.3125 9.38199 22.3125 10.47V18.25C22.3125 19.6642 22.3125 20.3713 21.8732 20.8107C21.4338 21.25 20.7267 21.25 19.3125 21.25H6.1875C4.77329 21.25 4.06618 21.25 3.62684 20.8107C3.1875 20.3713 3.1875 19.6642 3.1875 18.25V10.47Z"
        stroke="white"
        stroke-width="1.5"
      />
      <circle
        cx="12.75"
        cy="13.8125"
        r="3.5"
        stroke="white"
        stroke-width="1.5"
      />
    </svg>
  );
}

export function GreyCalendar() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16.75 3.56V2C16.75 1.59 16.41 1.25 16 1.25C15.59 1.25 15.25 1.59 15.25 2V3.5H8.74999V2C8.74999 1.59 8.40999 1.25 7.99999 1.25C7.58999 1.25 7.24999 1.59 7.24999 2V3.56C4.54999 3.81 3.23999 5.42 3.03999 7.81C3.01999 8.1 3.25999 8.34 3.53999 8.34H20.46C20.75 8.34 20.99 8.09 20.96 7.81C20.76 5.42 19.45 3.81 16.75 3.56Z"
        fill="#899CA8"
      />
      <path
        d="M20 9.83984H4C3.45 9.83984 3 10.2898 3 10.8398V16.9998C3 19.9998 4.5 21.9998 8 21.9998H16C19.5 21.9998 21 19.9998 21 16.9998V10.8398C21 10.2898 20.55 9.83984 20 9.83984ZM9.21 18.2098C9.16 18.2498 9.11 18.2998 9.06 18.3298C9 18.3698 8.94 18.3998 8.88 18.4198C8.82 18.4498 8.76 18.4698 8.7 18.4798C8.63 18.4898 8.57 18.4998 8.5 18.4998C8.37 18.4998 8.24 18.4698 8.12 18.4198C7.99 18.3698 7.89 18.2998 7.79 18.2098C7.61 18.0198 7.5 17.7598 7.5 17.4998C7.5 17.2398 7.61 16.9798 7.79 16.7898C7.89 16.6998 7.99 16.6298 8.12 16.5798C8.3 16.4998 8.5 16.4798 8.7 16.5198C8.76 16.5298 8.82 16.5498 8.88 16.5798C8.94 16.5998 9 16.6298 9.06 16.6698C9.11 16.7098 9.16 16.7498 9.21 16.7898C9.39 16.9798 9.5 17.2398 9.5 17.4998C9.5 17.7598 9.39 18.0198 9.21 18.2098ZM9.21 14.7098C9.02 14.8898 8.76 14.9998 8.5 14.9998C8.24 14.9998 7.98 14.8898 7.79 14.7098C7.61 14.5198 7.5 14.2598 7.5 13.9998C7.5 13.7398 7.61 13.4798 7.79 13.2898C8.07 13.0098 8.51 12.9198 8.88 13.0798C9.01 13.1298 9.12 13.1998 9.21 13.2898C9.39 13.4798 9.5 13.7398 9.5 13.9998C9.5 14.2598 9.39 14.5198 9.21 14.7098ZM12.71 18.2098C12.52 18.3898 12.26 18.4998 12 18.4998C11.74 18.4998 11.48 18.3898 11.29 18.2098C11.11 18.0198 11 17.7598 11 17.4998C11 17.2398 11.11 16.9798 11.29 16.7898C11.66 16.4198 12.34 16.4198 12.71 16.7898C12.89 16.9798 13 17.2398 13 17.4998C13 17.7598 12.89 18.0198 12.71 18.2098ZM12.71 14.7098C12.66 14.7498 12.61 14.7898 12.56 14.8298C12.5 14.8698 12.44 14.8998 12.38 14.9198C12.32 14.9498 12.26 14.9698 12.2 14.9798C12.13 14.9898 12.07 14.9998 12 14.9998C11.74 14.9998 11.48 14.8898 11.29 14.7098C11.11 14.5198 11 14.2598 11 13.9998C11 13.7398 11.11 13.4798 11.29 13.2898C11.38 13.1998 11.49 13.1298 11.62 13.0798C11.99 12.9198 12.43 13.0098 12.71 13.2898C12.89 13.4798 13 13.7398 13 13.9998C13 14.2598 12.89 14.5198 12.71 14.7098ZM16.21 18.2098C16.02 18.3898 15.76 18.4998 15.5 18.4998C15.24 18.4998 14.98 18.3898 14.79 18.2098C14.61 18.0198 14.5 17.7598 14.5 17.4998C14.5 17.2398 14.61 16.9798 14.79 16.7898C15.16 16.4198 15.84 16.4198 16.21 16.7898C16.39 16.9798 16.5 17.2398 16.5 17.4998C16.5 17.7598 16.39 18.0198 16.21 18.2098ZM16.21 14.7098C16.16 14.7498 16.11 14.7898 16.06 14.8298C16 14.8698 15.94 14.8998 15.88 14.9198C15.82 14.9498 15.76 14.9698 15.7 14.9798C15.63 14.9898 15.56 14.9998 15.5 14.9998C15.24 14.9998 14.98 14.8898 14.79 14.7098C14.61 14.5198 14.5 14.2598 14.5 13.9998C14.5 13.7398 14.61 13.4798 14.79 13.2898C14.89 13.1998 14.99 13.1298 15.12 13.0798C15.3 12.9998 15.5 12.9798 15.7 13.0198C15.76 13.0298 15.82 13.0498 15.88 13.0798C15.94 13.0998 16 13.1298 16.06 13.1698C16.11 13.2098 16.16 13.2498 16.21 13.2898C16.39 13.4798 16.5 13.7398 16.5 13.9998C16.5 14.2598 16.39 14.5198 16.21 14.7098Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Cross() {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="43"
        height="43"
        rx="21.5"
        fill="white"
        stroke="#F5F1FE"
      />
      <path
        d="M16 27.3723C16.0292 27.3833 16.0183 27.4125 16.0256 27.4308C16.2009 28.0045 16.8949 28.1909 17.3222 27.7743C17.7313 27.376 18.1294 26.9703 18.5312 26.5647C19.6561 25.4392 20.7847 24.3136 21.9097 23.1808C21.9827 23.1077 22.0156 23.1114 22.0887 23.1808C23.6008 24.701 25.1166 26.2139 26.6323 27.7304C26.9428 28.0411 27.3519 28.0813 27.6806 27.8401C28.0495 27.5697 28.1079 27.0507 27.8084 26.7036C27.7755 26.6634 27.739 26.6305 27.7025 26.5939C26.2013 25.092 24.7002 23.5901 23.1954 22.0881C23.1223 22.015 23.1077 21.9785 23.1917 21.8981C24.7075 20.3889 26.2196 18.8723 27.7317 17.3594C28.0312 17.0598 28.0824 16.6651 27.8705 16.3399C27.7573 16.1681 27.5929 16.0767 27.4103 16C27.2861 16 27.1619 16 27.0341 16C26.8624 16.0183 26.7309 16.1096 26.6141 16.2266C25.1202 17.7248 23.6227 19.2195 22.1288 20.7141C22.1033 20.7397 22.0777 20.7616 22.0558 20.7872C22.0193 20.8274 21.9827 20.8274 21.9462 20.7872C21.9206 20.7616 21.8951 20.736 21.8732 20.7141C20.372 19.2268 18.8745 17.7322 17.3806 16.2339C17.2638 16.1133 17.1323 16.0256 16.9606 16.0073C16.8364 16.0073 16.7122 16.0073 16.5844 16.0073C16.2484 16.0767 16.0621 16.2887 16 16.6176C16 16.7199 16 16.8222 16 16.9209C16.0146 17.1146 16.1205 17.2571 16.252 17.3923C17.7495 18.8869 19.2434 20.3816 20.7409 21.8798C20.7811 21.92 20.8213 21.9675 20.8724 21.9968C20.8286 22.0224 20.7957 22.0626 20.7592 22.0954C19.258 23.5937 17.7568 25.0957 16.2557 26.5976C16.1242 26.7292 16.0183 26.8717 16 27.069C16 27.1713 16 27.27 16 27.3723Z"
        fill="#363636"
      />
    </svg>
  );
}

export function DashboardIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M6 3C4.34315 3 3 4.34315 3 6V8C3 9.65685 4.34315 11 6 11H8C9.65685 11 11 9.65685 11 8V6C11 4.34315 9.65685 3 8 3H6ZM16 3C14.3431 3 13 4.34315 13 6V8C13 9.65685 14.3431 11 16 11H18C19.6569 11 21 9.65685 21 8V6C21 4.34315 19.6569 3 18 3H16ZM3 16C3 14.3431 4.34315 13 6 13H8C9.65685 13 11 14.3431 11 16V18C11 19.6569 9.65685 21 8 21H6C4.34315 21 3 19.6569 3 18V16ZM16 13C14.3431 13 13 14.3431 13 16V18C13 19.6569 14.3431 21 16 21H18C19.6569 21 21 19.6569 21 18V16C21 14.3431 19.6569 13 18 13H16Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function NormalSearch() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M7.66683 14.1584C11.1646 14.1584 14.0002 11.3228 14.0002 7.82503C14.0002 4.32723 11.1646 1.4917 7.66683 1.4917C4.16903 1.4917 1.3335 4.32723 1.3335 7.82503C1.3335 11.3228 4.16903 14.1584 7.66683 14.1584Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.6668 14.825L13.3335 13.4917"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function SearchSvg() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 3C6.80558 3 3 6.80558 3 11.5C3 16.1944 6.80558 20 11.5 20C13.4845 20 15.3102 19.3199 16.7567 18.18L17.1601 18.5742L20.2929 21.7071L20.3871 21.7903C20.7794 22.0953 21.3466 22.0676 21.7071 21.7071C22.0976 21.3166 22.0976 20.6834 21.7071 20.2929L18.5661 17.1518L18.1721 16.7668C19.3167 15.3187 20 13.4892 20 11.5C20 6.80558 16.1944 3 11.5 3ZM11.5 5C15.0899 5 18 7.91015 18 11.5C18 15.0899 15.0899 18 11.5 18C7.91015 18 5 15.0899 5 11.5C5 7.91015 7.91015 5 11.5 5Z"
        fill="#0A1629"
      />
    </svg>
  );
}

export function SearchSvgLight() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5304 17.4698C19.2375 17.1769 18.7626 17.1769 18.4697 17.4698C18.1768 17.7626 18.1768 18.2375 18.4697 18.5304L19.5304 17.4698ZM22.4696 22.5304C22.7625 22.8233 23.2374 22.8233 23.5303 22.5304C23.8232 22.2375 23.8232 21.7626 23.5303 21.4697L22.4696 22.5304ZM18.4697 18.5304L22.4696 22.5304L23.5303 21.4697L19.5304 17.4698L18.4697 18.5304ZM11 18.25C6.44365 18.25 2.75 14.5563 2.75 10H1.25C1.25 15.3848 5.61522 19.75 11 19.75V18.25ZM19.25 10C19.25 14.5563 15.5563 18.25 11 18.25V19.75C16.3848 19.75 20.75 15.3848 20.75 10H19.25ZM11 1.75C15.5563 1.75 19.25 5.44365 19.25 10H20.75C20.75 4.61522 16.3848 0.25 11 0.25V1.75ZM11 0.25C5.61522 0.25 1.25 4.61522 1.25 10H2.75C2.75 5.44365 6.44365 1.75 11 1.75V0.25Z"
        fill="#989898"
      />
    </svg>
  );
}
export function SetupIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.75 12C9.75 10.7574 10.7574 9.75002 12 9.75002C13.2426 9.75002 14.25 10.7574 14.25 12C14.25 13.2427 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2427 9.75 12Z"
        fill="#989898"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.58523 3.2323C9.56564 -0.203083 14.4342 -0.203084 15.4147 3.2323C15.7184 4.2967 16.812 4.92806 17.8857 4.65893C21.351 3.7903 23.7853 8.00664 21.3004 10.5734C20.5305 11.3687 20.5305 12.6314 21.3004 13.4266C23.7853 15.9934 21.351 20.2097 17.8857 19.3411C16.812 19.072 15.7184 19.7033 15.4147 20.7677C14.4342 24.2031 9.56564 24.2031 8.58523 20.7677C8.28146 19.7033 7.18792 19.072 6.11423 19.3411C2.6489 20.2097 0.214599 15.9934 2.69952 13.4266C3.46944 12.6314 3.46944 11.3687 2.69952 10.5734C0.214599 8.00664 2.6489 3.7903 6.11423 4.65893C7.18792 4.92806 8.28146 4.2967 8.58523 3.2323ZM12 8.25002C9.92893 8.25002 8.25 9.92895 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92895 14.0711 8.25002 12 8.25002Z"
        fill="#989898"
      />
    </svg>
  );
}
export function NotificationSvg() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 2C15.9511 2 19.169 5.13941 19.2961 9.06012L19.3 9.30112V13.8019C19.3 14.6917 19.9831 15.4218 20.8533 15.4962L21.1332 15.5094C22.2445 15.6286 22.2872 17.2401 21.2614 17.4741L21.1332 17.4954L21 17.5024H3L2.86683 17.4954C1.71106 17.3714 1.71106 15.6334 2.86683 15.5094L3.14668 15.4962C3.96851 15.4259 4.62352 14.7708 4.69376 13.9486L4.7 13.8019V9.30112C4.7 5.26886 7.96828 2 12 2ZM13.557 19.103C14.3277 19.103 14.8087 19.9381 14.422 20.6047C13.9211 21.4684 12.9983 22 12 22C11.0017 22 10.0789 21.4684 9.57796 20.6047C9.21064 19.9714 9.62639 19.1861 10.3296 19.1092L10.443 19.103H13.557ZM6.70442 9.0826C6.81899 6.25617 9.14611 4 12 4C14.9271 4 17.3 6.37335 17.3 9.30112V13.8019L17.3051 13.9984L17.3276 14.2563C17.3797 14.6817 17.504 15.0848 17.6878 15.453L17.714 15.502H6.285L6.3122 15.453L6.41182 15.2362C6.59742 14.7951 6.7 14.3105 6.7 13.8019V9.30112L6.70442 9.0826Z"
        fill="#0A1629"
      />
    </svg>
  );
}
export function DropdownSvg() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.7071 9.29289C17.0676 9.65338 17.0953 10.2206 16.7903 10.6129L16.7071 10.7071L12.7071 14.7071C12.3466 15.0676 11.7794 15.0953 11.3871 14.7903L11.2929 14.7071L7.29289 10.7071C6.90237 10.3166 6.90237 9.68342 7.29289 9.29289C7.65338 8.93241 8.22061 8.90468 8.6129 9.2097L8.70711 9.29289L12 12.585L15.2929 9.29289C15.6534 8.93241 16.2206 8.90468 16.6129 9.2097L16.7071 9.29289Z"
        fill="#0A1629"
      />
    </svg>
  );
}
export function CancelIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.2791 4.23867C19.8364 3.82475 19.1438 3.824 18.7003 4.23697L12.6515 9.86874L6.60274 4.23697C6.1592 3.824 5.46656 3.82475 5.02393 4.23867L4.94754 4.3101C4.46761 4.75889 4.46845 5.51408 4.94936 5.96184L10.8985 11.5009L4.94936 17.0399C4.46845 17.4877 4.46762 18.2429 4.94754 18.6917L5.02393 18.7631C5.46656 19.177 6.1592 19.1778 6.60275 18.7648L12.6515 13.133L18.7003 18.7648C19.1438 19.1778 19.8364 19.177 20.2791 18.7631L20.3555 18.6917C20.8354 18.2429 20.8346 17.4877 20.3537 17.0399L14.4045 11.5009L20.3536 5.96184C20.8346 5.51408 20.8354 4.75889 20.3555 4.3101L20.2791 4.23867Z"
        fill="#363636"
      />
    </svg>
  );
}

export function NoSearchFound() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="250"
      height="200"
      viewBox="0 0 250 200"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M207 65C210.866 65 214 68.134 214 72C214 75.866 210.866 79 207 79H167C170.866 79 174 82.134 174 86C174 89.866 170.866 93 167 93H189C192.866 93 196 96.134 196 100C196 103.866 192.866 107 189 107H178.826C173.952 107 170 110.134 170 114C170 116.577 172 118.911 176 121C179.866 121 183 124.134 183 128C183 131.866 179.866 135 176 135H93C89.134 135 86 131.866 86 128C86 124.134 89.134 121 93 121H54C50.134 121 47 117.866 47 114C47 110.134 50.134 107 54 107H94C97.866 107 101 103.866 101 100C101 96.134 97.866 93 94 93H69C65.134 93 62 89.866 62 86C62 82.134 65.134 79 69 79H109C105.134 79 102 75.866 102 72C102 68.134 105.134 65 109 65H207ZM207 93C210.866 93 214 96.134 214 100C214 103.866 210.866 107 207 107C203.134 107 200 103.866 200 100C200 96.134 203.134 93 207 93Z"
        fill="#F3F7FF"
      />
      <path
        d="M125.588 130.321C146.94 130.321 164.248 113.012 164.248 91.6606C164.248 70.3089 146.94 53 125.588 53C104.236 53 86.9272 70.3089 86.9272 91.6606C86.9272 113.012 104.236 130.321 125.588 130.321Z"
        fill="#F3F7FF"
        stroke="#126ADF"
        stroke-width="2.5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M119.393 121.659C121.422 122.033 123.487 122.228 125.588 122.243C142.478 122.243 156.17 108.551 156.17 91.6606C156.17 74.7705 142.478 61.0784 125.588 61.0784C121.249 61.0784 117.121 61.9819 113.382 63.6111C106.885 66.4422 101.562 71.4647 98.3475 77.745C96.2108 81.9193 95.0054 86.6492 95.0054 91.6606C95.0054 96.2076 95.9977 100.523 97.7776 104.401C99.0483 107.171 100.72 109.717 102.719 111.967"
        fill="white"
      />
      <path
        d="M119.393 121.659C121.422 122.033 123.487 122.228 125.588 122.243C142.478 122.243 156.17 108.551 156.17 91.6606C156.17 74.7705 142.478 61.0784 125.588 61.0784C121.249 61.0784 117.121 61.9819 113.382 63.6111C106.885 66.4422 101.562 71.4647 98.3475 77.745C96.2108 81.9193 95.0054 86.6492 95.0054 91.6606C95.0054 96.2076 95.9977 100.523 97.7776 104.401C99.0483 107.171 100.72 109.717 102.719 111.967"
        stroke="#126ADF"
        stroke-width="2.5"
        stroke-linecap="round"
      />
      <path
        d="M106.312 115.405C108.792 117.42 111.592 119.054 114.626 120.219"
        stroke="#126ADF"
        stroke-width="2.5"
        stroke-linecap="round"
      />
      <path
        d="M157.324 122.243L164.249 129.167"
        stroke="#126ADF"
        stroke-width="2.5"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M163.129 128.048C160.945 130.232 160.945 133.774 163.129 135.958L175.922 148.751C178.107 150.935 181.648 150.935 183.832 148.751C186.017 146.567 186.017 143.025 183.832 140.841L171.039 128.048C168.855 125.864 165.314 125.864 163.129 128.048Z"
        fill="#E8F0FE"
        stroke="#126ADF"
        stroke-width="2.5"
      />
      <path
        d="M168.865 130.321L181.559 143.016"
        stroke="white"
        stroke-width="2.5"
        stroke-linecap="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M118.087 78.3892C118.087 91.7738 128.937 102.624 142.322 102.624C144.951 102.624 147.483 102.205 149.853 101.431C145.984 111.034 136.577 117.812 125.588 117.812C111.145 117.812 99.4365 106.104 99.4365 91.6608C99.4365 78.5733 109.05 67.7313 121.601 65.8113C119.371 69.4791 118.087 73.7842 118.087 78.3892Z"
        fill="#E8F0FE"
      />
      <path
        d="M126.165 70.3108C124.695 70.3108 123.259 70.4554 121.871 70.731M117.676 72.0143C109.782 75.3318 104.238 83.1374 104.238 92.2377"
        stroke="#75A4FE"
        stroke-width="2.5"
        stroke-linecap="round"
      />
      <path
        d="M187.568 92H178.099M194.893 83H175H194.893ZM203 83H200.427H203Z"
        stroke="#75A4FE"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M84 117H74.5162M78.5762 107H58.6525H78.5762ZM51.8965 107H47H51.8965Z"
        stroke="#75A4FE"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function CrossSquared() {
  return (
    <svg
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="44" height="44" rx="14" fill="#F4F9FD" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M30.041 14.2423C29.601 13.8258 28.9125 13.8251 28.4716 14.2406L22.5 19.8679L16.5285 14.2406C16.0876 13.8251 15.3991 13.8258 14.9591 14.2423L14.8936 14.3042C14.4166 14.7557 14.4174 15.5155 14.8954 15.966L20.768 21.5L14.8954 27.034C14.4174 27.4845 14.4166 28.2443 14.8936 28.6958L14.9591 28.7577C15.3991 29.1742 16.0876 29.1749 16.5285 28.7594L22.5 23.1321L28.4716 28.7594C28.9125 29.1749 29.601 29.1742 30.041 28.7577L30.1064 28.6958C30.5835 28.2443 30.5826 27.4845 30.1046 27.034L24.232 21.5L30.1046 15.966C30.5826 15.5155 30.5835 14.7557 30.1064 14.3042L30.041 14.2423Z"
        fill="#0A1629"
      />
    </svg>
  );
}

export function User() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 2C6.38 2 4.25 4.13 4.25 6.75C4.25 9.32 6.26 11.4 8.88 11.49C8.96 11.48 9.04 11.48 9.1 11.49C9.12 11.49 9.13 11.49 9.15 11.49C9.16 11.49 9.16 11.49 9.17 11.49C11.73 11.4 13.74 9.32 13.75 6.75C13.75 4.13 11.62 2 9 2Z"
        fill="#899CA8"
      />
      <path
        d="M14.08 14.15C11.29 12.29 6.73996 12.29 3.92996 14.15C2.65996 15 1.95996 16.15 1.95996 17.38C1.95996 18.61 2.65996 19.75 3.91996 20.59C5.31996 21.53 7.15996 22 8.99996 22C10.84 22 12.68 21.53 14.08 20.59C15.34 19.74 16.04 18.6 16.04 17.36C16.03 16.13 15.34 14.99 14.08 14.15Z"
        fill="#899CA8"
      />
      <path
        d="M19.9899 7.33998C20.1499 9.27998 18.7699 10.98 16.8599 11.21C16.8499 11.21 16.8499 11.21 16.8399 11.21H16.8099C16.7499 11.21 16.6899 11.21 16.6399 11.23C15.6699 11.28 14.7799 10.97 14.1099 10.4C15.1399 9.47998 15.7299 8.09998 15.6099 6.59998C15.5399 5.78998 15.2599 5.04998 14.8399 4.41998C15.2199 4.22998 15.6599 4.10998 16.1099 4.06998C18.0699 3.89998 19.8199 5.35998 19.9899 7.33998Z"
        fill="#899CA8"
      />
      <path
        d="M21.9902 16.59C21.9102 17.56 21.2902 18.4 20.2502 18.97C19.2502 19.52 17.9902 19.78 16.7402 19.75C17.4602 19.1 17.8802 18.29 17.9602 17.43C18.0602 16.19 17.4702 15 16.2902 14.05C15.6202 13.52 14.8402 13.1 13.9902 12.79C16.2002 12.15 18.9802 12.58 20.6902 13.96C21.6102 14.7 22.0802 15.63 21.9902 16.59Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Role() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2C9.38 2 7.25 4.13 7.25 6.75C7.25 9.32 9.26 11.4 11.88 11.49C11.96 11.48 12.04 11.48 12.1 11.49C12.12 11.49 12.13 11.49 12.15 11.49C12.16 11.49 12.16 11.49 12.17 11.49C14.73 11.4 16.74 9.32 16.75 6.75C16.75 4.13 14.62 2 12 2Z"
        fill="#899CA8"
      />
      <path
        d="M17.08 14.15C14.29 12.29 9.73996 12.29 6.92996 14.15C5.65996 15 4.95996 16.15 4.95996 17.38C4.95996 18.61 5.65996 19.75 6.91996 20.59C8.31996 21.53 10.16 22 12 22C13.84 22 15.68 21.53 17.08 20.59C18.34 19.74 19.04 18.6 19.04 17.36C19.03 16.13 18.34 14.99 17.08 14.15Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Marketing() {
  return (
    <svg
      width="19"
      height="20"
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.69632 15.9166C3.00984 15.8975 2.44441 15.626 2.08836 15.0327C1.45041 13.9706 0.825546 12.9002 0.229036 11.8141C-0.247518 10.9471 0.0447392 9.85169 0.886615 9.33697C1.85663 8.74428 2.84954 8.18975 3.83591 7.62378C4.06055 7.4951 4.22904 7.56707 4.38334 7.83424C5.0949 9.06652 5.80592 10.2993 6.51748 11.5316C6.55128 11.5905 6.584 11.6516 6.62653 11.7039C6.73503 11.8375 6.92642 11.874 7.06764 11.7852C7.21759 11.6908 7.27538 11.5518 7.21759 11.3811C7.18978 11.2983 7.14289 11.2214 7.09872 11.145C6.39152 9.91821 5.68323 8.69193 4.97549 7.46511C4.79501 7.15267 4.82009 7.02454 5.11671 6.81571C7.45205 5.17012 9.38225 3.13904 10.9231 0.733917C11.5682 -0.273171 12.8855 -0.236639 13.4848 0.798803C15.0769 3.55071 16.6658 6.3048 18.2536 9.05998C18.8463 10.0883 18.2416 11.2197 17.0562 11.3201C16.3032 11.3839 15.5475 11.4318 14.7994 11.5344C12.8179 11.8064 10.9199 12.3762 9.09654 13.1968C7.67724 13.8359 6.38171 14.6985 5.02729 15.4542C4.61017 15.687 4.20341 15.94 3.69632 15.9166Z"
        fill="#899CA8"
      />
      <path
        d="M7.90255 20C7.50397 19.9482 7.173 19.8021 6.97562 19.4711C6.39383 18.4962 5.83003 17.5104 5.26569 16.5251C5.15501 16.3315 5.21226 16.1532 5.41019 16.0376C6.10321 15.633 6.79786 15.2323 7.4947 14.8342C7.70899 14.7121 7.88619 14.7612 8.01269 14.9793C8.56504 15.9324 9.12011 16.8839 9.65828 17.8446C9.95926 18.3817 9.78478 19.0185 9.26678 19.3457C9.00288 19.5125 8.73243 19.6729 8.45326 19.8119C8.28151 19.8986 8.08685 19.9395 7.90255 20Z"
        fill="#899CA8"
      />
      <path
        d="M17.7344 5.15982C17.7273 5.23452 17.7256 5.35775 17.7027 5.47716C17.6733 5.63147 17.5692 5.75579 17.4165 5.75034C17.2982 5.74652 17.1302 5.686 17.0746 5.59494C16.6651 4.92209 16.2769 4.23671 15.8854 3.55295C15.8052 3.41282 15.8336 3.27378 15.9405 3.15764C16.0555 3.03278 16.1973 3.02515 16.3521 3.08131C17.1569 3.37193 17.7393 4.2258 17.7344 5.15982Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Payment() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0336 3.25C15.4053 3.25 16.4807 3.24999 17.3451 3.32061C18.2252 3.39252 18.9523 3.54138 19.6104 3.87671C20.6924 4.42798 21.572 5.30762 22.1233 6.38955C22.5254 7.17877 22.6643 8.08233 22.7165 9.25H1.28354C1.33571 8.08233 1.47459 7.17877 1.87671 6.38955C2.42798 5.30762 3.30762 4.42798 4.38955 3.87671C5.04769 3.54138 5.77479 3.39252 6.65494 3.32061C7.51929 3.24999 8.59472 3.25 9.96644 3.25H14.0336Z"
        fill="#899CA8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M1.25227 10.75C1.25 11.1341 1.25 11.548 1.25 11.9942V12.0336C1.25 13.4053 1.24999 14.4807 1.32061 15.3451C1.39252 16.2252 1.54138 16.9523 1.87671 17.6104C2.42798 18.6924 3.30762 19.572 4.38955 20.1233C5.04769 20.4586 5.77479 20.6075 6.65494 20.6794C7.51924 20.75 8.59461 20.75 9.96623 20.75H14.0336C15.4052 20.75 16.4808 20.75 17.3451 20.6794C18.2252 20.6075 18.9523 20.4586 19.6104 20.1233C20.6924 19.572 21.572 18.6924 22.1233 17.6104C22.4586 16.9523 22.6075 16.2252 22.6794 15.3451C22.75 14.4808 22.75 13.4054 22.75 12.0338V11.9942C22.75 11.548 22.75 11.1341 22.7477 10.75H1.25227ZM5.25 17C5.25 16.5858 5.58579 16.25 6 16.25H8C8.41421 16.25 8.75 16.5858 8.75 17C8.75 17.4142 8.41421 17.75 8 17.75H6C5.58579 17.75 5.25 17.4142 5.25 17ZM10.25 17C10.25 16.5858 10.5858 16.25 11 16.25H15C15.4142 16.25 15.75 16.5858 15.75 17C15.75 17.4142 15.4142 17.75 15 17.75H11C10.5858 17.75 10.25 17.4142 10.25 17Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Financing() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2499 8.07996V10.94L10.2399 10.59C9.72992 10.41 9.41992 10.24 9.41992 9.36996C9.41992 8.65996 9.94992 8.07996 10.5999 8.07996H11.2499Z"
        fill="#899CA8"
      />
      <path
        d="M14.58 14.6301C14.58 15.3401 14.05 15.9201 13.4 15.9201H12.75V13.0601L13.76 13.4101C14.27 13.5901 14.58 13.7601 14.58 14.6301Z"
        fill="#899CA8"
      />
      <path
        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.19C2 19.83 4.17 22 7.81 22H16.19C19.83 22 22 19.83 22 16.19V7.81C22 4.17 19.83 2 16.19 2ZM14.26 12C15.04 12.27 16.08 12.84 16.08 14.63C16.08 16.17 14.88 17.42 13.4 17.42H12.75V18C12.75 18.41 12.41 18.75 12 18.75C11.59 18.75 11.25 18.41 11.25 18V17.42H10.89C9.25 17.42 7.92 16.03 7.92 14.33C7.92 13.92 8.25 13.58 8.67 13.58C9.08 13.58 9.42 13.92 9.42 14.33C9.42 15.21 10.08 15.92 10.89 15.92H11.25V12.53L9.74 12C8.96 11.73 7.92 11.16 7.92 9.37C7.92 7.83 9.12 6.58 10.6 6.58H11.25V6C11.25 5.59 11.59 5.25 12 5.25C12.41 5.25 12.75 5.59 12.75 6V6.58H13.11C14.75 6.58 16.08 7.97 16.08 9.67C16.08 10.08 15.75 10.42 15.33 10.42C14.92 10.42 14.58 10.08 14.58 9.67C14.58 8.79 13.92 8.08 13.11 8.08H12.75V11.47L14.26 12Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Appointment() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.7502 3.56V2C16.7502 1.59 16.4102 1.25 16.0002 1.25C15.5902 1.25 15.2502 1.59 15.2502 2V3.5H8.75023V2C8.75023 1.59 8.41023 1.25 8.00023 1.25C7.59023 1.25 7.25023 1.59 7.25023 2V3.56C4.55023 3.81 3.24023 5.42 3.04023 7.81C3.02023 8.1 3.26023 8.34 3.54023 8.34H20.4602C20.7502 8.34 20.9902 8.09 20.9602 7.81C20.7602 5.42 19.4502 3.81 16.7502 3.56Z"
        fill="#899CA8"
      />
      <path
        d="M20 9.83997H4C3.45 9.83997 3 10.29 3 10.84V17C3 20 4.5 22 8 22H16C19.5 22 21 20 21 17V10.84C21 10.29 20.55 9.83997 20 9.83997ZM9.21 18.21C9.16 18.25 9.11 18.3 9.06 18.33C9 18.37 8.94 18.4 8.88 18.42C8.82 18.45 8.76 18.47 8.7 18.48C8.63 18.49 8.57 18.5 8.5 18.5C8.37 18.5 8.24 18.47 8.12 18.42C7.99 18.37 7.89 18.3 7.79 18.21C7.61 18.02 7.5 17.76 7.5 17.5C7.5 17.24 7.61 16.98 7.79 16.79C7.89 16.7 7.99 16.63 8.12 16.58C8.3 16.5 8.5 16.48 8.7 16.52C8.76 16.53 8.82 16.55 8.88 16.58C8.94 16.6 9 16.63 9.06 16.67C9.11 16.71 9.16 16.75 9.21 16.79C9.39 16.98 9.5 17.24 9.5 17.5C9.5 17.76 9.39 18.02 9.21 18.21ZM9.21 14.71C9.02 14.89 8.76 15 8.5 15C8.24 15 7.98 14.89 7.79 14.71C7.61 14.52 7.5 14.26 7.5 14C7.5 13.74 7.61 13.48 7.79 13.29C8.07 13.01 8.51 12.92 8.88 13.08C9.01 13.13 9.12 13.2 9.21 13.29C9.39 13.48 9.5 13.74 9.5 14C9.5 14.26 9.39 14.52 9.21 14.71ZM12.71 18.21C12.52 18.39 12.26 18.5 12 18.5C11.74 18.5 11.48 18.39 11.29 18.21C11.11 18.02 11 17.76 11 17.5C11 17.24 11.11 16.98 11.29 16.79C11.66 16.42 12.34 16.42 12.71 16.79C12.89 16.98 13 17.24 13 17.5C13 17.76 12.89 18.02 12.71 18.21ZM12.71 14.71C12.66 14.75 12.61 14.79 12.56 14.83C12.5 14.87 12.44 14.9 12.38 14.92C12.32 14.95 12.26 14.97 12.2 14.98C12.13 14.99 12.07 15 12 15C11.74 15 11.48 14.89 11.29 14.71C11.11 14.52 11 14.26 11 14C11 13.74 11.11 13.48 11.29 13.29C11.38 13.2 11.49 13.13 11.62 13.08C11.99 12.92 12.43 13.01 12.71 13.29C12.89 13.48 13 13.74 13 14C13 14.26 12.89 14.52 12.71 14.71ZM16.21 18.21C16.02 18.39 15.76 18.5 15.5 18.5C15.24 18.5 14.98 18.39 14.79 18.21C14.61 18.02 14.5 17.76 14.5 17.5C14.5 17.24 14.61 16.98 14.79 16.79C15.16 16.42 15.84 16.42 16.21 16.79C16.39 16.98 16.5 17.24 16.5 17.5C16.5 17.76 16.39 18.02 16.21 18.21ZM16.21 14.71C16.16 14.75 16.11 14.79 16.06 14.83C16 14.87 15.94 14.9 15.88 14.92C15.82 14.95 15.76 14.97 15.7 14.98C15.63 14.99 15.56 15 15.5 15C15.24 15 14.98 14.89 14.79 14.71C14.61 14.52 14.5 14.26 14.5 14C14.5 13.74 14.61 13.48 14.79 13.29C14.89 13.2 14.99 13.13 15.12 13.08C15.3 13 15.5 12.98 15.7 13.02C15.76 13.03 15.82 13.05 15.88 13.08C15.94 13.1 16 13.13 16.06 13.17C16.11 13.21 16.16 13.25 16.21 13.29C16.39 13.48 16.5 13.74 16.5 14C16.5 14.26 16.39 14.52 16.21 14.71Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function SettingsIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.75 12C9.75 10.7574 10.7574 9.75002 12 9.75002C13.2426 9.75002 14.25 10.7574 14.25 12C14.25 13.2427 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2427 9.75 12Z"
        fill="#363636"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.58523 3.2323C9.56564 -0.203083 14.4342 -0.203084 15.4147 3.2323C15.7184 4.2967 16.812 4.92806 17.8857 4.65893C21.351 3.7903 23.7853 8.00664 21.3004 10.5734C20.5305 11.3687 20.5305 12.6314 21.3004 13.4266C23.7853 15.9934 21.351 20.2097 17.8857 19.3411C16.812 19.072 15.7184 19.7033 15.4147 20.7677C14.4342 24.2031 9.56564 24.2031 8.58523 20.7677C8.28146 19.7033 7.18792 19.072 6.11423 19.3411C2.6489 20.2097 0.214599 15.9934 2.69952 13.4266C3.46944 12.6314 3.46944 11.3687 2.69952 10.5734C0.214599 8.00664 2.6489 3.7903 6.11423 4.65893C7.18792 4.92806 8.28146 4.2967 8.58523 3.2323ZM12 8.25002C9.92893 8.25002 8.25 9.92895 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92895 14.0711 8.25002 12 8.25002Z"
        fill="#363636"
      />
    </svg>
  );
}

export function LogoutProfile() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7 11.25C6.58579 11.25 6.25 11.5858 6.25 12C6.25 12.4142 6.58579 12.75 7 12.75L15 12.75L15 15C15 15.929 15 16.3935 14.9384 16.7822C14.5996 18.9216 12.9216 20.5996 10.7822 20.9384C10.3935 21 9.929 21 9 21C8.07099 21 7.60649 21 7.21783 20.9384C5.07836 20.5996 3.40041 18.9216 3.06156 16.7822C3 16.3935 3 15.929 3 15L3 9C3 8.07099 3 7.60649 3.06156 7.21783C3.40042 5.07836 5.07837 3.40042 7.21783 3.06156C7.60649 3 8.07099 3 9 3C9.92901 3 10.3935 3 10.7822 3.06156C12.9216 3.40042 14.5996 5.07836 14.9384 7.21783C15 7.60649 15 8.07099 15 9L15 11.25L7 11.25ZM15 11.25L19.8105 11.25C19.483 10.9273 19.001 10.5437 18.297 9.98553L16.534 8.58768C16.2095 8.33034 16.155 7.8586 16.4123 7.53403C16.6697 7.20946 17.1414 7.15497 17.466 7.41232L19.2648 8.83857C19.9372 9.37175 20.4922 9.81172 20.8875 10.2055C21.2932 10.6096 21.6294 11.0582 21.7208 11.6313C21.7402 11.7534 21.75 11.8766 21.75 12C21.75 12.1234 21.7402 12.2466 21.7208 12.3687C21.6294 12.9418 21.2932 13.3904 20.8875 13.7945C20.4922 14.1883 19.9373 14.6282 19.2648 15.1614L17.466 16.5877C17.1414 16.845 16.6697 16.7905 16.4123 16.466C16.155 16.1414 16.2095 15.6697 16.534 15.4123L18.297 14.0145C19.001 13.4563 19.483 13.0727 19.8105 12.75L15 12.75L15 11.25Z"
        fill="#363636"
      />
    </svg>
  );
}

export function Ezpay() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17 4H7C4 4 2 5.5 2 9V12.56C2 12.93 2.38 13.16 2.71 13.01C3.69 12.56 4.82 12.39 6.01 12.6C8.64 13.07 10.57 15.51 10.5 18.18C10.49 18.6 10.43 19.01 10.32 19.41C10.24 19.72 10.49 20.01 10.81 20.01H17C20 20.01 22 18.51 22 15.01V9C22 5.5 20 4 17 4ZM12 14.5C10.62 14.5 9.5 13.38 9.5 12C9.5 10.62 10.62 9.5 12 9.5C13.38 9.5 14.5 10.62 14.5 12C14.5 13.38 13.38 14.5 12 14.5ZM19.25 14C19.25 14.41 18.91 14.75 18.5 14.75C18.09 14.75 17.75 14.41 17.75 14V10C17.75 9.59 18.09 9.25 18.5 9.25C18.91 9.25 19.25 9.59 19.25 10V14Z"
        fill="#899CA8"
      />
      <path
        d="M5 14C2.79 14 1 15.79 1 18C1 18.75 1.21 19.46 1.58 20.06C2.27 21.22 3.54 22 5 22C6.46 22 7.73 21.22 8.42 20.06C8.79 19.46 9 18.75 9 18C9 15.79 7.21 14 5 14ZM6.97 17.67L4.84 19.64C4.7 19.77 4.51 19.84 4.33 19.84C4.14 19.84 3.95 19.77 3.8 19.62L2.81 18.63C2.52 18.34 2.52 17.86 2.81 17.57C3.1 17.28 3.58 17.28 3.87 17.57L4.35 18.05L5.95 16.57C6.25 16.29 6.73 16.31 7.01 16.61C7.29 16.91 7.27 17.39 6.97 17.67Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Ezplan() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.2499 8.07996V10.94L10.2399 10.59C9.72992 10.41 9.41992 10.24 9.41992 9.36996C9.41992 8.65996 9.94992 8.07996 10.5999 8.07996H11.2499Z"
        fill="#899CA8"
      />
      <path
        d="M14.58 14.6301C14.58 15.3401 14.05 15.9201 13.4 15.9201H12.75V13.0601L13.76 13.4101C14.27 13.5901 14.58 13.7601 14.58 14.6301Z"
        fill="#899CA8"
      />
      <path
        d="M16.19 2H7.81C4.17 2 2 4.17 2 7.81V16.19C2 19.83 4.17 22 7.81 22H16.19C19.83 22 22 19.83 22 16.19V7.81C22 4.17 19.83 2 16.19 2ZM14.26 12C15.04 12.27 16.08 12.84 16.08 14.63C16.08 16.17 14.88 17.42 13.4 17.42H12.75V18C12.75 18.41 12.41 18.75 12 18.75C11.59 18.75 11.25 18.41 11.25 18V17.42H10.89C9.25 17.42 7.92 16.03 7.92 14.33C7.92 13.92 8.25 13.58 8.67 13.58C9.08 13.58 9.42 13.92 9.42 14.33C9.42 15.21 10.08 15.92 10.89 15.92H11.25V12.53L9.74 12C8.96 11.73 7.92 11.16 7.92 9.37C7.92 7.83 9.12 6.58 10.6 6.58H11.25V6C11.25 5.59 11.59 5.25 12 5.25C12.41 5.25 12.75 5.59 12.75 6V6.58H13.11C14.75 6.58 16.08 7.97 16.08 9.67C16.08 10.08 15.75 10.42 15.33 10.42C14.92 10.42 14.58 10.08 14.58 9.67C14.58 8.79 13.92 8.08 13.11 8.08H12.75V11.47L14.26 12Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Administrator() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.75 12C9.75 10.7574 10.7574 9.75002 12 9.75002C13.2426 9.75002 14.25 10.7574 14.25 12C14.25 13.2427 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2427 9.75 12Z"
        fill="#899CA8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.58523 3.2323C9.56564 -0.203083 14.4342 -0.203084 15.4147 3.2323C15.7184 4.2967 16.812 4.92806 17.8857 4.65893C21.351 3.7903 23.7853 8.00664 21.3004 10.5734C20.5305 11.3687 20.5305 12.6314 21.3004 13.4266C23.7853 15.9934 21.351 20.2097 17.8857 19.3411C16.812 19.072 15.7184 19.7033 15.4147 20.7677C14.4342 24.2031 9.56564 24.2031 8.58523 20.7677C8.28146 19.7033 7.18792 19.072 6.11423 19.3411C2.6489 20.2097 0.214599 15.9934 2.69952 13.4266C3.46944 12.6314 3.46944 11.3687 2.69952 10.5734C0.214599 8.00664 2.6489 3.7903 6.11423 4.65893C7.18792 4.92806 8.28146 4.2967 8.58523 3.2323ZM12 8.25002C9.92893 8.25002 8.25 9.92895 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92895 14.0711 8.25002 12 8.25002Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function Content() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.5 13.15H13.33C11.55 13.15 10.1 11.71 10.1 9.92V7.75C10.1 7.34 9.77 7 9.35 7H6.18C3.87 7 2 8.5 2 11.18V17.82C2 20.5 3.87 22 6.18 22H12.07C14.38 22 16.25 20.5 16.25 17.82V13.9C16.25 13.48 15.91 13.15 15.5 13.15Z"
        fill="#899CA8"
      />
      <path
        d="M17.8198 2H15.8498H14.7598H11.9298C9.66977 2 7.83977 3.44 7.75977 6.01C7.81977 6.01 7.86977 6 7.92977 6H10.7598H11.8498H13.8198C16.1298 6 17.9998 7.5 17.9998 10.18V12.15V14.86V16.83C17.9998 16.89 17.9898 16.94 17.9898 16.99C20.2198 16.92 21.9998 15.44 21.9998 12.83V10.86V8.15V6.18C21.9998 3.5 20.1298 2 17.8198 2Z"
        fill="#899CA8"
      />
      <path
        d="M11.9801 7.14999C11.6701 6.83999 11.1401 7.04999 11.1401 7.47999V10.1C11.1401 11.2 12.0701 12.1 13.2101 12.1C13.9201 12.11 14.9101 12.11 15.7601 12.11C16.1901 12.11 16.4101 11.61 16.1101 11.31C15.0201 10.22 13.0801 8.26999 11.9801 7.14999Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function ArrowRight() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M1 1L7 7L1 13"
        stroke="#5C5C5C"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function Notification() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.1902 14.06L19.0602 12.18C18.8102 11.77 18.5902 10.98 18.5902 10.5V8.63005C18.5902 5.00005 15.6402 2.05005 12.0202 2.05005C8.3902 2.06005 5.4402 5.00005 5.4402 8.63005V10.49C5.4402 10.97 5.2202 11.76 4.9802 12.17L3.8502 14.05C3.4202 14.78 3.3202 15.61 3.5902 16.33C3.8602 17.06 4.4702 17.64 5.2702 17.9C6.3502 18.26 7.4402 18.52 8.5502 18.71C8.6602 18.73 8.7702 18.74 8.8802 18.76C9.0202 18.7801 9.1702 18.8 9.3202 18.82C9.5802 18.8601 9.8402 18.89 10.1102 18.91C10.7402 18.97 11.3802 19 12.0202 19C12.6502 19 13.2802 18.97 13.9002 18.91C14.1302 18.89 14.3602 18.8701 14.5802 18.84C14.7602 18.82 14.9402 18.8001 15.1202 18.7701C15.2302 18.76 15.3402 18.74 15.4502 18.72C16.5702 18.54 17.6802 18.26 18.7602 17.9C19.5302 17.64 20.1202 17.06 20.4002 16.32C20.6802 15.57 20.6002 14.75 20.1902 14.06ZM12.7502 10C12.7502 10.42 12.4102 10.76 11.9902 10.76C11.5702 10.76 11.2302 10.42 11.2302 10V6.90005C11.2302 6.48005 11.5702 6.14005 11.9902 6.14005C12.4102 6.14005 12.7502 6.48005 12.7502 6.90005V10Z"
        fill="#899CA8"
      />
      <path
        d="M14.8302 20.01C14.4102 21.17 13.3002 22 12.0002 22C11.2102 22 10.4302 21.68 9.88018 21.11C9.56018 20.81 9.32018 20.41 9.18018 20C9.31018 20.02 9.44018 20.03 9.58018 20.05C9.81018 20.08 10.0502 20.11 10.2902 20.13C10.8602 20.18 11.4402 20.21 12.0202 20.21C12.5902 20.21 13.1602 20.18 13.7202 20.13C13.9302 20.11 14.1402 20.1 14.3402 20.07C14.5002 20.05 14.6602 20.03 14.8302 20.01Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function NoNotificationSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="250"
      height="200"
      viewBox="0 0 250 200"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M63 134H154C154.515 134 155.017 133.944 155.5 133.839C155.983 133.944 156.485 134 157 134H209C212.866 134 216 130.866 216 127C216 123.134 212.866 120 209 120H203C199.134 120 196 116.866 196 113C196 109.134 199.134 106 203 106H222C225.866 106 229 102.866 229 99C229 95.134 225.866 92 222 92H200C203.866 92 207 88.866 207 85C207 81.134 203.866 78 200 78H136C139.866 78 143 74.866 143 71C143 67.134 139.866 64 136 64H79C75.134 64 72 67.134 72 71C72 74.866 75.134 78 79 78H39C35.134 78 32 81.134 32 85C32 88.866 35.134 92 39 92H64C67.866 92 71 95.134 71 99C71 102.866 67.866 106 64 106H24C20.134 106 17 109.134 17 113C17 116.866 20.134 120 24 120H63C59.134 120 56 123.134 56 127C56 130.866 59.134 134 63 134ZM226 134C229.866 134 233 130.866 233 127C233 123.134 229.866 120 226 120C222.134 120 219 123.134 219 127C219 130.866 222.134 134 226 134Z"
        fill="#F3F7FF"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M170.896 54.3303C169.981 52.0438 168.169 50.232 165.883 49.3172L164.106 48.6066L165.883 47.896C168.169 46.9812 169.981 45.1694 170.896 42.8829L171.606 41.1066L172.317 42.8829C173.232 45.1694 175.044 46.9812 177.33 47.896L179.106 48.6066L177.33 49.3172C175.044 50.232 173.232 52.0438 172.317 54.3303L171.606 56.1066L170.896 54.3303Z"
        stroke="#75A4FE"
        stroke-width="2.5"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M72.8958 161.33C71.981 159.044 70.1693 157.232 67.8827 156.317L66.1064 155.607L67.8827 154.896C70.1693 153.981 71.981 152.169 72.8958 149.883L73.6064 148.107L74.3171 149.883C75.2318 152.169 77.0436 153.981 79.3302 154.896L81.1064 155.607L79.3302 156.317C77.0436 157.232 75.2318 159.044 74.3171 161.33L73.6064 163.107L72.8958 161.33Z"
        stroke="#75A4FE"
        stroke-width="2.5"
        stroke-linejoin="round"
      />
      <path
        d="M137.897 62.3297L138.98 62.9547L139.605 61.8722L140.958 59.5275C142.463 56.922 145.794 56.0293 148.4 57.5336C151.005 59.0378 151.898 62.3694 150.394 64.9749L149.04 67.3196L148.415 68.4022L149.497 69.0272C159.532 74.8206 162.97 87.6516 157.176 97.686L143.782 120.887C141.881 124.179 142.98 128.38 146.231 130.325L142.583 136.643C142.376 137.002 141.917 137.125 141.558 136.917L80.3569 101.583C79.9982 101.376 79.8753 100.917 80.0824 100.558L83.7136 94.2689C83.717 94.2631 83.7196 94.2607 83.7215 94.2593C83.7241 94.2574 83.7281 94.2552 83.7333 94.2538C83.7386 94.2524 83.7431 94.2523 83.7464 94.2527C83.7487 94.253 83.7521 94.2536 83.758 94.257L84.27 94.5527C87.6521 96.5053 91.9768 95.3465 93.9295 91.9644L106.124 70.8434C112.547 59.7184 126.772 55.9067 137.897 62.3297Z"
        fill="white"
        stroke="#126ADF"
        stroke-width="2.5"
      />
      <mask id="path-5-inside-1_737_62955" fill="white">
        <path d="M110.661 127.806C109.451 129.901 109.124 132.39 109.75 134.726C110.376 137.063 111.904 139.055 113.999 140.264C116.094 141.473 118.583 141.801 120.919 141.175C123.256 140.549 125.248 139.021 126.457 136.926L118.559 132.366L110.661 127.806Z" />
      </mask>
      <path
        d="M110.661 127.806C109.451 129.901 109.124 132.39 109.75 134.726C110.376 137.063 111.904 139.055 113.999 140.264C116.094 141.473 118.583 141.801 120.919 141.175C123.256 140.549 125.248 139.021 126.457 136.926L118.559 132.366L110.661 127.806Z"
        fill="#E8F0FE"
        stroke="#126ADF"
        stroke-width="4"
        mask="url(#path-5-inside-1_737_62955)"
      />
      <circle
        cx="168.462"
        cy="93.6945"
        r="2.70496"
        fill="#E8F0FE"
        stroke="#126ADF"
        stroke-width="2"
      />
      <circle
        cx="84.1029"
        cy="84.5746"
        r="2.70496"
        stroke="#126ADF"
        stroke-width="2"
      />
      <path
        d="M156 96C130.8 94 131.833 73.8334 134.5 62.5C120.1 57.7 111.333 65 108 70C105.333 75 98.7 86.3 95.5 91.5C92.3 96.7 86.3333 96.5 84 95.5L81 101L142 136L145 130.5L143.49 129.141C141.44 127.296 140.912 124.291 142.209 121.857L156 96Z"
        fill="#E8F0FE"
        stroke="#F3F7FF"
      />
    </svg>
  );
}

export function Logout() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M20.8962 2C21.4065 2 21.8271 2.38604 21.8845 2.88338L21.8912 3V21C21.8912 21.5128 21.5071 21.9355 21.0122 21.9933L20.8962 22H14.9259C14.3763 22 13.9308 21.5523 13.9308 21C13.9308 20.4872 14.315 20.0645 14.8098 20.0067L14.9259 20H19.9011V4H14.9259C14.4156 4 13.995 3.61396 13.9375 3.11662L13.9308 3C13.9308 2.48716 14.315 2.06449 14.8098 2.00673L14.9259 2H20.8962ZM10.5605 6.2097L10.6542 6.29289L15.6295 11.2929C15.9882 11.6534 16.0158 12.2206 15.7123 12.6129L15.6295 12.7071L10.6542 17.7071C10.2656 18.0976 9.63562 18.0976 9.24702 17.7071C8.88832 17.3466 8.86073 16.7794 9.16425 16.3871L9.24702 16.2929L12.5228 13H2.98528C2.43573 13 1.99023 12.5523 1.99023 12C1.99023 11.4872 2.37436 11.0645 2.86924 11.0067L2.98528 11H12.5228L9.24702 7.70711C8.88832 7.34662 8.86073 6.77939 9.16425 6.3871L9.24702 6.29289C9.57583 5.96245 10.0775 5.91161 10.4595 6.14038L10.5605 6.2097Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function TotalPatients() {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_183_5678)">
        <rect
          x="0.424805"
          width="48"
          height="48"
          rx="24"
          fill="#00CFE8"
          fill-opacity="0.12"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24 16C21.9289 16 20.25 17.6789 20.25 19.75C20.25 21.8211 21.9289 23.5 24 23.5C26.0711 23.5 27.75 21.8211 27.75 19.75C27.75 17.6789 26.0711 16 24 16ZM21.75 19.75C21.75 18.5074 22.7574 17.5 24 17.5C25.2426 17.5 26.25 18.5074 26.25 19.75C26.25 20.9926 25.2426 22 24 22C22.7574 22 21.75 20.9926 21.75 19.75Z"
          fill="#00BCC1"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21 25C18.9289 25 17.25 26.6789 17.25 28.75C17.25 30.8211 18.9289 32.5 21 32.5H27C29.0711 32.5 30.75 30.8211 30.75 28.75C30.75 26.6789 29.0711 25 27 25H21ZM18.75 28.75C18.75 27.5074 19.7574 26.5 21 26.5H27C28.2426 26.5 29.25 27.5074 29.25 28.75C29.25 29.9926 28.2426 31 27 31H21C19.7574 31 18.75 29.9926 18.75 28.75Z"
          fill="#00BCC1"
        />
        <path
          d="M19.7521 22.3887C19.5944 22.1353 19.2985 22 19 22C17.7574 22 16.75 20.9926 16.75 19.75C16.75 18.5074 17.7574 17.5 19 17.5C19.2985 17.5 19.5944 17.3647 19.7521 17.1113C19.7591 17.1001 19.7661 17.089 19.7732 17.0778C20.0358 16.6633 19.9027 16.0764 19.415 16.0227C19.2787 16.0077 19.1403 16 19 16C16.9289 16 15.25 17.6789 15.25 19.75C15.25 21.8211 16.9289 23.5 19 23.5C19.1403 23.5 19.2787 23.4923 19.415 23.4773C19.9027 23.4236 20.0358 22.8367 19.7732 22.4222C19.7661 22.411 19.7591 22.3999 19.7521 22.3887Z"
          fill="#00BCC1"
        />
        <path
          d="M16.7083 30.3169C16.5948 30.1275 16.3944 30 16.1736 30H16C14.7574 30 13.75 28.9926 13.75 27.75C13.75 26.5074 14.7574 25.5 16 25.5H16.1736C16.3944 25.5 16.5948 25.3725 16.7083 25.1831C16.9854 24.7208 16.6847 24 16.1457 24H16C13.9289 24 12.25 25.6789 12.25 27.75C12.25 29.8211 13.9289 31.5 16 31.5H16.1457C16.6847 31.5 16.9854 30.7792 16.7083 30.3169Z"
          fill="#00BCC1"
        />
        <path
          d="M28.2268 22.4222C27.9642 22.8367 28.0973 23.4236 28.585 23.4773C28.7213 23.4923 28.8597 23.5 29 23.5C31.0711 23.5 32.75 21.8211 32.75 19.75C32.75 17.6789 31.0711 16 29 16C28.8597 16 28.7213 16.0077 28.585 16.0227C28.0973 16.0764 27.9642 16.6633 28.2268 17.0778C28.2339 17.089 28.2409 17.1001 28.2479 17.1113C28.4056 17.3647 28.7015 17.5 29 17.5C30.2426 17.5 31.25 18.5074 31.25 19.75C31.25 20.9926 30.2426 22 29 22C28.7015 22 28.4056 22.1353 28.2479 22.3887C28.2409 22.3999 28.2339 22.411 28.2268 22.4222Z"
          fill="#00BCC1"
        />
        <path
          d="M31.2917 30.3169C31.0146 30.7792 31.3153 31.5 31.8543 31.5H32C34.0711 31.5 35.75 29.8211 35.75 27.75C35.75 25.6789 34.0711 24 32 24H31.8543C31.3153 24 31.0146 24.7208 31.2917 25.1831C31.4052 25.3725 31.6056 25.5 31.8264 25.5H32C33.2426 25.5 34.25 26.5074 34.25 27.75C34.25 28.9926 33.2426 30 32 30H31.8264C31.6056 30 31.4052 30.1275 31.2917 30.3169Z"
          fill="#00BCC1"
        />
      </g>
      <defs>
        <clipPath id="clip0_183_5678">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(0.424805)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function TotalCare() {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_183_5666)">
        <rect
          x="0.30127"
          width="48"
          height="48"
          rx="24"
          fill="#EA5455"
          fill-opacity="0.12"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M24 16C21.9289 16 20.25 17.6789 20.25 19.75C20.25 21.8211 21.9289 23.5 24 23.5C26.0711 23.5 27.75 21.8211 27.75 19.75C27.75 17.6789 26.0711 16 24 16ZM21.75 19.75C21.75 18.5074 22.7574 17.5 24 17.5C25.2426 17.5 26.25 18.5074 26.25 19.75C26.25 20.9926 25.2426 22 24 22C22.7574 22 21.75 20.9926 21.75 19.75Z"
          fill="#FF5A4E"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M21 25C18.9289 25 17.25 26.6789 17.25 28.75C17.25 30.8211 18.9289 32.5 21 32.5H27C29.0711 32.5 30.75 30.8211 30.75 28.75C30.75 26.6789 29.0711 25 27 25H21ZM18.75 28.75C18.75 27.5074 19.7574 26.5 21 26.5H27C28.2426 26.5 29.25 27.5074 29.25 28.75C29.25 29.9926 28.2426 31 27 31H21C19.7574 31 18.75 29.9926 18.75 28.75Z"
          fill="#FF5A4E"
        />
        <path
          d="M19.7521 22.3887C19.5944 22.1353 19.2985 22 19 22C17.7574 22 16.75 20.9926 16.75 19.75C16.75 18.5074 17.7574 17.5 19 17.5C19.2985 17.5 19.5944 17.3647 19.7521 17.1113C19.7591 17.1001 19.7661 17.089 19.7732 17.0778C20.0358 16.6633 19.9027 16.0764 19.415 16.0227C19.2787 16.0077 19.1403 16 19 16C16.9289 16 15.25 17.6789 15.25 19.75C15.25 21.8211 16.9289 23.5 19 23.5C19.1403 23.5 19.2787 23.4923 19.415 23.4773C19.9027 23.4236 20.0358 22.8367 19.7732 22.4222C19.7661 22.411 19.7591 22.3999 19.7521 22.3887Z"
          fill="#FF5A4E"
        />
        <path
          d="M16.7083 30.3169C16.5948 30.1275 16.3944 30 16.1736 30H16C14.7574 30 13.75 28.9926 13.75 27.75C13.75 26.5074 14.7574 25.5 16 25.5H16.1736C16.3944 25.5 16.5948 25.3725 16.7083 25.1831C16.9854 24.7208 16.6847 24 16.1457 24H16C13.9289 24 12.25 25.6789 12.25 27.75C12.25 29.8211 13.9289 31.5 16 31.5H16.1457C16.6847 31.5 16.9854 30.7792 16.7083 30.3169Z"
          fill="#FF5A4E"
        />
        <path
          d="M28.2268 22.4222C27.9642 22.8367 28.0973 23.4236 28.585 23.4773C28.7213 23.4923 28.8597 23.5 29 23.5C31.0711 23.5 32.75 21.8211 32.75 19.75C32.75 17.6789 31.0711 16 29 16C28.8597 16 28.7213 16.0077 28.585 16.0227C28.0973 16.0764 27.9642 16.6633 28.2268 17.0778C28.2339 17.089 28.2409 17.1001 28.2479 17.1113C28.4056 17.3647 28.7015 17.5 29 17.5C30.2426 17.5 31.25 18.5074 31.25 19.75C31.25 20.9926 30.2426 22 29 22C28.7015 22 28.4056 22.1353 28.2479 22.3887C28.2409 22.3999 28.2339 22.411 28.2268 22.4222Z"
          fill="#FF5A4E"
        />
        <path
          d="M31.2917 30.3169C31.0146 30.7792 31.3153 31.5 31.8543 31.5H32C34.0711 31.5 35.75 29.8211 35.75 27.75C35.75 25.6789 34.0711 24 32 24H31.8543C31.3153 24 31.0146 24.7208 31.2917 25.1831C31.4052 25.3725 31.6056 25.5 31.8264 25.5H32C33.2426 25.5 34.25 26.5074 34.25 27.75C34.25 28.9926 33.2426 30 32 30H31.8264C31.6056 30 31.4052 30.1275 31.2917 30.3169Z"
          fill="#FF5A4E"
        />
      </g>
      <defs>
        <clipPath id="clip0_183_5666">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(0.30127)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function TotalFinance() {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <rect
          x="0.287598"
          width="48"
          height="48"
          rx="24"
          fill="#7367F0"
          fill-opacity="0.12"
        />
        <path
          d="M36.2876 18V24C36.2876 24.6 35.8876 25 35.2876 25C34.6876 25 34.2876 24.6 34.2876 24V20.4L26.4876 28.2C26.0876 28.6 25.4876 28.6 25.0876 28.2L20.7876 23.9L13.9876 30.7C13.7876 30.9 13.5876 31 13.2876 31C12.9876 31 12.7876 30.9 12.5876 30.7C12.1876 30.3 12.1876 29.7 12.5876 29.3L20.0876 21.8C20.4876 21.4 21.0876 21.4 21.4876 21.8L25.7876 26.1L32.8876 19H29.2876C28.6876 19 28.2876 18.6 28.2876 18C28.2876 17.4 28.6876 17 29.2876 17H35.2876C35.3876 17 35.5876 17 35.6876 17.1C35.8876 17.2 36.0876 17.4 36.1876 17.6C36.2876 17.7 36.2876 17.9 36.2876 18Z"
          fill="black"
        />
        <mask
          id="mask0_183_5694"
          style="mask-type:alpha"
          maskUnits="userSpaceOnUse"
          x="12"
          y="17"
          width="25"
          height="14"
        >
          <path
            d="M36.2876 18V24C36.2876 24.6 35.8876 25 35.2876 25C34.6876 25 34.2876 24.6 34.2876 24V20.4L26.4876 28.2C26.0876 28.6 25.4876 28.6 25.0876 28.2L20.7876 23.9L13.9876 30.7C13.7876 30.9 13.5876 31 13.2876 31C12.9876 31 12.7876 30.9 12.5876 30.7C12.1876 30.3 12.1876 29.7 12.5876 29.3L20.0876 21.8C20.4876 21.4 21.0876 21.4 21.4876 21.8L25.7876 26.1L32.8876 19H29.2876C28.6876 19 28.2876 18.6 28.2876 18C28.2876 17.4 28.6876 17 29.2876 17H35.2876C35.3876 17 35.5876 17 35.6876 17.1C35.8876 17.2 36.0876 17.4 36.1876 17.6C36.2876 17.7 36.2876 17.9 36.2876 18Z"
            fill="white"
          />
        </mask>
      </g>
      <defs>
        <clipPath id="clip0_183_5694">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(0.287598)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function TotalPlans() {
  return (
    <svg
      width="49"
      height="48"
      viewBox="0 0 49 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_183_5694)">
        <rect
          x="0.287598"
          width="48"
          height="48"
          rx="24"
          fill="#7367F0"
          fill-opacity="0.12"
        />
        <path
          d="M36.2876 18V24C36.2876 24.6 35.8876 25 35.2876 25C34.6876 25 34.2876 24.6 34.2876 24V20.4L26.4876 28.2C26.0876 28.6 25.4876 28.6 25.0876 28.2L20.7876 23.9L13.9876 30.7C13.7876 30.9 13.5876 31 13.2876 31C12.9876 31 12.7876 30.9 12.5876 30.7C12.1876 30.3 12.1876 29.7 12.5876 29.3L20.0876 21.8C20.4876 21.4 21.0876 21.4 21.4876 21.8L25.7876 26.1L32.8876 19H29.2876C28.6876 19 28.2876 18.6 28.2876 18C28.2876 17.4 28.6876 17 29.2876 17H35.2876C35.3876 17 35.5876 17 35.6876 17.1C35.8876 17.2 36.0876 17.4 36.1876 17.6C36.2876 17.7 36.2876 17.9 36.2876 18Z"
          fill="black"
        />
        <mask
          id="mask0_183_5694"
          style="mask-type:alpha"
          maskUnits="userSpaceOnUse"
          x="12"
          y="17"
          width="25"
          height="14"
        >
          <path
            d="M36.2876 18V24C36.2876 24.6 35.8876 25 35.2876 25C34.6876 25 34.2876 24.6 34.2876 24V20.4L26.4876 28.2C26.0876 28.6 25.4876 28.6 25.0876 28.2L20.7876 23.9L13.9876 30.7C13.7876 30.9 13.5876 31 13.2876 31C12.9876 31 12.7876 30.9 12.5876 30.7C12.1876 30.3 12.1876 29.7 12.5876 29.3L20.0876 21.8C20.4876 21.4 21.0876 21.4 21.4876 21.8L25.7876 26.1L32.8876 19H29.2876C28.6876 19 28.2876 18.6 28.2876 18C28.2876 17.4 28.6876 17 29.2876 17H35.2876C35.3876 17 35.5876 17 35.6876 17.1C35.8876 17.2 36.0876 17.4 36.1876 17.6C36.2876 17.7 36.2876 17.9 36.2876 18Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_183_5694)">
          <rect x="12.2876" y="12" width="24" height="24" fill="#7367F0" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_183_5694">
          <rect
            width="48"
            height="48"
            fill="white"
            transform="translate(0.287598)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function TotalMonth() {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_183_5650)">
        <rect
          width="48"
          height="48"
          rx="24"
          fill="#288EC7"
          fill-opacity="0.12"
        />
        <path
          d="M25.7299 15.51L27.4899 19.03C27.7299 19.52 28.3699 19.99 28.9099 20.08L32.0999 20.61C34.1399 20.95 34.6199 22.43 33.1499 23.89L30.6699 26.37C30.2499 26.79 30.0199 27.6 30.1499 28.18L30.8599 31.25C31.4199 33.68 30.1299 34.62 27.9799 33.35L24.9899 31.58C24.4499 31.26 23.5599 31.26 23.0099 31.58L20.0199 33.35C17.8799 34.62 16.5799 33.67 17.1399 31.25L17.8499 28.18C17.9799 27.6 17.7499 26.79 17.3299 26.37L14.8499 23.89C13.3899 22.43 13.8599 20.95 15.8999 20.61L19.0899 20.08C19.6199 19.99 20.2599 19.52 20.4999 19.03L22.2599 15.51C23.2199 13.6 24.7799 13.6 25.7299 15.51Z"
          stroke="#3B7AFE"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_183_5650">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function SearchIcon() {
  return (
    <svg
      width="17"
      height="17"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17C10.4845 17 12.3102 16.3199 13.7567 15.18L14.1601 15.5742L17.2929 18.7071L17.3871 18.7903C17.7794 19.0953 18.3466 19.0676 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L15.5661 14.1518L15.1721 13.7668C16.3167 12.3187 17 10.4892 17 8.5C17 3.80558 13.1944 0 8.5 0ZM8.5 2C12.0899 2 15 4.91015 15 8.5C15 12.0899 12.0899 15 8.5 15C4.91015 15 2 12.0899 2 8.5C2 4.91015 4.91015 2 8.5 2Z"
        fill="#0A1629"
      />
    </svg>
  );
}

export function DashboardNotification() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.3399 14.49L18.3399 12.83C18.1299 12.46 17.9399 11.76 17.9399 11.35V8.82C17.9399 6.47 16.5599 4.44 14.5699 3.49C14.0499 2.57 13.0899 2 11.9899 2C10.8999 2 9.91994 2.59 9.39994 3.52C7.44994 4.49 6.09994 6.5 6.09994 8.82V11.35C6.09994 11.76 5.90994 12.46 5.69994 12.82L4.68994 14.49C4.28994 15.16 4.19994 15.9 4.44994 16.58C4.68994 17.25 5.25994 17.77 5.99994 18.02C7.93994 18.68 9.97994 19 12.0199 19C14.0599 19 16.0999 18.68 18.0399 18.03C18.7399 17.8 19.2799 17.27 19.5399 16.58C19.7999 15.89 19.7299 15.13 19.3399 14.49Z"
        fill="#363636"
      />
      <path
        d="M14.8299 20.01C14.4099 21.17 13.2999 22 11.9999 22C11.2099 22 10.4299 21.68 9.87993 21.11C9.55993 20.81 9.31993 20.41 9.17993 20C9.30993 20.02 9.43993 20.03 9.57993 20.05C9.80993 20.08 10.0499 20.11 10.2899 20.13C10.8599 20.18 11.4399 20.21 12.0199 20.21C12.5899 20.21 13.1599 20.18 13.7199 20.13C13.9299 20.11 14.1399 20.1 14.3399 20.07C14.4999 20.05 14.6599 20.03 14.8299 20.01Z"
        fill="#363636"
      />
    </svg>
  );
}

export function ArrowDown() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16.7071 9.29289C17.0676 9.65338 17.0953 10.2206 16.7903 10.6129L16.7071 10.7071L12.7071 14.7071C12.3466 15.0676 11.7794 15.0953 11.3871 14.7903L11.2929 14.7071L7.29289 10.7071C6.90237 10.3166 6.90237 9.68342 7.29289 9.29289C7.65338 8.93241 8.22061 8.90468 8.6129 9.2097L8.70711 9.29289L12 12.585L15.2929 9.29289C15.6534 8.93241 16.2206 8.90468 16.6129 9.2097L16.7071 9.29289Z"
        fill="#989898"
      />
    </svg>
  );
}

export function PdfIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="38"
      height="50"
      viewBox="0 0 38 50"
      fill="none"
    >
      <path
        d="M0.9476 0C9.75777 0 18.5679 0 27.3781 0C27.3781 0.0563551 27.3781 0.131495 27.3781 0.18785C27.3781 3.47523 27.3781 6.76261 27.3781 10.0688C27.3781 10.482 27.4908 10.6135 27.9229 10.6135C31.0224 10.5947 34.1219 10.6135 37.2215 10.5947C37.3905 10.5947 37.5784 10.6511 37.7287 10.5008C38.0104 10.9329 37.9916 11.4589 37.9916 11.9285C38.0104 19.2734 37.9916 26.6184 37.9916 33.9633C37.9916 34.1324 37.9729 34.2827 37.9729 34.4517C37.785 34.3578 37.5972 34.3954 37.4093 34.3954C25.1427 34.3954 12.8761 34.3954 0.590684 34.3954C0.402834 34.3954 0.196199 34.3578 0.0271339 34.4517C0.0271339 34.2263 0.0083489 34.0009 0.0083489 33.7755C0.0083489 24.4581 0.0083489 15.1595 0.0083489 5.84214C0.0083489 4.56476 -0.0104361 3.26859 0.0083489 1.99121C0.0083489 1.20224 0.121059 0.41327 0.9476 0ZM20.5216 8.67868C20.5216 8.41569 20.5404 8.17148 20.5216 7.90849C20.4464 7.15709 19.6387 6.16149 19.0751 6.08635C18.1547 5.97364 17.4033 6.55597 17.1027 7.57036C16.9336 8.11513 16.9524 8.67868 17.0276 9.24223C17.1966 10.4445 17.6099 11.5716 18.0983 12.6799C18.2486 12.9992 18.2486 13.2998 18.1547 13.6567C17.3657 16.606 16.3325 19.4801 15.1115 22.279C14.9988 22.542 14.8297 22.7299 14.5667 22.8426C13.4021 23.3873 12.275 23.9885 11.2606 24.815C10.528 25.4161 9.87048 26.0736 9.68263 27.0504C9.53235 27.8018 10.002 28.7223 10.7534 29.1543C11.3921 29.53 12.1059 29.4361 12.7446 28.8726C13.0264 28.6284 13.2894 28.3842 13.5336 28.0836C14.5104 26.9001 15.1866 25.5288 15.8629 24.1575C15.9944 23.8945 16.1635 23.7443 16.4265 23.6316C18.6619 22.7111 20.9724 21.9597 23.3393 21.4149C23.715 21.321 23.9592 21.3961 24.241 21.6403C24.9548 22.2978 25.725 22.8614 26.6643 23.1619C28.0356 23.6128 29.4069 22.9177 29.8765 21.5652C30.1771 20.6823 29.8014 19.8933 28.9185 19.6116C28.5428 19.4988 28.1483 19.4049 27.735 19.3861C26.7206 19.3486 25.7062 19.4613 24.7106 19.6303C24.4477 19.6867 24.2786 19.6303 24.0907 19.4237C22.4377 17.564 21.1039 15.4789 19.9768 13.281C19.8829 13.0932 19.8641 12.9429 19.9017 12.7362C20.2022 11.3837 20.5216 10.05 20.5216 8.67868Z"
        fill="#E8E8DF"
      />
      <path
        d="M37.9542 34.452C37.9542 38.8477 37.9542 43.2433 37.9354 47.6578C37.9354 48.9352 37.5033 49.3673 36.2447 49.3673C24.7295 49.3673 13.2143 49.3673 1.69907 49.3673C0.440478 49.3673 0.00842285 48.9352 0.00842285 47.6578C0.00842285 43.2621 0.00842285 38.8664 0.00842285 34.452C0.196273 34.358 0.384123 34.3956 0.571973 34.3956C12.8386 34.3956 25.1052 34.3956 37.3906 34.3956C37.5785 34.3956 37.7851 34.358 37.9542 34.452ZM15.5248 42.2477C15.5248 43.619 15.5248 44.9716 15.5248 46.3429C15.5248 46.6246 15.6 46.7374 15.9005 46.7374C16.8774 46.7186 17.8542 46.7561 18.831 46.7186C20.3714 46.6622 21.5736 46.0047 22.2311 44.5395C22.5504 43.8257 22.6444 43.0743 22.7007 42.2853C22.8322 40.2377 21.4985 38.3968 19.4885 37.9648C18.3238 37.7206 17.1216 37.8333 15.9381 37.7957C15.6 37.7769 15.5061 37.9084 15.5061 38.2277C15.5436 39.5991 15.5248 40.914 15.5248 42.2477ZM8.1799 42.2853C8.1799 43.4312 8.1799 44.5583 8.1799 45.7042C8.1799 46.7561 8.1799 46.7561 9.25065 46.7374C9.58878 46.7374 9.64514 46.6059 9.64514 46.3053C9.62635 45.5539 9.66392 44.8025 9.62635 44.0511C9.60757 43.619 9.73906 43.4688 10.1711 43.5063C11.0164 43.5627 11.843 43.4876 12.5756 43.0179C13.5524 42.398 14.022 41.1582 13.7591 39.9935C13.5148 38.9416 12.4441 38.0399 11.2606 37.9084C10.3778 37.7957 9.49486 37.8896 8.61196 37.8333C8.23626 37.8145 8.16112 37.9648 8.1799 38.3029C8.19869 39.6178 8.1799 40.9516 8.1799 42.2853ZM24.7859 42.2665C24.7859 43.4124 24.7859 44.5395 24.7859 45.6854C24.7859 46.7561 24.7859 46.7374 25.8378 46.7374C26.2135 46.7374 26.2887 46.6059 26.2887 46.2677C26.2699 45.2158 26.2887 44.1826 26.2699 43.1306C26.2699 42.7925 26.3638 42.6986 26.7019 42.6986C27.6036 42.7174 28.5053 42.6986 29.407 42.7174C29.7827 42.7174 30.0081 42.7174 30.0081 42.2102C30.0081 41.703 29.7827 41.7218 29.4258 41.7218C28.5053 41.7405 27.6036 41.7218 26.6831 41.7405C26.3638 41.7405 26.2699 41.6466 26.2699 41.3273C26.2887 40.651 26.2887 39.9748 26.2699 39.2985C26.2511 38.9979 26.3638 38.9228 26.6644 38.9228C27.7539 38.9416 28.8434 38.904 29.9329 38.9416C30.4589 38.9604 30.3462 38.6598 30.365 38.3592C30.3838 38.0399 30.4214 37.7769 29.9142 37.7957C28.355 37.8333 26.7959 37.8145 25.2367 37.7957C24.8234 37.7957 24.7671 37.9272 24.7671 38.3029C24.8046 39.6366 24.7859 40.9516 24.7859 42.2665Z"
        fill="#CB4B4C"
      />
      <path
        d="M20.5217 8.67868C20.5217 10.05 20.2024 11.3837 19.9206 12.7175C19.883 12.9241 19.9018 13.0744 19.9957 13.2622C21.1228 15.4789 22.4566 17.5452 24.1096 19.4049C24.2975 19.6116 24.4666 19.6679 24.7296 19.6116C25.7252 19.4425 26.7395 19.3298 27.7539 19.3674C28.1672 19.3861 28.5617 19.4613 28.9374 19.5928C29.8203 19.8745 30.196 20.6635 29.8954 21.5464C29.4258 22.9177 28.0733 23.594 26.6832 23.1431C25.7439 22.8426 24.9738 22.279 24.2599 21.6216C23.9969 21.3773 23.7339 21.3022 23.3582 21.3961C20.9913 21.9597 18.6996 22.6923 16.4454 23.6128C16.1824 23.7255 15.9945 23.8758 15.8818 24.1387C15.2056 25.5101 14.5293 26.8814 13.5525 28.0648C13.3083 28.3466 13.0453 28.6096 12.7635 28.8538C12.1248 29.4173 11.411 29.5113 10.7723 29.1356C10.0209 28.7035 9.55126 27.783 9.70154 27.0316C9.88939 26.0548 10.5469 25.3973 11.2795 24.7962C12.2751 23.9885 13.4022 23.3686 14.5856 22.8238C14.8486 22.7111 15.0177 22.5232 15.1304 22.2602C16.3514 19.4613 17.3846 16.5872 18.1736 13.6379C18.2675 13.281 18.2675 12.9992 18.1172 12.6611C17.61 11.5528 17.2155 10.4257 17.0465 9.22344C16.9713 8.65989 16.9526 8.09634 17.1216 7.55158C17.4222 6.53719 18.1736 5.95485 19.094 6.06756C19.6764 6.1427 20.4841 7.13831 20.5405 7.88971C20.5405 8.17148 20.5217 8.41569 20.5217 8.67868ZM13.6464 25.0216C12.9701 25.341 12.3878 25.773 11.843 26.2802C11.5988 26.4869 11.3734 26.7311 11.2419 27.0316C11.1104 27.3134 11.1668 27.5576 11.411 27.7643C11.6928 27.9897 11.8242 27.7267 11.9557 27.5952C12.6884 26.8626 13.2707 26.036 13.7027 25.0968C13.7215 25.078 13.7591 25.0404 13.7591 25.0404C13.7028 24.9653 13.6652 25.0029 13.6464 25.0216ZM16.9338 21.8094C18.8498 21.058 20.7096 20.4945 22.6632 20.006C21.3858 18.4845 20.3151 16.8877 19.3007 15.1219C18.6056 17.4325 17.8542 19.5928 16.9338 21.8094ZM18.7747 7.70186C18.0233 8.45326 18.0984 10.0124 18.8686 10.4069C19.2255 9.48644 19.4134 8.60354 18.7747 7.70186ZM25.8754 20.9453C26.2511 21.2271 26.4953 21.4525 26.7959 21.6403C27.2467 21.9033 27.9794 21.7718 28.2799 21.3961C28.4866 21.1331 28.5053 20.9641 28.0921 20.8889C27.397 20.7762 26.702 20.8514 25.8754 20.9453Z"
        fill="#CC4D4E"
      />
      <path
        d="M27.3782 0.1875C27.4721 0.26264 27.5848 0.33778 27.6787 0.431705C30.9473 3.7003 34.2159 6.96889 37.4845 10.2375C37.5596 10.3126 37.6348 10.4065 37.7099 10.5005C37.5596 10.6508 37.3718 10.5944 37.2027 10.5944C34.1032 10.5944 31.0037 10.5944 27.9041 10.6132C27.4721 10.6132 27.3594 10.4817 27.3594 10.0684C27.3782 6.78104 27.3782 3.49366 27.3782 0.1875Z"
        fill="#D8D6C9"
      />
      <path
        d="M15.5248 42.248C15.5248 40.9143 15.5436 39.5805 15.5248 38.2468C15.5248 37.9275 15.5999 37.796 15.9568 37.8147C17.1403 37.8523 18.3425 37.7208 19.5072 37.9838C21.5172 38.4159 22.8509 40.2568 22.7194 42.3044C22.6631 43.0745 22.5692 43.8447 22.2498 44.5586C21.5923 46.0238 20.3901 46.6813 18.8497 46.7376C17.8729 46.7752 16.8961 46.7376 15.9193 46.7564C15.6187 46.7564 15.5436 46.6625 15.5436 46.3619C15.5248 44.9906 15.5248 43.6193 15.5248 42.248ZM16.9712 42.2856C16.9712 43.2812 16.9712 44.2768 16.9712 45.2724C16.9712 45.573 17.0652 45.6669 17.3469 45.6669C17.8729 45.6293 18.3989 45.6669 18.9249 45.6105C19.6951 45.5354 20.315 45.1785 20.6531 44.4834C21.2354 43.2812 21.3294 42.0226 20.9724 40.7452C20.8034 40.1253 20.3713 39.6932 19.8265 39.3927C19.0564 38.9794 18.2298 38.9606 17.4033 38.9418C17.0839 38.9418 16.9524 39.017 16.9712 39.3551C16.99 40.3319 16.9712 41.3088 16.9712 42.2856Z"
        fill="#FDFAFA"
      />
      <path
        d="M8.17993 42.2854C8.17993 40.9516 8.19872 39.6179 8.17993 38.2842C8.17993 37.946 8.23629 37.7958 8.61199 37.8146C9.49488 37.8521 10.3778 37.777 11.2607 37.8897C12.4629 38.04 13.5149 38.9229 13.7591 39.9748C14.0221 41.1395 13.5524 42.3793 12.5756 42.9992C11.843 43.4688 10.9977 43.544 10.1711 43.4876C9.7203 43.4501 9.60759 43.6003 9.62638 44.0324C9.66395 44.7838 9.62638 45.5352 9.64516 46.2866C9.64516 46.5684 9.60759 46.7186 9.25068 46.7186C8.17993 46.7186 8.17993 46.7374 8.17993 45.6855C8.17993 44.5584 8.17993 43.4125 8.17993 42.2854ZM9.62638 40.6887C9.62638 40.8577 9.62638 41.008 9.62638 41.1771C9.62638 42.5296 9.62638 42.5296 10.9789 42.4357C11.843 42.3793 12.3126 41.9097 12.4253 40.9892C12.5568 39.9748 12.1811 39.2798 11.3734 39.0356C10.8662 38.8853 10.359 38.9792 9.8518 38.9417C9.62638 38.9417 9.66395 39.1107 9.66395 39.2422C9.62638 39.7306 9.62638 40.2002 9.62638 40.6887Z"
        fill="#FDFBFB"
      />
      <path
        d="M24.7856 42.266C24.7856 40.951 24.8044 39.6361 24.7856 38.3211C24.7856 37.9642 24.842 37.8139 25.2553 37.8139C26.8144 37.8327 28.3736 37.8515 29.9327 37.8139C30.4211 37.7952 30.3836 38.0581 30.3836 38.3775C30.3648 38.6593 30.4775 38.9786 29.9515 38.9598C28.862 38.9223 27.7725 38.9598 26.6829 38.941C26.4012 38.941 26.2884 39.0162 26.2884 39.3167C26.3072 39.993 26.3072 40.6693 26.2884 41.3455C26.2697 41.6649 26.3824 41.7588 26.7017 41.7588C27.6222 41.74 28.5239 41.7588 29.4443 41.74C29.8012 41.74 30.0267 41.7212 30.0267 42.2284C30.0267 42.7356 29.8012 42.7544 29.4255 42.7356C28.5239 42.7168 27.6222 42.7356 26.7205 42.7168C26.3824 42.7168 26.2697 42.792 26.2884 43.1489C26.3072 44.2008 26.2884 45.234 26.3072 46.286C26.3072 46.6241 26.2509 46.7744 25.8564 46.7556C24.8044 46.7368 24.8044 46.7556 24.8044 45.7036C24.7856 44.539 24.7856 43.3931 24.7856 42.266Z"
        fill="#FCF7F7"
      />
      <path
        d="M16.9336 21.8098C17.8541 19.5744 18.6242 17.4329 19.3005 15.1411C20.3149 16.9069 21.3856 18.5036 22.663 20.0252C20.7094 20.5136 18.8497 21.0584 16.9336 21.8098Z"
        fill="#E8E6DD"
      />
      <path
        d="M13.6838 25.0786C13.2517 26.0178 12.6694 26.8631 11.9368 27.577C11.8053 27.7085 11.655 27.9902 11.392 27.746C11.1478 27.5394 11.1102 27.2952 11.2229 27.0134C11.3544 26.7129 11.5986 26.4874 11.8241 26.262C12.3688 25.7736 12.9512 25.3228 13.6274 25.0034C13.665 25.041 13.665 25.0598 13.6838 25.0786Z"
        fill="#E7E2DA"
      />
      <path
        d="M18.7747 7.70215C19.3946 8.58504 19.2067 9.48673 18.8686 10.4072C18.0984 10.0127 18.0233 8.45355 18.7747 7.70215Z"
        fill="#E7E2D9"
      />
      <path
        d="M25.8752 20.9459C26.7206 20.852 27.4156 20.7769 28.1107 20.8896C28.5239 20.9459 28.5051 21.1338 28.2985 21.3968C27.9979 21.7725 27.2653 21.904 26.8145 21.641C26.4951 21.4719 26.2509 21.2277 25.8752 20.9459Z"
        fill="#E7E0D7"
      />
      <path
        d="M13.6462 25.0209C13.6838 24.9833 13.7026 24.9646 13.7402 25.0209C13.7402 25.0209 13.7026 25.0585 13.6838 25.0773C13.665 25.0585 13.665 25.0397 13.6462 25.0209Z"
        fill="#E7E2DA"
      />
      <path
        d="M16.9713 42.2854C16.9713 41.3085 16.9901 40.3317 16.9713 39.3549C16.9713 38.998 17.084 38.9228 17.4033 38.9416C18.2487 38.9604 19.0752 38.9604 19.8266 39.3925C20.3902 39.693 20.8034 40.1251 20.9725 40.745C21.3294 42.0224 21.2355 43.281 20.6532 44.4832C20.315 45.197 19.6951 45.5352 18.9249 45.6103C18.399 45.6667 17.873 45.6291 17.347 45.6667C17.0464 45.6854 16.9525 45.5727 16.9713 45.2722C16.9901 44.2766 16.9713 43.281 16.9713 42.2854Z"
        fill="#CC4D4E"
      />
      <path
        d="M9.62644 40.6876C9.62644 40.1991 9.62644 39.7295 9.62644 39.2411C9.62644 39.1096 9.58887 38.9218 9.81429 38.9405C10.3215 38.9593 10.8475 38.8654 11.3359 39.0345C12.1436 39.2787 12.5193 39.9737 12.3878 40.9881C12.2751 41.9086 11.8055 42.3782 10.9414 42.4346C9.58887 42.5285 9.58887 42.5285 9.58887 41.176C9.62644 41.0069 9.62644 40.8566 9.62644 40.6876Z"
        fill="#CC4C4D"
      />
    </svg>
  );
}

export function Profilearrow() {
  return (
    <svg
      width="10"
      height="6"
      viewBox="0 0 10 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.70711 0.292893C10.0676 0.653377 10.0953 1.22061 9.7903 1.6129L9.70711 1.70711L5.70711 5.70711C5.34662 6.06759 4.77939 6.09532 4.3871 5.7903L4.29289 5.70711L0.292893 1.70711C-0.0976305 1.31658 -0.0976305 0.683418 0.292893 0.292893C0.653378 -0.0675907 1.22061 -0.0953203 1.6129 0.209705L1.70711 0.292893L5 3.585L8.29289 0.292893C8.65338 -0.0675907 9.22061 -0.0953203 9.6129 0.209705L9.70711 0.292893Z"
        fill="#0A1629"
      />
    </svg>
  );
}

export function MainLogo() {
  return (
    <svg
      width="150"
      height="60"
      viewBox="0 0 150 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_33_151)">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.7979 29.1291L40.1813 48.5126L57.5658 31.1281L28.7907 2.35297L22.7037 8.43991L45.3918 31.1281L39.8728 36.6473L26.5762 23.3506L20.7979 29.1291Z"
          fill="#3B7AFE"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M0.015625 31.1281L17.2419 13.9019L23.3289 19.9888L12.1896 31.1281L34.8778 53.8163L28.7908 59.9032L0.015625 31.1281Z"
          fill="#3B7AFE"
        />
        <path
          d="M73.55 27.4598C75.8883 25.0932 78.7253 23.9099 82.0614 23.9099C85.4261 23.9099 88.2777 25.0932 90.6158 27.4598C92.9539 29.8266 94.123 32.678 94.123 36.0141C94.123 36.7271 94.066 37.5967 93.9519 38.6232H77.4422C77.7843 39.5641 78.4188 40.3268 79.3454 40.9115C80.2723 41.496 81.377 41.7883 82.6602 41.7883C84.7134 41.7883 86.3101 41.218 87.4507 40.0773L92.9682 43.5846C91.8561 44.9818 90.352 46.101 88.4557 46.9421C86.5596 47.7834 84.6278 48.204 82.6602 48.204C78.9819 48.204 75.9522 47.0276 73.5713 44.6754C71.1905 42.3229 70 39.4358 70 36.0141C70 32.678 71.1833 29.8266 73.55 27.4598ZM142.663 47.5364V24.3432H149.592V47.5364H142.663ZM118.906 15.354H138.494V22.454H126.263V28.6314H138.118V35.7314H126.263V47.5364H118.906V15.354ZM96.1516 30.5159V24.5359H113.877V29.596L104.906 41.2216H114.462V47.5364H95.912V42.8109L105.031 30.5159H96.1516ZM77.4849 33.4625H86.9374C86.7093 32.513 86.1603 31.7075 85.2907 31.0462C84.4211 30.385 83.3588 30.0543 82.1043 30.0543C80.8781 30.0543 79.8587 30.385 79.0461 31.0462C78.2335 31.7075 77.7131 32.513 77.4849 33.4625Z"
          fill="#3B7AFE"
        />
        <path
          d="M143.226 15.3511C142.419 16.1735 142.016 17.1481 142.016 18.2749C142.016 19.402 142.419 20.3691 143.226 21.1762C144.034 21.9833 145.001 22.3869 146.127 22.3869C147.254 22.3869 148.229 21.9758 149.052 21.1533C149.843 20.3615 150.239 19.402 150.239 18.2749C150.239 17.1481 149.836 16.1735 149.029 15.3511C148.221 14.5288 147.254 14.1177 146.128 14.1177C145.001 14.1177 144.034 14.5288 143.226 15.3511Z"
          fill="#5FBF24"
        />
      </g>
      <defs>
        <clipPath id="clip0_33_151">
          <rect width="150" height="60" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function Eye() {
  return (
    <svg
      width="18"
      height="14"
      viewBox="0 0 18 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_33_215)">
        <path
          d="M9.00003 7.63622C8.37423 7.63622 7.76249 7.82283 7.24216 8.17246C6.72182 8.52209 6.31628 9.01904 6.07679 9.60045C5.83731 10.1819 5.77465 10.8216 5.89674 11.4389C6.01882 12.0561 6.32018 12.6231 6.76268 13.0681C7.20519 13.513 7.76898 13.8161 8.38275 13.9389C8.99653 14.0616 9.63272 13.9986 10.2109 13.7578C10.789 13.517 11.2832 13.1091 11.6309 12.5859C11.9786 12.0626 12.1641 11.4474 12.1641 10.8181C12.1632 9.97451 11.8296 9.16572 11.2364 8.5692C10.6432 7.97268 9.83892 7.63715 9.00003 7.63622ZM9.00003 12.5856C8.65241 12.5856 8.31259 12.4819 8.02355 12.2877C7.73451 12.0935 7.50924 11.8175 7.37621 11.4945C7.24318 11.1715 7.20837 10.8162 7.27619 10.4733C7.34401 10.1304 7.51141 9.81549 7.75721 9.5683C8.00302 9.32111 8.31619 9.15277 8.65714 9.08458C8.99808 9.01638 9.35148 9.05138 9.67265 9.18516C9.99381 9.31893 10.2683 9.54547 10.4614 9.83614C10.6546 10.1268 10.7576 10.4685 10.7576 10.8181C10.757 11.2867 10.5717 11.7359 10.2422 12.0672C9.91269 12.3986 9.46599 12.585 9.00003 12.5856Z"
          fill="#899CA8"
        />
        <path
          d="M17.9243 9.14317C17.1201 7.56798 15.8873 6.25504 14.3696 5.35733L16.273 3.44322C16.3389 3.3777 16.3913 3.29974 16.4271 3.2138C16.4629 3.12787 16.4815 3.03566 16.4817 2.94249C16.482 2.84931 16.4639 2.757 16.4286 2.67086C16.3932 2.58473 16.3413 2.50647 16.2758 2.44058C16.2103 2.3747 16.1325 2.32248 16.0468 2.28695C15.9612 2.25141 15.8694 2.23325 15.7767 2.23351C15.6841 2.23377 15.5924 2.25245 15.5069 2.28847C15.4215 2.32448 15.3439 2.37713 15.2788 2.44339L13.0459 4.68883C11.9814 4.24745 10.8522 3.9847 9.70313 3.91106V0.707C9.70313 0.519492 9.62906 0.339663 9.49721 0.207075C9.36537 0.0744867 9.18655 0 9.00009 0C8.81363 0 8.6348 0.0744867 8.50296 0.207075C8.37111 0.339663 8.29704 0.519492 8.29704 0.707V3.91183C7.14798 3.98547 6.01873 4.24822 4.95428 4.68961L2.72178 2.44378C2.65663 2.37752 2.5791 2.32487 2.49364 2.28886C2.40819 2.25284 2.3165 2.23416 2.22384 2.2339C2.13119 2.23364 2.03939 2.2518 1.95374 2.28734C1.86809 2.32287 1.79026 2.37509 1.72475 2.44097C1.65923 2.50686 1.60731 2.58512 1.57197 2.67125C1.53663 2.75739 1.51857 2.8497 1.51883 2.94287C1.51909 3.03605 1.53766 3.12826 1.57348 3.21419C1.6093 3.30013 1.66165 3.3781 1.72754 3.44361L3.63094 5.35772C2.11373 6.25549 0.881375 7.56828 0.0774266 9.14317C0.00253317 9.30922 -0.00566888 9.49795 0.0545334 9.66994C0.114736 9.84193 0.238687 9.98388 0.400499 10.0661C0.562312 10.1484 0.749473 10.1646 0.922894 10.1114C1.09631 10.0582 1.24258 9.93966 1.33115 9.78056C2.63554 7.18278 5.5417 5.30289 9.00009 5.30289C12.4585 5.30289 15.3662 7.18511 16.6675 9.78056C16.7091 9.86344 16.7665 9.93727 16.8365 9.99783C16.9065 10.0584 16.9877 10.1045 17.0754 10.1335C17.1631 10.1625 17.2556 10.1739 17.3477 10.1669C17.4398 10.16 17.5296 10.1349 17.612 10.093C17.6944 10.0512 17.7679 9.99341 17.8281 9.92302C17.8883 9.85264 17.9342 9.77101 17.963 9.68281C17.9919 9.59461 18.0032 9.50155 17.9962 9.40896C17.9893 9.31637 17.9644 9.22605 17.9227 9.14317H17.9243Z"
          fill="#899CA8"
        />
      </g>
      <defs>
        <clipPath id="clip0_33_215">
          <rect width="18" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function Close() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.3814 0.813768C10.0765 0.528675 9.59944 0.528162 9.29394 0.812599L5.3335 4.50002L1.37306 0.8126C1.06756 0.528163 0.590499 0.528676 0.28563 0.813769C-0.0449231 1.12288 -0.0443505 1.64302 0.286882 1.95142L4.17884 5.57508L0.286883 9.19874C-0.0443493 9.50714 -0.0449218 10.0273 0.285631 10.3364C0.590501 10.6215 1.06756 10.622 1.37306 10.3376L5.3335 6.65014L9.29394 10.3376C9.59943 10.622 10.0765 10.6215 10.3814 10.3364C10.7119 10.0273 10.7113 9.50714 10.3801 9.19874L6.48816 5.57508L10.3801 1.95142C10.7113 1.64302 10.7119 1.12288 10.3814 0.813768Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function EyeClose() {
  return (
    <svg
      width="19"
      height="15"
      viewBox="0 0 19 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.0618 7.82444L8.87356 9.05333C8.91227 9.04944 8.95097 9.04944 8.99355 9.04944C9.34148 9.04906 9.68171 9.15235 9.97121 9.34624C10.2607 9.54014 10.4865 9.81593 10.62 10.1388C10.7535 10.4616 10.7887 10.8169 10.7212 11.1599C10.6537 11.5028 10.4865 11.8179 10.2408 12.0654C9.99502 12.3128 9.68175 12.4815 9.34058 12.5501C8.99941 12.6187 8.64566 12.5841 8.32407 12.4506C8.00248 12.3172 7.72749 12.091 7.53387 11.8005C7.34025 11.5101 7.2367 11.1685 7.23632 10.8189C7.23568 10.7955 7.23697 10.7721 7.24019 10.7489L6.04419 11.9817C6.23738 12.4779 6.55144 12.9174 6.95758 13.26C7.36373 13.6027 7.84897 13.8374 8.36883 13.9427C8.88868 14.0479 9.42653 14.0204 9.93306 13.8627C10.4396 13.7049 10.8986 13.4219 11.268 13.0397C11.6375 12.6574 11.9055 12.1881 12.0476 11.6747C12.1896 11.1614 12.2011 10.6204 12.0811 10.1014C11.9611 9.58239 11.7133 9.10197 11.3605 8.70416C11.0077 8.30634 10.5612 8.00386 10.0618 7.82444Z"
        fill="#899CA8"
      />
      <path
        d="M10.7238 5.46778L11.8656 4.28556L11.8493 4.28128L15.0062 1.01461C15.1153 0.905231 15.1767 0.756778 15.1769 0.60191C15.177 0.447041 15.116 0.298443 15.0071 0.188806C14.8983 0.079168 14.7505 0.0174718 14.5964 0.0172895C14.4422 0.0171072 14.2943 0.0784536 14.1852 0.187833L10.5039 3.99894C10.2369 3.96006 9.96825 3.92933 9.69808 3.91222V0.707778C9.69808 0.520063 9.62387 0.340037 9.49176 0.207303C9.35965 0.0745692 9.18047 0 8.99364 0C8.80682 0 8.62764 0.0745692 8.49553 0.207303C8.36342 0.340037 8.2892 0.520063 8.2892 0.707778V3.91222C7.13951 3.98499 6.00963 4.24778 4.94505 4.69L2.71174 2.44222C2.57972 2.31163 2.40182 2.23851 2.21656 2.2387C2.03129 2.23888 1.85354 2.31235 1.72178 2.44321C1.59001 2.57406 1.51483 2.75178 1.51248 2.93791C1.51014 3.12404 1.58083 3.30362 1.70926 3.43778C1.71314 3.44167 1.71314 3.44167 1.71701 3.44167L3.62132 5.35889C2.10322 6.25667 0.869789 7.56877 0.0642805 9.14278C-0.011707 9.30886 -0.0206783 9.49807 0.0392509 9.67067C0.0991801 9.84326 0.223346 9.9858 0.385669 10.0684C0.547991 10.1509 0.735838 10.167 0.909753 10.1134C1.08367 10.0597 1.23012 9.94042 1.31834 9.78055C2.62272 7.18278 5.53337 5.30444 8.99364 5.30444C9.07454 5.30444 9.15195 5.31339 9.23207 5.31533L1.82229 12.9889C1.71332 13.0982 1.65204 13.2466 1.65193 13.4013C1.65182 13.556 1.71289 13.7044 1.8217 13.8139C1.93052 13.9234 2.07816 13.985 2.23215 13.9851C2.38615 13.9852 2.53388 13.9238 2.64284 13.8145L10.7056 5.46506L10.7238 5.46778Z"
        fill="#899CA8"
      />
      <path
        d="M17.9269 9.14278C17.1225 7.56798 15.8888 6.25561 14.3698 5.35889L16.2741 3.44167C16.4066 3.30965 16.4814 3.13018 16.4821 2.94275C16.4828 2.75532 16.4094 2.57527 16.278 2.44222C16.1466 2.30917 15.968 2.23401 15.7814 2.23329C15.5949 2.23256 15.4157 2.30631 15.2833 2.43833L14.6524 3.07222L12.0088 5.81C14.0157 6.4766 15.6865 7.90017 16.6689 9.78056C16.7531 9.94816 16.9001 10.0753 17.0776 10.134C17.2551 10.1927 17.4485 10.1782 17.6153 10.0936C17.7821 10.009 17.9086 9.86135 17.9671 9.68303C18.0255 9.50471 18.011 9.31038 17.9269 9.14278Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function RoundedLeft() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      viewBox="0 0 44 44"
      fill="none"
    >
      <rect
        x="0.5"
        y="0.5"
        width="43"
        height="43"
        rx="21.5"
        fill="white"
        stroke="#F5F1FE"
      />
      <path
        d="M30 22.75C30.4142 22.75 30.75 22.4142 30.75 22C30.75 21.5858 30.4142 21.25 30 21.25V22.75ZM14 21.25C13.5858 21.25 13.25 21.5858 13.25 22C13.25 22.4142 13.5858 22.75 14 22.75V21.25ZM17.472 27.5327C17.7662 27.8243 18.2411 27.8222 18.5327 27.528C18.8243 27.2338 18.8222 26.7589 18.528 26.4673L17.472 27.5327ZM16.237 25.2527L16.765 24.72L16.765 24.72L16.237 25.2527ZM16.237 18.7473L15.7091 18.2146L15.7091 18.2146L16.237 18.7473ZM18.528 17.5327C18.8222 17.2411 18.8243 16.7662 18.5327 16.472C18.2411 16.1778 17.7662 16.1757 17.472 16.4673L18.528 17.5327ZM14.0199 22.3133L13.2759 22.4082L13.2759 22.4082L14.0199 22.3133ZM14.0199 21.6867L13.2759 21.5918L13.2759 21.5918L14.0199 21.6867ZM30 21.25H14V22.75H30V21.25ZM18.528 26.4673L16.765 24.72L15.7091 25.7854L17.472 27.5327L18.528 26.4673ZM16.765 19.28L18.528 17.5327L17.472 16.4673L15.7091 18.2146L16.765 19.28ZM16.765 24.72C16.0495 24.0109 15.5587 23.5228 15.2266 23.1093C14.904 22.7076 14.7933 22.4496 14.7639 22.2185L13.2759 22.4082C13.3547 23.0263 13.6496 23.5412 14.0571 24.0485C14.455 24.544 15.0186 25.1011 15.7091 25.7854L16.765 24.72ZM15.7091 18.2146C15.0186 18.8989 14.455 19.456 14.0571 19.9515C13.6496 20.4588 13.3547 20.9737 13.2759 21.5918L14.7639 21.7815C14.7933 21.5504 14.904 21.2924 15.2266 20.8907C15.5587 20.4772 16.0495 19.9891 16.765 19.28L15.7091 18.2146ZM14.7639 22.2185C14.7454 22.0734 14.7454 21.9266 14.7639 21.7815L13.2759 21.5918C13.2414 21.8629 13.2414 22.1371 13.2759 22.4082L14.7639 22.2185Z"
        fill="#2D264B"
      />
    </svg>
  );
}

export function Tick() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.8966 4C14.2069 2.75862 13.2414 1.7931 12 1.10345C10.7586 0.413793 9.51724 0 8 0C6.62069 0 5.24138 0.413793 4 1.10345C2.75862 1.7931 1.7931 2.75862 1.10345 4C0.413793 5.24138 0 6.62069 0 8C0 9.37931 0.413793 10.7586 1.10345 12C1.7931 13.2414 2.75862 14.2069 4 14.8966C5.24138 15.5862 6.62069 16 8 16C9.37931 16 10.7586 15.5862 12 14.8966C13.2414 14.2069 14.2069 13.2414 14.8966 12C15.5862 10.7586 16 9.37931 16 8C16 6.62069 15.7241 5.24138 14.8966 4ZM13.1034 6.34483L7.03448 12.2759C7.03448 12.4138 6.89655 12.4138 6.75862 12.4138C6.62069 12.4138 6.48276 12.4138 6.34483 12.2759L3.03448 8.82759C2.89655 8.82759 2.89655 8.68965 2.89655 8.55172C2.89655 8.41379 2.89655 8.27586 3.03448 8.13793L3.72414 7.44828C3.86207 7.31034 4 7.31034 4.13793 7.31034C4.27586 7.31034 4.41379 7.31034 4.55172 7.44828L6.75862 9.65517L11.5862 4.82759C11.7241 4.68965 11.8621 4.68965 12 4.68965C12.1379 4.68965 12.2759 4.68965 12.4138 4.82759L13.1034 5.51724C13.2414 5.65517 13.2414 5.65517 13.2414 5.7931C13.2414 6.06896 13.1034 6.2069 13.1034 6.34483Z"
        fill="#5FBF24"
      />
    </svg>
  );
}

export function DateRangeCalender() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.75 3.56V2C16.75 1.59 16.41 1.25 16 1.25C15.59 1.25 15.25 1.59 15.25 2V3.5H8.74999V2C8.74999 1.59 8.40999 1.25 7.99999 1.25C7.58999 1.25 7.24999 1.59 7.24999 2V3.56C4.54999 3.81 3.23999 5.42 3.03999 7.81C3.01999 8.1 3.25999 8.34 3.53999 8.34H20.46C20.75 8.34 20.99 8.09 20.96 7.81C20.76 5.42 19.45 3.81 16.75 3.56Z"
        fill="#5FBF24"
      />
      <path
        d="M20 9.83997H4C3.45 9.83997 3 10.29 3 10.84V17C3 20 4.5 22 8 22H16C19.5 22 21 20 21 17V10.84C21 10.29 20.55 9.83997 20 9.83997ZM9.21 18.21C9.16 18.25 9.11 18.3 9.06 18.33C9 18.37 8.94 18.4 8.88 18.42C8.82 18.45 8.76 18.47 8.7 18.48C8.63 18.49 8.57 18.5 8.5 18.5C8.37 18.5 8.24 18.47 8.12 18.42C7.99 18.37 7.89 18.3 7.79 18.21C7.61 18.02 7.5 17.76 7.5 17.5C7.5 17.24 7.61 16.98 7.79 16.79C7.89 16.7 7.99 16.63 8.12 16.58C8.3 16.5 8.5 16.48 8.7 16.52C8.76 16.53 8.82 16.55 8.88 16.58C8.94 16.6 9 16.63 9.06 16.67C9.11 16.71 9.16 16.75 9.21 16.79C9.39 16.98 9.5 17.24 9.5 17.5C9.5 17.76 9.39 18.02 9.21 18.21ZM9.21 14.71C9.02 14.89 8.76 15 8.5 15C8.24 15 7.98 14.89 7.79 14.71C7.61 14.52 7.5 14.26 7.5 14C7.5 13.74 7.61 13.48 7.79 13.29C8.07 13.01 8.51 12.92 8.88 13.08C9.01 13.13 9.12 13.2 9.21 13.29C9.39 13.48 9.5 13.74 9.5 14C9.5 14.26 9.39 14.52 9.21 14.71ZM12.71 18.21C12.52 18.39 12.26 18.5 12 18.5C11.74 18.5 11.48 18.39 11.29 18.21C11.11 18.02 11 17.76 11 17.5C11 17.24 11.11 16.98 11.29 16.79C11.66 16.42 12.34 16.42 12.71 16.79C12.89 16.98 13 17.24 13 17.5C13 17.76 12.89 18.02 12.71 18.21ZM12.71 14.71C12.66 14.75 12.61 14.79 12.56 14.83C12.5 14.87 12.44 14.9 12.38 14.92C12.32 14.95 12.26 14.97 12.2 14.98C12.13 14.99 12.07 15 12 15C11.74 15 11.48 14.89 11.29 14.71C11.11 14.52 11 14.26 11 14C11 13.74 11.11 13.48 11.29 13.29C11.38 13.2 11.49 13.13 11.62 13.08C11.99 12.92 12.43 13.01 12.71 13.29C12.89 13.48 13 13.74 13 14C13 14.26 12.89 14.52 12.71 14.71ZM16.21 18.21C16.02 18.39 15.76 18.5 15.5 18.5C15.24 18.5 14.98 18.39 14.79 18.21C14.61 18.02 14.5 17.76 14.5 17.5C14.5 17.24 14.61 16.98 14.79 16.79C15.16 16.42 15.84 16.42 16.21 16.79C16.39 16.98 16.5 17.24 16.5 17.5C16.5 17.76 16.39 18.02 16.21 18.21ZM16.21 14.71C16.16 14.75 16.11 14.79 16.06 14.83C16 14.87 15.94 14.9 15.88 14.92C15.82 14.95 15.76 14.97 15.7 14.98C15.63 14.99 15.56 15 15.5 15C15.24 15 14.98 14.89 14.79 14.71C14.61 14.52 14.5 14.26 14.5 14C14.5 13.74 14.61 13.48 14.79 13.29C14.89 13.2 14.99 13.13 15.12 13.08C15.3 13 15.5 12.98 15.7 13.02C15.76 13.03 15.82 13.05 15.88 13.08C15.94 13.1 16 13.13 16.06 13.17C16.11 13.21 16.16 13.25 16.21 13.29C16.39 13.48 16.5 13.74 16.5 14C16.5 14.26 16.39 14.52 16.21 14.71Z"
        fill="#5FBF24"
      />
    </svg>
  );
}

export function ProfileIcon() {
  return (
    <svg
      width="16"
      height="21"
      viewBox="0 0 16 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 0C5.37665 0 3.25 2.12665 3.25 4.75C3.25 7.37335 5.37665 9.5 8 9.5C10.6234 9.5 12.75 7.37335 12.75 4.75C12.75 2.12665 10.6234 0 8 0Z"
        fill="#989898"
      />
      <path
        d="M5 11C2.37665 11 0.25 13.1266 0.25 15.75C0.25 18.3734 2.37665 20.5 5 20.5H11C13.6234 20.5 15.75 18.3734 15.75 15.75C15.75 13.1266 13.6234 11 11 11H5Z"
        fill="#989898"
      />
    </svg>
  );
}

export function LockIcon() {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M15.9956 5.23375C15.8736 2.29884 13.2127 0 10 0C6.71081 0 4 2.40961 4 5.44444V8C1.79086 8 0 9.79086 0 12V17C0 19.2091 1.79086 21 4 21H16C18.2091 21 20 19.2091 20 17V12C20 9.79086 18.2091 8 16 8V5.44444L15.9956 5.23375ZM14 8V5.44444C14 3.57008 12.2337 2 10 2C7.8384 2 6.11444 3.47042 6.00547 5.26405L6 5.44444V8H14Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function LockationIcon() {
  return (
    <svg
      width="16"
      height="22"
      viewBox="0 0 16 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.7808 18.7005C13.0905 15.7551 16 11.4759 16 8.6087C16 3.85424 12.4183 0 8 0C3.58172 0 0 3.85424 0 8.6087C0 11.4759 2.90945 15.7551 5.21921 18.7005C6.42425 20.2371 7.02677 21.0055 8 21.0055C8.97323 21.0055 9.57575 20.2371 10.7808 18.7005ZM8 12C6.34315 12 5 10.6569 5 9C5 7.34315 6.34315 6 8 6C9.65685 6 11 7.34315 11 9C11 10.6569 9.65685 12 8 12Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function DeleteIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.07 5.23C19.46 5.07 17.85 4.95 16.23 4.86V4.85L16.01 3.55C15.86 2.63 15.64 1.25 13.3 1.25H10.68C8.35004 1.25 8.13003 2.57 7.97004 3.54L7.76004 4.82C6.83004 4.88 5.90004 4.94 4.97004 5.03L2.93004 5.23C2.51004 5.27 2.21004 5.64 2.25004 6.05C2.29004 6.46 2.65004 6.76 3.07004 6.72L5.11004 6.52C10.35 6 15.63 6.2 20.93 6.73C20.96 6.73 20.98 6.73 21.01 6.73C21.39 6.73 21.72 6.44 21.76 6.05C21.79 5.64 21.49 5.27 21.07 5.23Z"
        fill="#899CA8"
      />
      <path
        d="M19.23 8.14C18.99 7.89 18.66 7.75 18.32 7.75H5.67999C5.33999 7.75 4.99999 7.89 4.76999 8.14C4.53999 8.39 4.40999 8.73 4.42999 9.08L5.04999 19.34C5.15999 20.86 5.29999 22.76 8.78999 22.76H15.21C18.7 22.76 18.84 20.87 18.95 19.34L19.57 9.09C19.59 8.73 19.46 8.39 19.23 8.14ZM13.66 17.75H10.33C9.91999 17.75 9.57999 17.41 9.57999 17C9.57999 16.59 9.91999 16.25 10.33 16.25H13.66C14.07 16.25 14.41 16.59 14.41 17C14.41 17.41 14.07 17.75 13.66 17.75ZM14.5 13.75H9.49999C9.08999 13.75 8.74999 13.41 8.74999 13C8.74999 12.59 9.08999 12.25 9.49999 12.25H14.5C14.91 12.25 15.25 12.59 15.25 13C15.25 13.41 14.91 13.75 14.5 13.75Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function EditIcon() {
  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="45"
        height="45"
        rx="12.5"
        fill="white"
        stroke="#F5F1FE"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M27.8787 12.8787L19.2929 21.4645C19.1054 21.652 19 21.9064 19 22.1716V26.1716C19 26.7239 19.4477 27.1716 20 27.1716H24C24.2652 27.1716 24.5196 27.0662 24.7071 26.8787L33.2929 18.2929C34.4645 17.1213 34.4645 15.2218 33.2929 14.0503L32.1213 12.8787C30.9497 11.7071 29.0503 11.7071 27.8787 12.8787ZM31.8787 15.4645L31.9619 15.5587C32.2669 15.951 32.2392 16.5182 31.8787 16.8787L23.584 25.1716H21V22.5856L29.2929 14.2929C29.6834 13.9024 30.3166 13.9024 30.7071 14.2929L31.8787 15.4645ZM23.0308 14.1716C23.0308 13.6193 22.5831 13.1716 22.0308 13.1716H18L17.7831 13.1762C15.1223 13.2898 13 15.4828 13 18.1716V28.1716L13.0046 28.3885C13.1182 31.0493 15.3112 33.1716 18 33.1716H28L28.2169 33.167C30.8777 33.0534 33 30.8603 33 28.1716V23.2533L32.9933 23.1366C32.9355 22.6393 32.5128 22.2533 32 22.2533C31.4477 22.2533 31 22.701 31 23.2533V28.1716L30.9949 28.3478C30.9037 29.9227 29.5977 31.1716 28 31.1716H18L17.8237 31.1665C16.2489 31.0752 15 29.7693 15 28.1716V18.1716L15.0051 17.9953C15.0963 16.4205 16.4023 15.1716 18 15.1716H22.0308L22.1474 15.1648C22.6448 15.1071 23.0308 14.6844 23.0308 14.1716Z"
        fill="#363636"
      />
    </svg>
  );
}

export function MenuDots() {
  return (
    <svg
      width="4"
      height="14"
      viewBox="0 0 4 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="1.55556" cy="6.99989" r="1.55556" fill="#899CA8" />
      <circle cx="1.55556" cy="1.55556" r="1.55556" fill="#899CA8" />
      <circle cx="1.55556" cy="12.4442" r="1.55556" fill="#899CA8" />
    </svg>
  );
}

export function EyeHide() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21.2699 9.18005C20.9799 8.72005 20.6699 8.29005 20.3499 7.89005C19.9799 7.42005 19.2799 7.38005 18.8599 7.80005L15.8599 10.8001C16.0799 11.4601 16.1199 12.2201 15.9199 13.0101C15.5699 14.4201 14.4299 15.5601 13.0199 15.9101C12.2299 16.1101 11.4699 16.0701 10.8099 15.8501C10.8099 15.8501 9.37995 17.2801 8.34995 18.3101C7.84995 18.8101 8.00995 19.6901 8.67995 19.9501C9.74995 20.3601 10.8599 20.5701 11.9999 20.5701C13.7799 20.5701 15.5099 20.0501 17.0899 19.0801C18.6999 18.0801 20.1499 16.6101 21.3199 14.74C22.2699 13.2301 22.2199 10.6901 21.2699 9.18005Z"
        fill="#899CA8"
      />
      <path
        d="M14.0199 9.97989L9.97989 14.0199C9.46989 13.4999 9.13989 12.7799 9.13989 11.9999C9.13989 10.4299 10.4199 9.13989 11.9999 9.13989C12.7799 9.13989 13.4999 9.46989 14.0199 9.97989Z"
        fill="#899CA8"
      />
      <path
        d="M18.25 5.74993L14.86 9.13993C14.13 8.39993 13.12 7.95993 12 7.95993C9.76 7.95993 7.96 9.76993 7.96 11.9999C7.96 13.1199 8.41 14.1299 9.14 14.8599L5.76 18.2499H5.75C4.64 17.3499 3.62 16.1999 2.75 14.8399C1.75 13.2699 1.75 10.7199 2.75 9.14993C3.91 7.32993 5.33 5.89993 6.91 4.91993C8.49 3.95993 10.22 3.42993 12 3.42993C14.23 3.42993 16.39 4.24993 18.25 5.74993Z"
        fill="#899CA8"
      />
      <path
        d="M14.8601 12.0001C14.8601 13.5701 13.5801 14.8601 12.0001 14.8601C11.9401 14.8601 11.8901 14.8601 11.8301 14.8401L14.8401 11.8301C14.8601 11.8901 14.8601 11.9401 14.8601 12.0001Z"
        fill="#899CA8"
      />
      <path
        d="M21.7699 2.22988C21.4699 1.92988 20.9799 1.92988 20.6799 2.22988L2.22988 20.6899C1.92988 20.9899 1.92988 21.4799 2.22988 21.7799C2.37988 21.9199 2.56988 21.9999 2.76988 21.9999C2.96988 21.9999 3.15988 21.9199 3.30988 21.7699L21.7699 3.30988C22.0799 3.00988 22.0799 2.52988 21.7699 2.22988Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function ThreeDots() {
  return (
    <svg
      width="4"
      height="14"
      viewBox="0 0 4 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="1.55556" cy="6.99989" r="1.55556" fill="#899CA8" />
      <circle cx="1.55556" cy="1.55556" r="1.55556" fill="#899CA8" />
      <circle cx="1.55556" cy="12.4442" r="1.55556" fill="#899CA8" />
    </svg>
  );
}

export function GreenTick() {
  return (
    <svg
      width="15"
      height="11"
      viewBox="0 0 15 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.36893 11C5.06878 11 4.78364 10.8772 4.57354 10.6624L0.326413 6.31915C-0.108804 5.87408 -0.108804 5.13743 0.326413 4.69236C0.761631 4.2473 1.48199 4.2473 1.91721 4.69236L5.36893 8.22218L13.0828 0.333798C13.518 -0.111266 14.2384 -0.111266 14.6736 0.333798C15.1088 0.778863 15.1088 1.51552 14.6736 1.96059L6.16433 10.6624C5.95423 10.8772 5.66908 11 5.36893 11Z"
        fill="#5FBF24"
      />
    </svg>
  );
}

export function Telephone() {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.11183 0.97505C5.05974 0.00831676 3.44259 0.00831676 2.3905 0.97505C2.34741 1.01464 2.30142 1.06065 2.24169 1.12039L1.34419 2.01788C0.441081 2.921 0.0619618 4.22292 0.339024 5.4697C1.91099 12.5436 7.43553 18.0681 14.5094 19.6401C15.7562 19.9171 17.0581 19.538 17.9612 18.6349L18.8586 17.7375C18.9184 17.6777 18.9644 17.6317 19.004 17.5886C19.9708 16.5365 19.9708 14.9193 19.004 13.8673C18.9644 13.8241 18.9184 13.7781 18.8586 13.7184L17.3894 12.2491C16.3693 11.229 14.8287 10.9372 13.5063 11.5137C12.7492 11.8437 11.8672 11.6767 11.2832 11.0927L8.88639 8.69589C8.30239 8.11188 8.13536 7.22994 8.46538 6.47283C9.04184 5.15037 8.75009 3.60984 7.72999 2.58974L6.26066 1.12041C6.20093 1.06066 6.15492 1.01464 6.11183 0.97505Z"
        fill="#3B7AFE"
      />
    </svg>
  );
}

export function Envelope() {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.333223 3.40947C0 4.64946 0 6.36008 0 9C0 12.7497 0 14.6246 0.954915 15.9389C1.26331 16.3634 1.6366 16.7367 2.06107 17.0451C3.3754 18 5.25027 18 9 18H11C14.7497 18 16.6246 18 17.9389 17.0451C18.3634 16.7367 18.7367 16.3634 19.0451 15.9389C20 14.6246 20 12.7497 20 9C20 6.35129 20 4.63806 19.6634 3.39709L17.5607 5.49986C15.9284 7.13214 14.6492 8.41132 13.517 9.2752C12.3581 10.1594 11.2653 10.6789 9.99986 10.6789C8.73441 10.6789 7.64167 10.1594 6.48274 9.2752C5.35048 8.41132 4.07131 7.13213 2.43904 5.49984L0.483855 3.54466L0.333223 3.40947Z"
        fill="#3B7AFE"
      />
      <path
        d="M1 2L1.10885 2.09007L1.51587 2.45535L3.45913 4.39861C5.14079 6.08027 6.34981 7.28703 7.39261 8.08267C8.41812 8.8651 9.19425 9.17894 9.99986 9.17894C10.8055 9.17894 11.5816 8.8651 12.6071 8.08267C13.6499 7.28703 14.8589 6.08027 16.5406 4.39861L18.8485 2.0907L18.9741 1.96579C18.6657 1.54132 18.3634 1.26331 17.9389 0.954915C16.6246 0 14.7497 0 11 0H9C5.25027 0 3.3754 0 2.06107 0.954915C1.6366 1.26331 1.3084 1.57553 1 2Z"
        fill="#3B7AFE"
      />
    </svg>
  );
}

export function Loc() {
  return (
    <svg
      width="16"
      height="22"
      viewBox="0 0 16 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.7808 18.7005C13.0905 15.7551 16 11.4759 16 8.6087C16 3.85424 12.4183 0 8 0C3.58172 0 0 3.85424 0 8.6087C0 11.4759 2.90945 15.7551 5.21921 18.7005C6.42425 20.2371 7.02677 21.0055 8 21.0055C8.97323 21.0055 9.57575 20.2371 10.7808 18.7005ZM8 12C6.34315 12 5 10.6569 5 9C5 7.34315 6.34315 6 8 6C9.65685 6 11 7.34315 11 9C11 10.6569 9.65685 12 8 12Z"
        fill="#3B7AFE"
      />
    </svg>
  );
}

export function PrivacyIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19 1H5C2.79086 1 1 2.79086 1 5V10C1 14.3666 3.65957 18.1686 8.83853 21.3794C10.7752 22.58 13.2248 22.58 15.1615 21.3794L15.5314 21.1463C20.4685 17.983 23 14.2589 23 10V5C23 2.79086 21.2091 1 19 1Z"
        fill="#899CA8"
      />
      <path
        d="M16.2994 6.29075C16.69 5.90033 17.3232 5.9005 17.7136 6.29113C18.074 6.65171 18.1015 7.21895 17.7964 7.61116L17.7132 7.70534L11.7072 13.7081C11.3465 14.0687 10.779 14.0961 10.3868 13.7906L10.2926 13.7073L7.29621 10.706C6.90601 10.3151 6.90654 9.68193 7.29739 9.29174C7.65818 8.93156 8.22543 8.9043 8.61747 9.20965L8.7116 9.29292L11.0003 11.5858L16.2994 6.29075Z"
        fill="white"
      />
    </svg>
  );
}

export function FaqIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.16998 22.1094C7.42998 22.2494 7.72 22.3194 8 22.3194C8.34 22.3194 8.67997 22.2195 8.96997 22.0295L13.23 19.1894H17C20.44 19.1894 22.75 16.8794 22.75 13.4394V7.43945C22.75 3.99945 20.44 1.68945 17 1.68945H7C3.56 1.68945 1.25 3.99945 1.25 7.43945V13.4394C1.25 16.6194 3.23 18.8395 6.25 19.1495V20.5694C6.25 21.2094 6.59998 21.8094 7.16998 22.1094Z"
        fill="#899CA8"
      />
      <path
        d="M11.9998 12.1094C11.5898 12.1094 11.2498 11.7694 11.2498 11.3594V11.1494C11.2498 9.98941 12.0998 9.4194 12.4198 9.1994C12.7898 8.9494 12.9098 8.77941 12.9098 8.51941C12.9098 8.01941 12.4998 7.60938 11.9998 7.60938C11.4998 7.60938 11.0898 8.01941 11.0898 8.51941C11.0898 8.92941 10.7498 9.26941 10.3398 9.26941C9.92984 9.26941 9.58984 8.92941 9.58984 8.51941C9.58984 7.18941 10.6698 6.10938 11.9998 6.10938C13.3298 6.10938 14.4098 7.18941 14.4098 8.51941C14.4098 9.65941 13.5698 10.2294 13.2598 10.4394C12.8698 10.6994 12.7498 10.8694 12.7498 11.1494V11.3594C12.7498 11.7794 12.4098 12.1094 11.9998 12.1094Z"
        fill="white"
      />
      <path
        d="M12 14.5996C11.58 14.5996 11.25 14.2596 11.25 13.8496C11.25 13.4396 11.59 13.0996 12 13.0996C12.41 13.0996 12.75 13.4396 12.75 13.8496C12.75 14.2596 12.42 14.5996 12 14.5996Z"
        fill="white"
      />
    </svg>
  );
}

export function TermsIcon() {
  return (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 4.91094C16 6.12338 14.99 7.11094 13.75 7.11094H10.25C9.63 7.11094 9.07 6.86649 8.66 6.4656C8.25 6.06472 8 5.51716 8 4.91094C8 3.69849 9.01 2.71094 10.25 2.71094H13.75C14.37 2.71094 14.93 2.95538 15.34 3.35627C15.75 3.75716 16 4.30472 16 4.91094Z"
        fill="#899CA8"
      />
      <path
        d="M18.83 5.67437C18.6 5.48859 18.34 5.34193 18.06 5.23437C17.77 5.12682 17.48 5.3517 17.42 5.64504C17.08 7.31704 15.57 8.57837 13.75 8.57837H10.25C9.25 8.57837 8.31 8.19704 7.6 7.50282C7.08 6.99437 6.72 6.34904 6.58 5.65482C6.52 5.36148 6.22 5.12682 5.93 5.24415C4.77 5.7037 4 6.74015 4 8.82282V18.3561C4 21.2895 5.79 22.2673 8 22.2673H16C18.21 22.2673 20 21.2895 20 18.3561V8.82282C20 7.22904 19.55 6.25126 18.83 5.67437ZM8 12.7339H12C12.41 12.7339 12.75 13.0664 12.75 13.4673C12.75 13.8681 12.41 14.2006 12 14.2006H8C7.59 14.2006 7.25 13.8681 7.25 13.4673C7.25 13.0664 7.59 12.7339 8 12.7339ZM16 18.1117H8C7.59 18.1117 7.25 17.7793 7.25 17.3784C7.25 16.9775 7.59 16.645 8 16.645H16C16.41 16.645 16.75 16.9775 16.75 17.3784C16.75 17.7793 16.41 18.1117 16 18.1117Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function AppointmentArrow() {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1"
        y="1"
        width="24"
        height="23.7126"
        rx="5"
        fill="#F9FAFA"
        stroke="#C4CBD6"
        stroke-opacity="0.103611"
      />
      <path
        d="M16.8178 14.3168L14.9829 12.4819L13.8625 11.3558C13.3881 10.8814 12.6164 10.8814 12.142 11.3558L9.181 14.3168C8.79231 14.7055 9.0724 15.3686 9.61543 15.3686H12.8222H16.3834C16.9321 15.3686 17.2065 14.7055 16.8178 14.3168Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function PaymentTick() {
  return (
    <svg
      width="15"
      height="11"
      viewBox="0 0 15 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.36893 11C5.06878 11 4.78364 10.8772 4.57354 10.6624L0.326413 6.31915C-0.108804 5.87408 -0.108804 5.13743 0.326413 4.69236C0.761631 4.2473 1.48199 4.2473 1.91721 4.69236L5.36893 8.22218L13.0828 0.333798C13.518 -0.111266 14.2384 -0.111266 14.6736 0.333798C15.1088 0.778863 15.1088 1.51552 14.6736 1.96059L6.16433 10.6624C5.95423 10.8772 5.66908 11 5.36893 11Z"
        fill="#5FBF24"
      />
    </svg>
  );
}

export function FileUpload() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.21783 20.9384L7.1005 21.6792H7.1005L7.21783 20.9384ZM3.06156 16.7822L3.80232 16.6648L3.06156 16.7822ZM20.9384 16.7822L21.6792 16.8995V16.8995L20.9384 16.7822ZM16.7822 20.9384L16.8995 21.6792H16.8995L16.7822 20.9384ZM20.6 10.5496C20.3513 10.2184 19.8811 10.1516 19.5499 10.4003C19.2187 10.6491 19.1519 11.1192 19.4007 11.4504L20.6 10.5496ZM4.59931 11.4504C4.84808 11.1192 4.78126 10.6491 4.45007 10.4003C4.11888 10.1516 3.64873 10.2184 3.39996 10.5496L4.59931 11.4504ZM11.25 17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17H11.25ZM7.41232 6.53403C7.15497 6.8586 7.20946 7.33034 7.53403 7.58768C7.8586 7.84503 8.33034 7.79054 8.58768 7.46597L7.41232 6.53403ZM9.39785 5.23703L8.81016 4.77106L9.39785 5.23703ZM14.6022 5.23703L15.1898 4.77106L14.6022 5.23703ZM15.4123 7.46597C15.6697 7.79054 16.1414 7.84503 16.466 7.58768C16.7905 7.33034 16.845 6.8586 16.5877 6.53403L15.4123 7.46597ZM11.7493 3.01989L11.6313 2.27923L11.6313 2.27923L11.7493 3.01989ZM12.2507 3.01989L12.3687 2.27923L12.3687 2.27923L12.2507 3.01989ZM20.25 14V15H21.75V14H20.25ZM15 20.25H9V21.75H15V20.25ZM3.75 15V14H2.25V15H3.75ZM9 20.25C8.04233 20.25 7.65082 20.2477 7.33515 20.1977L7.1005 21.6792C7.56216 21.7523 8.09965 21.75 9 21.75V20.25ZM2.25 15C2.25 15.9003 2.24767 16.4378 2.32079 16.8995L3.80232 16.6648C3.75233 16.3492 3.75 15.9577 3.75 15H2.25ZM7.33515 20.1977C5.51661 19.9096 4.09035 18.4834 3.80232 16.6648L2.32079 16.8995C2.71048 19.3599 4.64012 21.2895 7.1005 21.6792L7.33515 20.1977ZM20.25 15C20.25 15.9577 20.2477 16.3492 20.1977 16.6648L21.6792 16.8995C21.7523 16.4378 21.75 15.9003 21.75 15H20.25ZM15 21.75C15.9003 21.75 16.4378 21.7523 16.8995 21.6792L16.6648 20.1977C16.3492 20.2477 15.9577 20.25 15 20.25V21.75ZM20.1977 16.6648C19.9096 18.4834 18.4834 19.9096 16.6648 20.1977L16.8995 21.6792C19.3599 21.2895 21.2895 19.3599 21.6792 16.8995L20.1977 16.6648ZM21.75 14C21.75 12.7064 21.3219 11.5106 20.6 10.5496L19.4007 11.4504C19.9342 12.1607 20.25 13.0424 20.25 14H21.75ZM3.75 14C3.75 13.0424 4.06583 12.1607 4.59931 11.4504L3.39996 10.5496C2.67806 11.5106 2.25 12.7064 2.25 14H3.75ZM12.75 17V4H11.25V17H12.75ZM8.58768 7.46597L9.98553 5.703L8.81016 4.77106L7.41232 6.53403L8.58768 7.46597ZM14.0145 5.703L15.4123 7.46597L16.5877 6.53403L15.1898 4.77106L14.0145 5.703ZM9.98553 5.703C10.5543 4.98568 10.9418 4.49884 11.2682 4.17113C11.5913 3.84678 11.7612 3.77747 11.8673 3.76055L11.6313 2.27923C11.0582 2.37055 10.6096 2.70685 10.2055 3.11252C9.80475 3.51484 9.35616 4.08245 8.81016 4.77106L9.98553 5.703ZM15.1898 4.77106C14.6438 4.08245 14.1953 3.51484 13.7945 3.11252C13.3904 2.70685 12.9418 2.37055 12.3687 2.27923L12.1327 3.76055C12.2388 3.77747 12.4087 3.84678 12.7318 4.17113C13.0582 4.49884 13.4457 4.98568 14.0145 5.703L15.1898 4.77106ZM11.8673 3.76055C11.9117 3.75348 11.9559 3.75 12 3.75V2.25C11.8766 2.25 11.7534 2.25978 11.6313 2.27923L11.8673 3.76055ZM12 3.75C12.0441 3.75 12.0883 3.75348 12.1327 3.76055L12.3687 2.27923C12.2466 2.25978 12.1234 2.25 12 2.25V3.75ZM12.75 4V3H11.25V4H12.75Z"
        fill="#3B7AFE"
      />
    </svg>
  );
}

export function PlusIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.99327 0.883379C7.93551 0.38604 7.51284 0 7 0C6.44772 0 6 0.447715 6 1V6H1L0.883379 6.00673C0.38604 6.06449 0 6.48716 0 7C0 7.55228 0.447715 8 1 8H6V13L6.00673 13.1166C6.06449 13.614 6.48716 14 7 14C7.55228 14 8 13.5523 8 13V8H13L13.1166 7.99327C13.614 7.93551 14 7.51284 14 7C14 6.44772 13.5523 6 13 6H8V1L7.99327 0.883379Z"
        fill="white"
      />
    </svg>
  );
}

export function FilterIcon() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M5 2C4.44772 2 4 2.44772 4 3V5.00001H20V3C20 2.44772 19.5523 2 19 2H5ZM19.7822 7.00001H4.21776C4.3321 7.22455 4.48907 7.42794 4.68299 7.59762L10.683 12.8476C11.437 13.5074 12.563 13.5074 13.317 12.8476L19.317 7.59762C19.5109 7.42794 19.6679 7.22455 19.7822 7.00001Z"
        fill="#899CA8"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M14 16.7049L14 10H10V18.7049L14 16.7049Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function GridViewIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect width="24" height="24" rx="4" fill="#F9F9F9" />
      <rect
        width="3.75"
        height="3.75"
        transform="matrix(1 0 0 -1 3.375 10.75)"
        fill="#899CA8"
      />
      <rect
        width="3.75"
        height="3.75"
        transform="matrix(1 0 0 -1 3.375 17)"
        fill="#899CA8"
      />
      <rect
        width="3.75"
        height="3.75"
        transform="matrix(1 0 0 -1 9.625 10.75)"
        fill="#899CA8"
      />
      <rect
        width="3.75"
        height="3.75"
        transform="matrix(1 0 0 -1 9.625 17)"
        fill="#899CA8"
      />
      <rect
        width="3.75"
        height="3.75"
        transform="matrix(1 0 0 -1 15.875 10.75)"
        fill="#899CA8"
      />
      <rect
        width="3.75"
        height="3.75"
        transform="matrix(1 0 0 -1 15.875 17)"
        fill="#899CA8"
      />
    </svg>
  );
}

export function ListViewIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <rect width="24" height="24" rx="4" fill="#F9F9F9" />
      <rect
        width="2.2"
        height="2.2"
        transform="matrix(1 0 0 -1 3.19995 9.2002)"
        fill="#899CA8"
      />
      <rect
        width="2.2"
        height="2.2"
        transform="matrix(1 0 0 -1 3.19995 13.5996)"
        fill="#899CA8"
      />
      <rect
        width="2.2"
        height="2.2"
        transform="matrix(1 0 0 -1 3.19995 18)"
        fill="#899CA8"
      />
      <rect
        width="13.2"
        height="2.2"
        transform="matrix(1 0 0 -1 7.59985 9.2002)"
        fill="#899CA8"
      />
      <rect
        width="13.2"
        height="2.2"
        transform="matrix(1 0 0 -1 7.59985 13.5996)"
        fill="#899CA8"
      />
      <rect
        width="13.2"
        height="2.2"
        transform="matrix(1 0 0 -1 7.59985 18)"
        fill="#899CA8"
      />
    </svg>
  );
}

export function BlueUser() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="21"
      viewBox="0 0 16 21"
      fill="none"
    >
      <path
        d="M8 0C5.37665 0 3.25 2.12665 3.25 4.75C3.25 7.37335 5.37665 9.5 8 9.5C10.6234 9.5 12.75 7.37335 12.75 4.75C12.75 2.12665 10.6234 0 8 0Z"
        fill="#3B7AFE"
      />
      <path
        d="M5 11C2.37665 11 0.25 13.1266 0.25 15.75C0.25 18.3734 2.37665 20.5 5 20.5H11C13.6234 20.5 15.75 18.3734 15.75 15.75C15.75 13.1266 13.6234 11 11 11H5Z"
        fill="#3B7AFE"
      />
    </svg>
  );
}

export function NoDataShow() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="214"
      height="157"
      fill="none"
      viewBox="0 0 214 157"
    >
      <path
        fill="#F3F7FF"
        fillRule="evenodd"
        d="M45.574 92.246h90.157a6.96 6.96 0 001.487-.16c.478.105.976.16 1.486.16h51.518a6.939 6.939 0 006.935-6.942 6.939 6.939 0 00-6.935-6.943h-5.944a6.939 6.939 0 01-6.935-6.942 6.939 6.939 0 016.935-6.943h18.824a6.939 6.939 0 006.935-6.943 6.939 6.939 0 00-6.935-6.942h-21.796a6.939 6.939 0 006.935-6.943 6.939 6.939 0 00-6.935-6.942h-63.408a6.939 6.939 0 006.935-6.943 6.939 6.939 0 00-6.935-6.943H61.426a6.939 6.939 0 00-6.935 6.943 6.939 6.939 0 006.935 6.943h-39.63a6.939 6.939 0 00-6.935 6.942 6.939 6.939 0 006.935 6.943h24.769a6.939 6.939 0 016.935 6.942 6.939 6.939 0 01-6.935 6.943H6.935A6.939 6.939 0 000 71.42a6.939 6.939 0 006.935 6.942h38.64a6.939 6.939 0 00-6.936 6.943 6.939 6.939 0 006.935 6.942zm161.491 0A6.939 6.939 0 00214 85.304a6.939 6.939 0 00-6.935-6.943 6.939 6.939 0 00-6.935 6.943 6.939 6.939 0 006.935 6.942z"
        clipRule="evenodd"
      ></path>
      <path
        stroke="#75A4FE"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.5"
        d="M154.06 3.975v5.95M154.06 17.86v5.95M144.153 13.893h5.944M158.023 13.893h5.945M71.829 106.131v3.967M71.829 118.033V122M63.903 114.065h3.963M75.792 114.065h3.963"
      ></path>
      <g clipPath="url(#clip0_3266_166487)">
        <path
          fill="#fff"
          d="M107.541 90.975H73.374c-2.845 0-4.13-1.274-4.377-4.181-.711-8.168-1.45-16.336-2.16-24.503-.657-7.365-1.287-14.758-1.916-22.123-.109-1.135-.191-2.27-.3-3.405-.22-2.27 1.285-4.07 3.528-4.236.41-.028.82-.028 1.231-.028 11.872 0 23.717.028 35.589-.028 3.064-.027 5.526.997 7.413 3.434.848 1.08 1.806 2.076 2.709 3.128 1.778 2.049 4.021 3.018 6.702 3.018 3.692-.028 7.385 0 11.078 0 4.405 0 8.809-.028 13.24 0 2.49.028 4.295 1.744 4.103 3.876-.109 1.412-.273 2.825-.41 4.236a5041.863 5041.863 0 01-1.997 20.434l-1.641 16.945c-.192 2.02-1.833 3.433-3.939 3.433-11.571.028-23.143 0-34.686 0z"
        ></path>
        <path
          fill="#fff"
          d="M69.216 30.34v-2.354c.028-3.156 2.052-5.178 5.17-5.15l39.556.582c8.234.11 16.467.221 24.701.304 1.724.028 3.31.415 4.35 1.855.519.748 1.039 1.717 1.067 2.603.109 3.765.054 7.53.054 11.49h-1.094c-7.03 0-14.088-.028-21.118 0-2.27 0-4.103-.83-5.58-2.575-.931-1.107-1.888-2.187-2.845-3.267-2.134-2.409-4.788-3.572-7.988-3.572-11.653.028-23.307 0-34.96 0-.383.084-.793.084-1.313.084z"
        ></path>
        <path
          fill="#3B7AFE"
          d="M145.92 92.221c1.012.083 1.778.111 2.544.194.602.083 1.231.138 1.805.332 1.669.582 1.997 2.326.52 3.323-.793.526-1.888.83-2.872.858-13.377.139-26.726.36-40.103.25-10.942-.084-21.857-.5-32.799-.887-1.996-.055-3.993-.47-5.936-.969-2.434-.609-3.966-2.353-4.376-4.845-.41-2.492-.602-5.011-.849-7.531-.683-7.752-1.34-15.505-1.996-23.258-.465-5.51-.958-11.02-1.423-16.529-.328-4.014.848-7.586 3.283-10.715.602-.748 1.45-1.384 2.325-1.8.684-.332.875-.692.848-1.384-.027-.997-.055-2.021.137-2.99.71-3.6 3.638-5.98 7.358-5.925 10.122.11 20.243.277 30.364.415 11.271.166 22.568.305 33.839.47 4.841.084 7.796 3.13 7.823 8.058 0 3.073.027 6.146 0 9.247 0 .693.137 1.025.903 1.136 3.255.47 5.471 3.405 5.143 6.755-1.04 10.881-2.134 21.735-3.174 32.616-.246 2.436-.465 4.9-.683 7.337-.165 2.215-.684 4.236-2.681 5.842zm-38.379-1.246h34.658c2.107 0 3.748-1.412 3.94-3.433.574-5.648 1.094-11.296 1.641-16.945.656-6.81 1.313-13.622 1.997-20.433.137-1.412.301-2.824.41-4.236.164-2.16-1.614-3.876-4.103-3.876-4.404-.028-8.808 0-13.24 0-3.693 0-7.386-.028-11.079 0-2.681.027-4.924-.942-6.702-3.018-.903-1.052-1.86-2.021-2.708-3.129-1.915-2.437-4.349-3.46-7.413-3.433-11.872.055-23.717.027-35.59.027-.41 0-.82 0-1.23.028-2.243.166-3.748 1.966-3.529 4.236.11 1.136.219 2.27.301 3.406.656 7.365 1.286 14.757 1.915 22.122.711 8.168 1.477 16.336 2.16 24.504.247 2.879 1.533 4.18 4.378 4.18 11.407.028 22.814 0 34.194 0zM69.216 30.34h36.273c3.2 0 5.854 1.163 7.988 3.571.957 1.08 1.914 2.16 2.845 3.268 1.477 1.716 3.282 2.575 5.58 2.575 7.03-.028 14.088 0 21.118 0h1.094c0-3.96.055-7.725-.054-11.49-.028-.887-.52-1.856-1.067-2.603-1.04-1.468-2.626-1.855-4.35-1.855-8.234-.083-16.467-.194-24.701-.305l-39.556-.581c-3.118-.056-5.142 1.993-5.17 5.15v2.27z"
        ></path>
        <mask
          id="mask0_3266_166487"
          style={{ maskType: "alpha" }}
          width="87"
          height="60"
          x="64"
          y="32"
          maskUnits="userSpaceOnUse"
        >
          <path
            fill="#1F6DE0"
            d="M107.367 91.24h34.659c2.106 0 3.747-1.412 3.939-3.433.574-5.648 1.094-11.296 1.641-16.945.656-6.81 1.313-13.622 1.997-20.433.137-1.412.301-2.824.41-4.236.164-2.16-1.614-3.876-4.103-3.876-4.404-.028-8.808 0-13.24 0-3.693 0-7.386-.028-11.079 0-2.68.027-4.924-.942-6.702-3.018-.902-1.052-1.86-2.021-2.708-3.129-1.915-2.436-4.349-3.46-7.413-3.433-11.872.055-23.717.028-35.589.028-.41 0-.82 0-1.231.027-2.243.166-3.748 1.966-3.529 4.236.11 1.136.22 2.27.301 3.406.657 7.365 1.286 14.757 1.915 22.122.711 8.168 1.477 16.336 2.161 24.504.246 2.88 1.532 4.18 4.377 4.18 11.407.028 22.814 0 34.194 0z"
          ></path>
        </mask>
        <g mask="url(#mask0_3266_166487)">
          <path
            fill="#E8F0FE"
            d="M148.933 60.774c-32.1 15.869-54.326-12.232-61.426-28.267l-20.31-.991-4.459 4.463 6.44 56.037 76.782-.992 2.973-30.25z"
          ></path>
        </g>
        <path
          stroke="#75A4FE"
          strokeLinecap="round"
          strokeWidth="2.5"
          d="M74.305 77.367l.991 7.935M73.315 65.963l.495 3.471"
        ></path>
      </g>
      <path
        stroke="#75A4FE"
        strokeWidth="2"
        d="M132.759 6.95a2.973 2.973 0 002.972-2.975A2.973 2.973 0 00132.759 1a2.974 2.974 0 00-2.972 2.975 2.974 2.974 0 002.972 2.976z"
      ></path>
      <path
        fill="#75A4FE"
        d="M52.51 108.115a2.974 2.974 0 002.971-2.976 2.974 2.974 0 00-2.972-2.975 2.974 2.974 0 00-2.972 2.975 2.974 2.974 0 002.972 2.976z"
      ></path>
      <path
        fill="#899CA8"
        d="M30.296 137.455V152H28.59l-7.926-11.42h-.142V152H18.76v-14.545h1.705l7.954 11.448h.142v-11.448h1.733zm7.729 14.772c-.985 0-1.85-.234-2.593-.703-.739-.469-1.316-1.124-1.733-1.967-.412-.843-.618-1.828-.618-2.955 0-1.136.206-2.128.618-2.976.417-.847.995-1.505 1.733-1.974.743-.469 1.608-.703 2.593-.703.984 0 1.846.234 2.585.703.743.469 1.32 1.127 1.733 1.974.416.848.625 1.84.625 2.976 0 1.127-.209 2.112-.625 2.955-.412.843-.99 1.498-1.733 1.967-.739.469-1.6.703-2.585.703zm0-1.505c.748 0 1.363-.192 1.846-.576.483-.383.84-.887 1.072-1.512a5.797 5.797 0 00.349-2.032 5.85 5.85 0 00-.349-2.038c-.231-.63-.589-1.139-1.072-1.527-.483-.388-1.098-.582-1.846-.582-.749 0-1.364.194-1.847.582-.483.388-.84.897-1.072 1.527a5.85 5.85 0 00-.349 2.038c0 .729.117 1.407.349 2.032.231.625.589 1.129 1.072 1.512.483.384 1.098.576 1.847.576zM51.379 152v-14.545h4.914c1.137 0 2.07.194 2.799.582.729.383 1.269.911 1.619 1.584.35.672.526 1.437.526 2.294s-.176 1.617-.526 2.28c-.35.662-.888 1.183-1.612 1.562-.725.374-1.65.561-2.777.561h-3.978v-1.591h3.92c.777 0 1.402-.113 1.876-.341.478-.227.824-.549 1.037-.966.218-.421.327-.923.327-1.505 0-.583-.11-1.092-.327-1.527-.218-.436-.566-.772-1.044-1.009-.478-.241-1.11-.362-1.897-.362H53.14V152h-1.761zm6.846-6.534l3.58 6.534h-2.046l-3.523-6.534h1.99zm10.176 6.761c-1.051 0-1.958-.232-2.72-.696a4.673 4.673 0 01-1.755-1.96c-.407-.843-.61-1.823-.61-2.94 0-1.118.203-2.103.61-2.955.412-.857.985-1.524 1.72-2.003.738-.483 1.6-.724 2.585-.724.568 0 1.129.095 1.683.284a4.167 4.167 0 011.513.923c.454.422.816.98 1.086 1.676.27.696.405 1.553.405 2.571v.711h-8.41v-1.449h6.705c0-.616-.123-1.165-.369-1.648a2.78 2.78 0 00-1.037-1.143c-.445-.28-.97-.419-1.576-.419-.668 0-1.246.165-1.733.497a3.268 3.268 0 00-1.116 1.278 3.756 3.756 0 00-.39 1.69v.966c0 .824.142 1.523.426 2.096a3.071 3.071 0 001.2 1.299c.512.294 1.106.441 1.783.441.44 0 .838-.062 1.193-.185.36-.128.67-.317.93-.568.26-.256.462-.573.604-.952l1.62.455a3.584 3.584 0 01-.86 1.448c-.402.412-.9.734-1.491.966-.592.228-1.257.341-1.996.341zm11.499 0c-1.023 0-1.904-.241-2.643-.724-.738-.483-1.306-1.148-1.704-1.996-.398-.847-.597-1.816-.597-2.905 0-1.108.204-2.085.611-2.933.412-.852.985-1.517 1.719-1.996.739-.483 1.6-.724 2.585-.724.767 0 1.458.142 2.074.426.616.284 1.12.682 1.513 1.193.393.512.637 1.108.731 1.79h-1.676c-.128-.497-.412-.938-.852-1.321-.436-.388-1.023-.582-1.761-.582-.654 0-1.227.17-1.72.511-.487.336-.868.812-1.143 1.427-.27.611-.405 1.329-.405 2.152 0 .843.133 1.577.398 2.202.27.625.649 1.11 1.136 1.456.493.346 1.07.519 1.734.519.435 0 .83-.076 1.186-.228a2.44 2.44 0 00.902-.653c.246-.284.421-.625.525-1.023h1.676a3.883 3.883 0 01-.703 1.74c-.37.512-.86.919-1.47 1.222-.606.298-1.312.447-2.117.447zm11.171 0c-.984 0-1.849-.234-2.592-.703-.739-.469-1.316-1.124-1.733-1.967-.412-.843-.618-1.828-.618-2.955 0-1.136.206-2.128.618-2.976.417-.847.994-1.505 1.733-1.974.743-.469 1.608-.703 2.592-.703.985 0 1.847.234 2.586.703.743.469 1.32 1.127 1.733 1.974.416.848.625 1.84.625 2.976 0 1.127-.209 2.112-.625 2.955-.412.843-.99 1.498-1.733 1.967-.739.469-1.6.703-2.586.703zm0-1.505c.749 0 1.364-.192 1.847-.576.483-.383.84-.887 1.072-1.512a5.797 5.797 0 00.348-2.032 5.85 5.85 0 00-.348-2.038c-.232-.63-.59-1.139-1.072-1.527-.483-.388-1.099-.582-1.847-.582s-1.363.194-1.846.582c-.483.388-.84.897-1.073 1.527a5.85 5.85 0 00-.348 2.038c0 .729.116 1.407.348 2.032.232.625.59 1.129 1.073 1.512.483.384 1.098.576 1.846.576zM98.573 152v-10.909h1.619v1.648h.114c.199-.54.559-.978 1.08-1.314a3.177 3.177 0 011.761-.505c.123 0 .277.003.462.008.184.004.324.011.419.021v1.704a5.397 5.397 0 00-.391-.064 3.858 3.858 0 00-.632-.049 2.96 2.96 0 00-1.42.334c-.412.217-.739.52-.981.909a2.454 2.454 0 00-.355 1.314V152h-1.676zm11.229.227c-.909 0-1.712-.229-2.408-.689-.696-.464-1.24-1.117-1.633-1.96-.393-.847-.59-1.849-.59-3.004 0-1.146.197-2.14.59-2.983.393-.843.94-1.494 1.64-1.953.701-.459 1.511-.689 2.429-.689.71 0 1.272.118 1.683.355.417.232.734.497.952.795.223.294.396.535.519.725h.142v-5.369h1.676V152h-1.619v-1.676h-.199c-.123.199-.299.45-.526.753-.227.298-.552.566-.973.802-.421.232-.982.348-1.683.348zm.227-1.505c.672 0 1.241-.176 1.705-.526.464-.355.816-.845 1.058-1.47.241-.63.362-1.357.362-2.181 0-.814-.118-1.527-.355-2.137-.237-.616-.587-1.094-1.051-1.435-.464-.346-1.037-.518-1.719-.518-.71 0-1.302.182-1.775.546-.469.36-.822.85-1.059 1.471-.232.615-.348 1.306-.348 2.073 0 .777.119 1.482.355 2.117.242.63.597 1.132 1.066 1.506.473.369 1.06.554 1.761.554zm15.803-7.188l-1.506.426a2.78 2.78 0 00-.419-.731 2.025 2.025 0 00-.739-.597c-.312-.156-.712-.234-1.2-.234-.668 0-1.224.154-1.669.461-.44.303-.661.689-.661 1.158 0 .417.152.746.455.987.303.242.777.443 1.42.604l1.62.398c.975.236 1.702.599 2.18 1.086.478.483.718 1.106.718 1.868 0 .625-.18 1.184-.54 1.676-.355.493-.853.881-1.492 1.165-.639.284-1.382.426-2.23.426-1.113 0-2.033-.241-2.763-.724-.729-.483-1.19-1.189-1.385-2.117l1.591-.397c.152.587.438 1.027.86 1.321.426.293.982.44 1.669.44.781 0 1.401-.166 1.861-.497.464-.336.696-.739.696-1.208 0-.378-.133-.696-.398-.951-.265-.261-.672-.455-1.222-.583l-1.818-.426c-.999-.237-1.733-.603-2.202-1.101-.464-.502-.696-1.129-.696-1.882 0-.615.173-1.16.519-1.633.35-.474.826-.845 1.427-1.115.606-.27 1.293-.405 2.06-.405 1.08 0 1.927.237 2.543.71a3.839 3.839 0 011.321 1.875zm8.574 8.466v-14.545h8.721v1.562h-6.96v4.915h6.307v1.562h-6.307V152h-1.761zm15.142.227c-.985 0-1.849-.234-2.592-.703-.739-.469-1.317-1.124-1.733-1.967-.412-.843-.618-1.828-.618-2.955 0-1.136.206-2.128.618-2.976.416-.847.994-1.505 1.733-1.974.743-.469 1.607-.703 2.592-.703.985 0 1.847.234 2.585.703.744.469 1.321 1.127 1.733 1.974.417.848.625 1.84.625 2.976 0 1.127-.208 2.112-.625 2.955-.412.843-.989 1.498-1.733 1.967-.738.469-1.6.703-2.585.703zm0-1.505c.748 0 1.364-.192 1.847-.576.482-.383.84-.887 1.072-1.512a5.797 5.797 0 00.348-2.032 5.85 5.85 0 00-.348-2.038 3.44 3.44 0 00-1.072-1.527c-.483-.388-1.099-.582-1.847-.582s-1.364.194-1.847.582c-.483.388-.84.897-1.072 1.527a5.85 5.85 0 00-.348 2.038c0 .729.116 1.407.348 2.032.232.625.589 1.129 1.072 1.512.483.384 1.099.576 1.847.576zm14.377-3.182v-6.449h1.676V152h-1.676v-1.847h-.114a3.58 3.58 0 01-1.193 1.414c-.54.383-1.222.575-2.046.575-.681 0-1.287-.149-1.818-.447-.53-.303-.947-.758-1.25-1.364-.303-.611-.454-1.38-.454-2.308v-6.932h1.676v6.818c0 .796.222 1.43.667 1.903.45.474 1.023.711 1.719.711.417 0 .841-.107 1.272-.32.435-.213.8-.54 1.093-.98.299-.44.448-1.001.448-1.683zm6.422-2.102V152h-1.676v-10.909h1.619v1.704h.142a3.115 3.115 0 011.165-1.335c.521-.341 1.193-.511 2.017-.511.739 0 1.385.151 1.939.454.554.299.985.753 1.293 1.364.307.606.461 1.373.461 2.301V152h-1.676v-6.818c0-.857-.223-1.525-.668-2.003-.445-.483-1.055-.724-1.832-.724-.535 0-1.013.116-1.435.348-.416.232-.745.57-.987 1.015-.241.445-.362.985-.362 1.62zm14.142 6.789c-.909 0-1.711-.229-2.407-.689-.696-.464-1.241-1.117-1.634-1.96-.393-.847-.589-1.849-.589-3.004 0-1.146.196-2.14.589-2.983.393-.843.94-1.494 1.641-1.953.701-.459 1.51-.689 2.429-.689.71 0 1.271.118 1.683.355.417.232.734.497.952.795.222.294.395.535.518.725h.142v-5.369h1.676V152h-1.619v-1.676h-.199c-.123.199-.298.45-.525.753-.228.298-.552.566-.973.802-.422.232-.983.348-1.684.348zm.228-1.505c.672 0 1.24-.176 1.704-.526.464-.355.817-.845 1.058-1.47.242-.63.363-1.357.363-2.181 0-.814-.119-1.527-.355-2.137-.237-.616-.588-1.094-1.052-1.435-.464-.346-1.037-.518-1.718-.518-.711 0-1.302.182-1.776.546-.469.36-.821.85-1.058 1.471-.232.615-.348 1.306-.348 2.073 0 .777.118 1.482.355 2.117.241.63.597 1.132 1.065 1.506.474.369 1.061.554 1.762.554zm10.291-13.267l-.142 10.454h-1.648l-.142-10.454h1.932zm-.966 14.659c-.35 0-.651-.126-.902-.377a1.23 1.23 0 01-.377-.902c0-.35.126-.651.377-.902a1.23 1.23 0 01.902-.376c.35 0 .651.125.902.376s.376.552.376.902c0 .232-.059.445-.177.639a1.322 1.322 0 01-.462.469 1.213 1.213 0 01-.639.171z"
      ></path>
      <defs>
        <clipPath id="clip0_3266_166487">
          <path
            fill="#fff"
            d="M0 0H100.065V83.311H0z"
            transform="translate(60.435 13.893)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}

export function EditSquare() {
  return (
    <svg
      width="54"
      height="54"
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="0.5"
        width="53"
        height="53"
        rx="12.5"
        fill="white"
        stroke="#F5F1FE"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M30.8787 17.8787L22.2929 26.4645C22.1054 26.652 22 26.9064 22 27.1716V31.1716C22 31.7239 22.4477 32.1716 23 32.1716H27C27.2652 32.1716 27.5196 32.0662 27.7071 31.8787L36.2929 23.2929C37.4645 22.1213 37.4645 20.2218 36.2929 19.0503L35.1213 17.8787C33.9497 16.7071 32.0503 16.7071 30.8787 17.8787ZM34.8787 20.4645L34.9619 20.5587C35.2669 20.951 35.2392 21.5182 34.8787 21.8787L26.584 30.1716H24V27.5856L32.2929 19.2929C32.6834 18.9024 33.3166 18.9024 33.7071 19.2929L34.8787 20.4645ZM26.0308 19.1716C26.0308 18.6193 25.5831 18.1716 25.0308 18.1716H21L20.7831 18.1762C18.1223 18.2898 16 20.4828 16 23.1716V33.1716L16.0046 33.3885C16.1182 36.0493 18.3112 38.1716 21 38.1716H31L31.2169 38.167C33.8777 38.0534 36 35.8603 36 33.1716V28.2533L35.9933 28.1366C35.9355 27.6393 35.5128 27.2533 35 27.2533C34.4477 27.2533 34 27.701 34 28.2533V33.1716L33.9949 33.3478C33.9037 34.9227 32.5977 36.1716 31 36.1716H21L20.8237 36.1665C19.2489 36.0752 18 34.7693 18 33.1716V23.1716L18.0051 22.9953C18.0963 21.4205 19.4023 20.1716 21 20.1716H25.0308L25.1474 20.1648C25.6448 20.1071 26.0308 19.6844 26.0308 19.1716Z"
        fill="#363636"
      />
    </svg>
  );
}

export function UserIcon() {
  return (
    <svg
      width="4"
      height="14"
      viewBox="0 0 4 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="1.55556" cy="6.99989" r="1.55556" fill="#899CA8" />
      <circle cx="1.55556" cy="1.55556" r="1.55556" fill="#899CA8" />
      <circle cx="1.55556" cy="12.4442" r="1.55556" fill="#899CA8" />
    </svg>
  );
}

export function InputDropdown() {
  return (
    <svg
      width="11"
      height="6"
      viewBox="0 0 11 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.3615 0.292861C10.5453 0.465054 10.6557 0.694154 10.672 0.93718C10.6883 1.18021 10.6094 1.42046 10.4501 1.61286L10.3615 1.70686L6.09121 5.70686C5.90739 5.87904 5.66281 5.98247 5.40336 5.99775C5.14391 6.01303 4.88743 5.93911 4.68203 5.78986L4.58167 5.70686L0.311404 1.70686C0.119938 1.5269 0.00877641 1.28543 0.000497855 1.03148C-0.0077807 0.777528 0.0874441 0.530148 0.266831 0.339583C0.446219 0.149017 0.696317 0.0295559 0.966329 0.00546227C1.23634 -0.0186313 1.50602 0.0544494 1.72059 0.209861L1.82094 0.292861L5.33644 3.58486L8.85194 0.292861C9.03577 0.120685 9.28035 0.0172534 9.5398 0.00197221C9.79924 -0.013309 10.0557 0.0606099 10.2611 0.209861L10.3615 0.292861Z"
        fill="#899CA8"
      />
    </svg>
  );
}

export function FAQs() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.16998 22.1094C7.42998 22.2494 7.72 22.3194 8 22.3194C8.34 22.3194 8.67997 22.2195 8.96997 22.0295L13.23 19.1894H17C20.44 19.1894 22.75 16.8794 22.75 13.4394V7.43945C22.75 3.99945 20.44 1.68945 17 1.68945H7C3.56 1.68945 1.25 3.99945 1.25 7.43945V13.4394C1.25 16.6194 3.23 18.8395 6.25 19.1495V20.5694C6.25 21.2094 6.59998 21.8094 7.16998 22.1094Z"
        fill="#899CA8"
      />
      <path
        d="M11.9998 12.1094C11.5898 12.1094 11.2498 11.7694 11.2498 11.3594V11.1494C11.2498 9.98941 12.0998 9.4194 12.4198 9.1994C12.7898 8.9494 12.9098 8.77941 12.9098 8.51941C12.9098 8.01941 12.4998 7.60938 11.9998 7.60938C11.4998 7.60938 11.0898 8.01941 11.0898 8.51941C11.0898 8.92941 10.7498 9.26941 10.3398 9.26941C9.92984 9.26941 9.58984 8.92941 9.58984 8.51941C9.58984 7.18941 10.6698 6.10938 11.9998 6.10938C13.3298 6.10938 14.4098 7.18941 14.4098 8.51941C14.4098 9.65941 13.5698 10.2294 13.2598 10.4394C12.8698 10.6994 12.7498 10.8694 12.7498 11.1494V11.3594C12.7498 11.7794 12.4098 12.1094 11.9998 12.1094Z"
        fill="white"
      />
      <path
        d="M12 14.5996C11.58 14.5996 11.25 14.2596 11.25 13.8496C11.25 13.4396 11.59 13.0996 12 13.0996C12.41 13.0996 12.75 13.4396 12.75 13.8496C12.75 14.2596 12.42 14.5996 12 14.5996Z"
        fill="white"
      />
    </svg>
  );
}

export function DeleteBin() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M21 6H3V9C4.10457 9 5 9.89543 5 11V15C5 17.8284 5 19.2426 5.87868 20.1213C6.75736 21 8.17157 21 11 21H13C15.8284 21 17.2426 21 18.1213 20.1213C19 19.2426 19 17.8284 19 15V11C19 9.89543 19.8954 9 21 9V6ZM10.5 11C10.5 10.4477 10.0523 10 9.5 10C8.94772 10 8.5 10.4477 8.5 11V16C8.5 16.5523 8.94772 17 9.5 17C10.0523 17 10.5 16.5523 10.5 16V11ZM15.5 11C15.5 10.4477 15.0523 10 14.5 10C13.9477 10 13.5 10.4477 13.5 11V16C13.5 16.5523 13.9477 17 14.5 17C15.0523 17 15.5 16.5523 15.5 16V11Z"
        fill="#FF5A4E"
      />
      <path
        d="M10.0681 3.37059C10.1821 3.26427 10.4332 3.17033 10.7825 3.10332C11.1318 3.03632 11.5597 3 12 3C12.4403 3 12.8682 3.03632 13.2175 3.10332C13.5668 3.17033 13.8179 3.26427 13.9319 3.37059"
        stroke="#FF5A4E"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  );
}

export function VerticalDot() {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10Z"
        fill="#707581"
      />
      <path
        d="M4 10C5.10457 10 6 10.8954 6 12C6 13.1046 5.10457 14 4 14C2.89543 14 2 13.1046 2 12C2 10.8954 2.89543 10 4 10Z"
        fill="#707581"
      />
      <path
        d="M20 10C21.1046 10 22 10.8954 22 12C22 13.1046 21.1046 14 20 14C18.8954 14 18 13.1046 18 12C18 10.8954 18.8954 10 20 10Z"
        fill="#707581"
      />
    </svg>
  );
}

export function BluePlusIcon() {
  return (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.99327 0.883379C7.93551 0.38604 7.51284 0 7 0C6.44772 0 6 0.447715 6 1V6H1L0.883379 6.00673C0.38604 6.06449 0 6.48716 0 7C0 7.55228 0.447715 8 1 8H6V13L6.00673 13.1166C6.06449 13.614 6.48716 14 7 14C7.55228 14 8 13.5523 8 13V8H13L13.1166 7.99327C13.614 7.93551 14 7.51284 14 7C14 6.44772 13.5523 6 13 6H8V1L7.99327 0.883379Z"
        fill="#3B7AFE"
      />
    </svg>
  );
}

export function BluePinLoc() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="21" viewBox="0 0 16 21" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.875 5.4C6.01104 5.4 4.5 6.91104 4.5 8.775C4.5 10.639 6.01104 12.15 7.875 12.15C9.73896 12.15 11.25 10.639 11.25 8.775C11.25 6.91104 9.73896 5.4 7.875 5.4ZM5.85 8.775C5.85 7.65662 6.75662 6.75 7.875 6.75C8.99338 6.75 9.9 7.65662 9.9 8.775C9.9 9.89338 8.99338 10.8 7.875 10.8C6.75662 10.8 5.85 9.89338 5.85 8.775Z" fill="#3B7AFE" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.875 0C3.48 0 0 3.8185 0 8.42283C0 9.89948 0.733595 11.6383 1.65658 13.2701C2.5945 14.9283 3.79159 16.5836 4.84113 17.922L4.87614 17.9666C5.38842 18.62 5.82483 19.1765 6.24802 19.5609C6.70972 19.9803 7.21885 20.2549 7.875 20.2549C8.53115 20.2549 9.04028 19.9803 9.50198 19.5609C9.92517 19.1765 10.3616 18.6199 10.8739 17.9666L10.9089 17.922C11.9584 16.5836 13.1555 14.9283 14.0934 13.2701C15.0164 11.6383 15.75 9.89948 15.75 8.42283C15.75 3.8185 12.27 0 7.875 0ZM1.35 8.42283C1.35 4.46914 4.3171 1.35 7.875 1.35C11.4329 1.35 14.4 4.46914 14.4 8.42283C14.4 9.52667 13.8243 11.0037 12.9184 12.6054C12.0273 14.1807 10.8758 15.7764 9.84656 17.0889C9.28949 17.7993 8.92271 18.2633 8.59426 18.5617C8.29472 18.8338 8.09476 18.9049 7.875 18.9049C7.65524 18.9049 7.45528 18.8338 7.15574 18.5617C6.82729 18.2633 6.46051 17.7993 5.90344 17.0889C4.8742 15.7764 3.72265 14.1807 2.83163 12.6054C1.92566 11.0037 1.35 9.52667 1.35 8.42283Z" fill="#3B7AFE" />
    </svg>
  )
}

export function ThinArrowDown() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="9" viewBox="0 0 18 9" fill="none">
      <path d="M9.00002 8.79989C8.30002 8.79989 7.60002 8.52989 7.07002 7.99989L0.55002 1.47989C0.26002 1.18989 0.26002 0.709893 0.55002 0.419893C0.84002 0.129893 1.32002 0.129893 1.61002 0.419893L8.13002 6.93989C8.61002 7.41989 9.39002 7.41989 9.87002 6.93989L16.39 0.419893C16.68 0.129893 17.16 0.129893 17.45 0.419893C17.74 0.709893 17.74 1.18989 17.45 1.47989L10.93 7.99989C10.4 8.52989 9.70002 8.79989 9.00002 8.79989Z" fill="#899CA8" />
    </svg>
  )
}

export function TargetIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M12 20.25C7.45 20.25 3.75 16.55 3.75 12C3.75 7.45 7.45 3.75 12 3.75C16.55 3.75 20.25 7.45 20.25 12C20.25 16.55 16.55 20.25 12 20.25ZM12 5.25C8.28 5.25 5.25 8.28 5.25 12C5.25 15.72 8.28 18.75 12 18.75C15.72 18.75 18.75 15.72 18.75 12C18.75 8.28 15.72 5.25 12 5.25Z" fill="#3B7AFE" />
      <path d="M12 15.75C9.93 15.75 8.25 14.07 8.25 12C8.25 9.93 9.93 8.25 12 8.25C14.07 8.25 15.75 9.93 15.75 12C15.75 14.07 14.07 15.75 12 15.75ZM12 9.75C10.76 9.75 9.75 10.76 9.75 12C9.75 13.24 10.76 14.25 12 14.25C13.24 14.25 14.25 13.24 14.25 12C14.25 10.76 13.24 9.75 12 9.75Z" fill="#3B7AFE" />
      <path d="M12 4.75C11.59 4.75 11.25 4.41 11.25 4V2C11.25 1.59 11.59 1.25 12 1.25C12.41 1.25 12.75 1.59 12.75 2V4C12.75 4.41 12.41 4.75 12 4.75Z" fill="#3B7AFE" />
      <path d="M4 12.75H2C1.59 12.75 1.25 12.41 1.25 12C1.25 11.59 1.59 11.25 2 11.25H4C4.41 11.25 4.75 11.59 4.75 12C4.75 12.41 4.41 12.75 4 12.75Z" fill="#3B7AFE" />
      <path d="M12 22.75C11.59 22.75 11.25 22.41 11.25 22V20C11.25 19.59 11.59 19.25 12 19.25C12.41 19.25 12.75 19.59 12.75 20V22C12.75 22.41 12.41 22.75 12 22.75Z" fill="#3B7AFE" />
      <path d="M22 12.75H20C19.59 12.75 19.25 12.41 19.25 12C19.25 11.59 19.59 11.25 20 11.25H22C22.41 11.25 22.75 11.59 22.75 12C22.75 12.41 22.41 12.75 22 12.75Z" fill="#3B7AFE" />
    </svg>
  )
}


export const SettingIconBlack = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path d="M9.75 12C9.75 10.7574 10.7574 9.75002 12 9.75002C13.2426 9.75002 14.25 10.7574 14.25 12C14.25 13.2427 13.2426 14.25 12 14.25C10.7574 14.25 9.75 13.2427 9.75 12Z" fill="#363636" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M8.58523 3.2323C9.56564 -0.203083 14.4342 -0.203084 15.4147 3.2323C15.7184 4.2967 16.812 4.92806 17.8857 4.65893C21.351 3.7903 23.7853 8.00664 21.3004 10.5734C20.5305 11.3687 20.5305 12.6314 21.3004 13.4266C23.7853 15.9934 21.351 20.2097 17.8857 19.3411C16.812 19.072 15.7184 19.7033 15.4147 20.7677C14.4342 24.2031 9.56564 24.2031 8.58523 20.7677C8.28146 19.7033 7.18792 19.072 6.11423 19.3411C2.6489 20.2097 0.214599 15.9934 2.69952 13.4266C3.46944 12.6314 3.46944 11.3687 2.69952 10.5734C0.214599 8.00664 2.6489 3.7903 6.11423 4.65893C7.18792 4.92806 8.28146 4.2967 8.58523 3.2323ZM12 8.25002C9.92893 8.25002 8.25 9.92895 8.25 12C8.25 14.0711 9.92893 15.75 12 15.75C14.0711 15.75 15.75 14.0711 15.75 12C15.75 9.92895 14.0711 8.25002 12 8.25002Z" fill="#363636" />
    </svg>
  )
}

export const LogoutIconBlack = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7 11.25C6.58579 11.25 6.25 11.5858 6.25 12C6.25 12.4142 6.58579 12.75 7 12.75L15 12.75L15 15C15 15.929 15 16.3935 14.9384 16.7822C14.5996 18.9216 12.9216 20.5996 10.7822 20.9384C10.3935 21 9.929 21 9 21C8.07099 21 7.60649 21 7.21783 20.9384C5.07836 20.5996 3.40041 18.9216 3.06156 16.7822C3 16.3935 3 15.929 3 15L3 9C3 8.07099 3 7.60649 3.06156 7.21783C3.40042 5.07836 5.07837 3.40042 7.21783 3.06156C7.60649 3 8.07099 3 9 3C9.92901 3 10.3935 3 10.7822 3.06156C12.9216 3.40042 14.5996 5.07836 14.9384 7.21783C15 7.60649 15 8.07099 15 9L15 11.25L7 11.25ZM15 11.25L19.8105 11.25C19.483 10.9273 19.001 10.5437 18.297 9.98553L16.534 8.58768C16.2095 8.33034 16.155 7.8586 16.4123 7.53403C16.6697 7.20946 17.1414 7.15497 17.466 7.41232L19.2648 8.83857C19.9372 9.37175 20.4922 9.81172 20.8875 10.2055C21.2932 10.6096 21.6294 11.0582 21.7208 11.6313C21.7402 11.7534 21.75 11.8766 21.75 12C21.75 12.1234 21.7402 12.2466 21.7208 12.3687C21.6294 12.9418 21.2932 13.3904 20.8875 13.7945C20.4922 14.1883 19.9373 14.6282 19.2648 15.1614L17.466 16.5877C17.1414 16.845 16.6697 16.7905 16.4123 16.466C16.155 16.1414 16.2095 15.6697 16.534 15.4123L18.297 14.0145C19.001 13.4563 19.483 13.0727 19.8105 12.75L15 12.75L15 11.25Z" fill="#363636" />
    </svg>
  )
}